/* eslint-disable radix */
/* eslint-disable indent */
/* eslint-disable eqeqeq */
/* eslint-disable quotes */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable no-loop-func */
/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-vars */  // eslint-disable-next-line
/* eslint-disable no-danger */
/* eslint-disable no-else-return */
/* eslint-disable import/no-cycle */
/* eslint-disable object-shorthand */
/* eslint-disable import/namespace */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/newline-after-import */
/* eslint-disable  import/no-mutable-exports */
/* eslint-disable  no-multiple-empty-lines */
/* eslint-disable   prefer-const */
/* eslint-disable   prefer-template */

import React, { useState, useRef, useCallback, useEffect, createContext, useMemo } from 'react';
import { useOidc, useOidcIdToken } from '@axa-fr/react-oidc';
import { removeElements } from 'react-flow-renderer';
// Added 'reactflow' upgarded version 11 @sudarsana
import ReactFlow, {
  addEdge,
  Handle,
  ReactFlowProvider,
  Background,
  ControlButton,
  Controls,
  useNodesState,
  useEdgesState,
  MarkerType,
  useStoreApi,
  updateEdge,
  useReactFlow
} from 'reactflow';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { get, map, startsWith } from 'lodash';
import debounce from 'lodash/debounce';
import Modal from 'react-modal';
import { Box, Backdrop, CircularProgress, Switch, styled, Button, IconButton, Tooltip, Grid } from '@mui/material';
import HeightRoundedIcon from '@mui/icons-material/HeightRounded';
import localforage from 'localforage';
import $ from 'jquery';
import FeedInput from './feed-input/feed-analysis';
import RoInput from './ro-input';
import ArgoAnalyzer from './ArgoAnalyzer';
import NFInput from './nf-input';
import ReportWinflow from './report-winflow';
import SplitInput from './split-input';
import SaveFiles from './save-files';
import SpecifyFlow from './specify-flow';
import StripperInput from './stripper';
import PumpInput from './pump-input';
import HPumpInput from './hp-pump-input';
import DosingInput from './dosing-input';
import EDIInput from './edi-input';
import Options from './options';
import Views from './views';
import Explorer from './explorer';
import ExecutePopup from './execute';
import './validation.css';
import Sidebar from './Sidebar';
import './dnd.scss';
import './save.css';
import AnimeList from './AnimeList';
import File_Share from './file_sharing';
import SaveDialog from './SaveDialog';
import AlertDialog from './Alert_Dialog';
import CartridgeFilter from './cartridge-filter';
import Notification from '../shared/notification-modal';
import { checkFileExists, getUserListData, saveWinflowsFileContent, getWinflowsFileContent_units, getWinflowsFileContent, getWinflowsFileContent_preconfigFile, getWinflowsFileContent_FlowsheetWizard, dbTransaction, logWinFileChange, getWinflowsFileContent_folder, WinflowsFileManagmentAPI } from '../shared/api/url-helper';
import { getBorderColor, removeCrossIcon, decrypt_data, encrypt_data, downloadFlowSheetJSON } from '../shared/utils';
import { CustomEdge } from '../CustomEdge';
import EdgeIntersections from './EdgeIntersections';
import editIcon from '../images/fileIcon/editFile.svg';
import editIconColor from '../images/fileIcon/editFileColor.svg';
import new_Icon from '../images/fileIcon/newFile.svg';
import Balance_Icon from '../images/fileIcon/balance.svg';
import Checked_Icon from '../images/fileIcon/checked.svg';
import UnChecked_Icon from '../images/fileIcon/unchecked.svg';
import resetIcon from '../images/fileIcon/reset.svg';
import shareIcon from '../images/fileIcon/shareFile.svg';
import {
  settings, Feed, ProductOut, WasteOut, MixSplit, Pump, RO, Chemical_Dosing, CF_new, EDI,
  stripperImage, optionsIcon, openIconColor, newIconColor, openFileIcon,
  systemUnitsIconColor, optionsIconColor, resetIconColor, navigateIcon, closeIcon,
  project_info, icon_color_project_info, reportWarningImage, ERD, TC, PW, rectangle, pressureIcon, boostIcon, clroboostIcon, ArgoIcon,
  share_Icon_hover, save_Icon, save_hover, download_Icon, download_hover,
  share_Icon_disabled, share_Icon_hover_disabled, save_Icon_disabled, save_hover_disabled, download_Icon_disabled, download_hover_disabled, horizentalStripper
} from '../shared/assets/images';
import SystemUnits from './system-units';
import ProjectInfo, { getCurrentDate } from './project-info/ProjectInfo';
import WorkExchangerForm from './work-exchanger';
import PeltonWheelForm from './pelton-wheel';
import TurboChargerForm from './turbo-form';
import { defaultUnitValues, defaultModalOptions, executeDefault, defaultSetUnitsetdict, test_email, user1_email, user2_email, user3_email, user4_email, getCommonData } from '../shared/constantVariable';
import { removeItemsInLocalStorage } from '../shared/feed-common-feature';
import { checkExitsLocalStorageValue, removeLocalStorageValue, checkDuplicateValue, updateControlsButtonTitle, streamDataHighlited, streamDataInformation, isObjectEmpty, checkLocalStorageValue, uploadWinFiles, getEmailUserType } from '../shared/helper';
import { invalidConnection, handleValue, uniqueValue } from '../shared/api/invalidConnection';
import './flow-responsive.scss';
import { removeItemFromLocalStorage } from '../shared/removeElements';
import { ro_elem_access, ro_elem_shared_access } from './ro-input/ro-element-access';
import DownloadFlowsheet from './DownloadFlowsheet';
// pdfoption file imported ---->Kranthi
import PdfOptions from './pdf-options';
import MassBalance from './pdf-options/massBalance';
import StreamOverlayDrawerHeader from './stream-overlay/StreamOverlayDrawerHeader';
import {
  getMyAndSharedFile, setMyAndSharedFile, resetAbValFactCheckedDict, addInABFobj,   // for ab value reset dict.
  setHomeBtnClkFlag, getHomeBtnClkFlag, check_CLRO_access, getProjectInfoOpenFlag, setProjectInfoOpenFlag,
  setAfterSavingClick, setUserDictData,
  getUserDictData, set_curr_file_name,
  unSavedgetProjectInfoOpenFlag,
  unSavedsetProjectInfoOpenFlag
} from './userData';
import { uploadWin_4_File } from './recent_file_form/Form_RecentFileForm';
import Reportunitop from './report-winflow/reportunitop';
import { getMassBalanceAccess, getNFfeedAndCLROFrom, getArgoFromAccess } from '../shared/Products';
import 'reactflow/dist/style.css';   // Added CSS version 11 import statement @sudarsana
import jsLogger, { getLogs, clearLogs, JustclearLog } from '../logger';
import { saveWithChangeTracking } from './logWinFileDataChange';
import { getObjectDifferences } from './logWinFileDataChange1';

localStorage.setItem('globalExitBtn', 'false');
export const ExecuteContext = createContext();
// const id = 0;
let clro_all_unitop = [];
let roPump_all_unitops = [];
let checked_newButton = 0;
let checked_ResetButton = 0;
let wex_call_count = 0;

let node1 = [];
let wexpex_all_unitop = [];
let peltonwheel_all_unitop = [];
let turbocharger_all_unitop = [];
let c_feed = [];
let c_edi = [];
let c_ro = [];
let c_roPump = [];
const c_feedAA = [];
let c_pump_hp = [];
const c_feed_AA = [];
let c_product = [];
let streamNum_dict = {};
let c_wasteout = [];
let c_mixsplit = [];
let c_chemical_dosing = [];
let c_wex = [];
let c_pelton_wheel = [];
let c_Turbo_Charger = [];
let c_pump = [];
let c_box_RO_HP = [];
const c_box_Feed_AA = [];
let c_rectangle = [];
let c_boosterPump = [];
let cartridge_feed = [];
let c_stripper = [];
let default_pump_ro_connection = {};
let ro_connection = {};
let wexpex_connection = {};
let pump_connection = {};
let turbocharger_connection = {};
let peltonwheel_connection = {};
let mixSplit_connection = {};
let connectionInfo = {};
let connectionInfo_source_target = {};
let mixSplit_source = [];
let mixSplit_target = [];
let unitopdelete = [];
let id_feed = 1;
let id_edi = 1;
let id_ro = 1;
let id_roPump = 1;
let id_feedAA = 1;
let id_AA = 1;
let id_clro = 1;
let id_pelton_wheel = 1;
let id_Turbo_Charger = 1;
let id_productOut = 1;
let id_wasteOut = 1;
let id_mixSplit = 1;
let id_chemical_dosing = 1;
let id_wex_pex = 1;
let id_cartridge = 1;
let id_pump = 1;
let id_pump_hp = 1;
let id_box_RO_HP = 1;
let id_box_Feed_AA = 1;
let id_rectangle = 1;
let id_boosterPump = 1;
let id_stripper = 1;
let del_element_check = 0;
let isFileSaved = false;
let isRoPump = false;
let isNfPump = false;
let isclro = false;
let isWexPex = false;
let isPeltonWheel = false;
let isturbocharger = false;
// let animatedFlag = true;
// let fileSavedSuccess = false;
let preVal = {};
let preValFlag = true;
let turbochargeLength = false;
let executeOptionFlag = false;
let unitop_source = [];
let unitop_target = [];
let unitop_edge = [];
let edge_id_details = [];
let edge_details_SaveFiles = [];
const pelton_id_details = [];
const turbo_id_details = [];
const wexped_id_details = [];
// let disabledFlag = true;
let newFileFlag = false;
let duplicateNodeFlag = false;
let handleClickStr = '';
let streamInfoFlag = true;
let position1 = 0;
let position2 = 0;
let position3 = 0;
let position4 = 0;
let draggableStart = true;
let flagCalledLocalStorage = '';
let openProjectInfo = false;
let openPI_onNew_yes = false;
/**
 * Directly use the `sessionStorage.getItem('user_name')` instead of user_Name
 * added by chandrashekhar because when user login first time and and direclty
 * open any file and click share button after file sharing sharedby got blank
 * commented line const user_Name = sessionStorage.getItem('user_name');
 */
// const user_Name = sessionStorage.getItem('user_name');
let flagshareclick = false;
let flowPassData = '';
let error_details_info = [];
let groupFeeddAA = [];
// const Patharray_info = [];
let sourceYIncrement = 20;
const sourcePostion = '';
let increment = 5;
const connection_number = true;
const update_connection_number = true;
let updateconnectionInfoDelete = false;
let onClickElements = true;
// eslint-disable-next-line
let onSave_saveButton; // by Abhishek for saved file on exit on 03-Jan-2024
let autoRemoveFiles;
// eslint-disable-next-line
let updateconnectionsource = ''; // by sudarsana added for getting in update edge in connection issue
let itemToBePassIn_ro_elem_shared_access = ''; // by Abhishek on 28-3-24
let withoutDeletionDublicateTurbo = false; // by sudarsana added for two turbo charges are not allowed on same flowsheet
let withoutDeletionDublicatePeltonWheel = false; // by sudarsana added for two PW are not allowed on same flowsheet
let withoutDeletionDublicateERD = false; // by sudarsana added for two ERD are not allowed on same flowsheet
// let isClroPresent = false;
let curFnaam = '';
let cf_dict = {};
let isCfAdmin = false;
let withoutDuplicateWaterCompWithAA = false;
let textfile = '';
let fileDataWhenOpen = {};
// let timestamp = Date.now();
const formatDate = (timestamp) => {
  const d = new Date(timestamp);
  return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getFullYear()).slice(-2)}_${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
};
// GET WINDOW SCREEN WIDTH
function getScreenWidth() {
  const { innerWidth } = window;
  return innerWidth;
}
// GET WINDOW SCREEN HEIGHT
function getScreenHeight() {
  const { innerHeight } = window;
  return innerHeight;
}
// by Sudarsana for proximity connection
const Proximity = () => {
  const store = useStoreApi();
  const { nodeInternals } = store.getState();
  const storeNodes = Array.from(nodeInternals.values());
  localStorage.setItem('storeNodes', JSON.stringify(storeNodes));
  return (<div className="" style={{ display: 'none' }} />);
};
const MIN_DISTANCE = 250; // by Sudarsana for proximity connection
function Flow() {
  // GB-2259 chandrashekhar kumar added.
  const [ediOutputData, setEdiOutputData] = useState('');
  const initialTimestamp = useRef(formatDate(Date.now()));
  const [sourcePath, setSourcePath] = useState(null);  // custom folder
  const { t } = useTranslation();
  const { isAuthenticated } = useOidc();
  const [executefetchLoadings, setExecutefetchLoadings] = useState('');
  const [inputOutputFlag, setInputOutputFlag] = useState(false);
  const navigate = useNavigate();
  const executeEDIInfoData = useMemo(() => ({ data: {}, reportData: {}, flowSheetSolvdData: {} }), []);
  const [flowSheetImage, setFlowSheetImage] = useState('');
  const [executeDisabled, setExecuteDisabled] = useState(false);
  const [openMassBalanceOverlay, setOpenMassBalanceOverlay] = useState(false);
  const [openOption, setOpenOption] = useState(false);
  const [viewOption, setViewOption] = useState(false);
  const [isInteractive, setIsInteractive] = useState(true);
  const [explorerOption, setExplorerOption] = useState(false);
  const [showSessionAlert, setShowSessionAlert] = useState(true);
  const [, setState] = useState(null);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [deleteUnitop] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [dbTransactionDetails, setDbTransactionDetails] = useState({});
  const [state_loader, setState_loader] = useState({ showResults: false });
  const [edgeText, setEdgeText] = useState(0);
  const [, setClonedEdgeText] = useState(0);
  const [feedItem, setFeedItem] = useState({});
  const [width_canvas, setWidth_canvas] = useState(Number(getScreenWidth() - 210));
  const [height_canvas, setHeight_canvas] = useState(Number(getScreenHeight() - 150));
  const [unitopDetails, setUnitopDetails] = useState({});
  const [stripperDetails, setStripperDetails] = useState({});
  const [visibleStripper, setVisibleStripper] = useState(false);
  const [isHoveredShare, setIsHoveredShare] = useState(false);
  const [isHoveredSave, setIsHoveredSave] = useState(false);
  const [isHoveredDownload, setIsHoveredDownload] = useState(false);
  // notification modal
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  // system units
  const [visibleUnits, setVisibleUnits] = useState(false);
  // Show default units
  const [visibleDefaultUnits, setVisibleDefaultuints] = useState(false);
  // Project Info
  const [visiblePi, setVisiblePi] = useState(false);
  // work Exchanger
  const [visibleWorkExchanger, setVisibleWorkExchanger] = useState(false);
  const [workExchanger, setWorkExchanger] = useState({});
  // pelton Wheel
  const [visiblePeltonWheel, setVisiblePeltonWheel] = useState(false);
  const [pletonWheel, setPletonWheel] = useState({});
  // Turbo Chager
  const [visibleTurbo, setVisibleTurbo] = useState(false);
  const [turboChargeDetails, setturboChargeDetails] = useState({});
  // RO - input
  const [visibleRo, setVisibleRo] = useState(false);
  // NF - input
  const [visibleNF, setVisibleNF] = useState(false);
  const [roDetails, setRoDetails] = useState({});
  // Split - input
  const [visibleSplit, setVisibleSplit] = useState(false);
  const [visibleSaveFiles, setVisibleSaveFiles] = useState(false);
  const [visiblePump, setVisiblePump] = useState(false);
  const [visibleDosing, setVisibleDosing] = useState(false);
  const [visibleEDI, setVisibleEDI] = useState(false);
  const [okbuttonFormAutoSave, setokbuttonFormAutoSave] = useState(false);
  const [, setVisibleWexPex] = useState(false);
  const [visibleHpPump, setVisibleHpPump] = useState(false);
  const [splitDetails, setSplitDetails] = useState({});
  const [pumpDetails, setPumpDetails] = useState({});
  const [dosingDetails, setDosingDetails] = useState({});
  const [ediDetails, setEDIDetails] = useState({});
  const [localData_mixSplit, setlocalData_mixSplit] = useState({});
  const [, setWexPexDetails] = useState({});
  const [splitObjData, setSplitObjData] = useState([]);
  // Specify Flow
  const [visibleSpecifyFlow, setVisibleSpecifyFlow] = useState(false);
  // Model Dialog
  const [visibleFeed, setVisibleFeed] = useState(false);
  // const [autoSaveFeedForm, setAutoSavedFeedForm] = useState(false);
  // const [visiableFeedWithAA, setVisiableFeedWithAA] = useState(false);
  const [visiableAAWithFeed, setVisiableAAWithFeed] = useState(false);
  const [argoDetails, setArgoDetails] = useState({});
  // const classes = useStyles();
  const [isEdit, setIsEdit] = useState(false);
  const [text, setText] = useState('');
  const [clonedText, setClonedText] = useState(decodeURIComponent(text));
  const oldText = useRef('');
  const [, setFeedItemName] = useState('');
  const [, setFeedForAA] = useState('');
  const [, AATextwithFeed] = useState('');
  const [, setROItemName] = useState('');
  const [, setRoPumpItemName] = useState('');
  const [, setPumpItemName] = useState('');
  const [, setHP_PumpItemName] = useState('');
  const [, setEDIItemName] = useState('');
  const [, setProductItemName] = useState('');
  const [, setWasteOutItemName] = useState('');
  const [, setMixSplitItemName] = useState('');
  const [, setCartridgeItemName] = useState('');
  const [, setStripperName] = useState('');
  const [, setChemicalDosingItemName] = useState('');
  const [, setwexpexItemName] = useState('');
  // Errors active index value infomation
  const [activeIndexVal, setActiveIndexVal] = useState(0);
  // Model Dialog - alert dialog
  const [modalIsOpen_alert, setModalIsOpen_alert] = useState(false);
  // Model Dialog - file handling
  const [modalIsOpen_filehandle, setModalIsOpen_filehandle] = useState(false);
  // Model Dialog - save Dialog
  const [modalIsOpen_saveDialog, setModalIsOpen_saveDialog] = useState(false);
  // Model Dialog - Reset Dialog
  const [, setModalIsOpen_reset] = useState(false);
  // Model Dialog - New file Dialog
  const [visibleCF, setVisibleCF] = useState(false);
  const [splitterColor, setSplitterColor] = useState('red');
  // const flowKey = 'example-flow';
  const reactFlowWrapper = useRef(null);
  const inputFile = useRef(null);
  const [rfInstance, setRfInstance] = useState(null);
  const [, setCountInstance] = useState(null);
  // File Sharing
  const [visible_fileSharing, setVisible_fileSharing] = useState(false);
  const [visiableError, setVisiableError] = useState(false);
  const [callExecuteFun, setCallExecuteFun] = useState(false);
  const [findAllConnection, setFindAllConnection] = useState(false);
  const [reportErrorListData, setReportErrorListData] = useState('');
  // File Download
  const [fileDownload, setFileDownload] = useState('');
  const [, setFileDownloadName] = useState('');
  // RO shared
  const [isElementModelAccess, setIsElementModelAccess] = useState(false);
  const [executeObj, setExecuteObj] = useState(executeDefault);
  const [streamInfoData, setStreamInfoData] = useState(executeDefault);
  const [saveTrigger, setSaveTrigger] = useState(true);
  const [unSavedFile, setUnSavedFile] = useState(true);
  const buttonElement = useRef([]);
  const projectInfo = useRef([]);
  const focusElement = useRef();
  const stramInfoElement = useRef('');
  let ro_payloadData = {};
  let ro_dictData = {};
  // Stream-overlay
  const [openStremOverlay, setOpenStremOverlay] = useState(false);
  // Admin Options
  const [adminBtnTxt, setAdminBtnTxt] = useState('Admin');
  // CLRO Access
  const [clroAccess, setClroAccess] = useState(false);
  // Automate Stream
  const [checked, setChecked] = useState(localStorage.getItem('autoStremId') || false);
  const dragdrop = useRef(false);
  // OIDC Authentication
  const { idTokenPayload } = useOidcIdToken();
  if (isAuthenticated) {
    if ((idTokenPayload === null || idTokenPayload === undefined)) {
      clearLogs();
      window.location.href = '/sign-in';
    }
  }
  // @sudarsana added variables for access of options button only specific user
  let mail_ID = '';
  if (isAuthenticated) {
    mail_ID = idTokenPayload.sub;
    if (mail_ID === test_email && (process.env.REACT_APP_ENV === 'dev')) {
      mail_ID = user1_email;
    }
  }
  const getUserEmail = sessionStorage.getItem('user_email');
  const userMail_ID_Access_Env = [user1_email, user2_email, user3_email, user4_email];
  let getUserType = '';
  if (getUserEmail) {
    getUserType = getUserEmail.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
  }
  // adding to anchor to pdf button --->Kranthi
  const [pdfAnchorEl, setPdfAnchorEl] = React.useState(null);
  const [massBalanceAnchorEl, setMassBalanceAnchorEl] = React.useState(null);
  const MassBalanceOpen = Boolean(massBalanceAnchorEl);
  const pdfOpen = Boolean(pdfAnchorEl);
  const systemRecoveryValue = localStorage.getItem('systemRecovery') || 'NA';

  const [isConvasEmpty, setConvasEmpty] = useState(true);
  const [trigger, setTrigger] = useState(false);

  // Function to force the useEffect to run
  const forceUpdate = () => {
    setTrigger(prev => !prev); // Toggle the state to force re-render
  };
  const toggleInteractivity = () => {
    setIsInteractive((prev) => !prev);
  };
  // project is empty then we are using this info to reright the project info array
  // Project info static details
  const [contactInfo] = useState({
    project_name: '',
    location: '',
    engineer: sessionStorage.getItem('user_name'),
    email: sessionStorage.getItem('user_email'),
    contact_no: '',

    filename: '',
    created_on: '',
    last_edited_on: '',
    createdby: sessionStorage.getItem('user_name'),
    sharedby: '',
    isRead: ''
  });

  // This function will check if canvas is empty or not, if empty is set the state to true else false
  const convasEmptyFun = () => {
    setTimeout(() => {
      const flowNodes = document.querySelector('.react-flow__node');
      if (flowNodes) {
        setConvasEmpty(false);
      } else {
        setConvasEmpty(true);
      }
    }, 100);
  };

  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => closeModelOption(),
      type
    });
  };
  // When use click on stream data, explorer tab call this function
  const openPopup = (str) => {
    if (str === 'View' && localStorage.getItem('stream_ouput_data') && localStorage.getItem('unit_set_dict')) {
      setViewOption(true);
    } else if (str === 'Explorer' && localStorage.getItem('ro_ouput_data') && localStorage.getItem('unit_set_dict')) {
      const ro_ouput_data = JSON.parse(localStorage.getItem('ro_ouput_data')) || {};
      const dataRoType = Object.values(ro_ouput_data).filter((ele) => {
        return (['RO_HP', 'RO', 'RO_ERD', 'RO_PW', 'RO_TC', 'CLRO'].indexOf(ele.unit_type) >= 0);
      });
      if (dataRoType.length) {
        setExplorerOption(true);
      } else {
        openModelPopUp('No Data Found', 'Warning', 'warning');
        return false;
      }
    }
    // commented by chandrashekhar because unused code.  6-May-2025 START
    // else {
    //   openModelPopUp('No Data Found', 'Warning', 'warning');
    //   axios({
    //     method: 'post',
    //     url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/fetch_s3_data',
    //     // url: `https://xkbpehmx1d.execute-api.us-east-1.amazonaws.com/dev/addwinflowfile?param1=${fs.name}.json&param2=${getUserEmail}`,
    //     headers: {},
    //     // data: {
    //     //   unit_op_dict_final,
    //     //   stream_input_dict_final,
    //     //   unit_set_dict,
    //     //   final_table_dict
    //     // },
    //   }).then(() => { }).catch(() => { });
    //   return false;
    // }
    // commented by chandrashekhar because unused code.  6-May-2025 END
  };
  const SessionExpTime = sessionStorage.getItem('expTime');
  let currTime = new Date().getTime().toString();
  currTime = currTime.substring(0, 10); // 1653312386

  if (parseInt(currTime, 10) >= parseInt(SessionExpTime, 10)) {
    removeItemFromLocalStorage();
    if (localStorage.getItem('db_version')) {
      localStorage.removeItem('db_version');
    }
    clearLogs();
    window.location.href = '/sign-in';
  };
  localforage.config({
    name: 'react-flow-docs',
    storeName: 'flows',
  });
  const ediOutputDataset = (data) => {
    setEdiOutputData(data);
  };
  const initialElements = [];
  useEffect(async () => {
    const userMailId = sessionStorage.getItem('user_email');
    const getUnits = `units/${userMailId}`;
    // console.log(unSavedgetProjectInfoOpenFlag());
    setFetchLoading(true);
    removeLocalStorageValue();
    localStorage.setItem('globalExitBtn', 'false');
    setChecked(false);
    // Get default unit set from localStorage or set it to an empty string
    let response_final = JSON.parse(localStorage.getItem('default_unit_set_dict')) || {
      'Volume Flow': defaultUnitValues.flow,
      'Pressure': defaultUnitValues.pressure,
      'Temperature': defaultUnitValues.temp,
      'Liquid Volume': defaultUnitValues.volume,
      'Flux': defaultUnitValues.flux,
      'Power': defaultUnitValues.power,
      'type': defaultUnitValues.type
    };
    // If default unit set not found in localStorage
    if (!checkLocalStorageValue('default_unit_set_dict')) {
      // Fetch the default unit set from the server
      getWinflowsFileContent_units(getUnits).then((response) => {
        // Process response data
        if (response.data !== 'File does not exists') {
          if (response.data[0] !== '{' && response.data[0] !== undefined) {
            const res_data = response.data.split('"')[1];
            response_final = res_data ? decrypt_data(res_data) : decrypt_data(response.data);
          } else {
            response_final = JSON.parse(response.data);
          };
          if (!response_final.country || response_final.country === null || response_final.country === undefined) {
            if (!sessionStorage.getItem('geolocationPromptShown') || sessionStorage.getItem('geolocationPromptShown') === 'false') {
              sessionStorage.setItem('geolocationPromptShown', 'true');
            }
          } else {
            sessionStorage.setItem('country', response_final.country);
          }
          // Store default unit set in localStorage
          localStorage.setItem('default_unit_set_dict', JSON.stringify(response_final));
        } else if (!sessionStorage.getItem('geolocationPromptShown')) {
          sessionStorage.setItem('geolocationPromptShown', 'true');
        }
      })
        .catch(() => openModelPopUp(t('Failed to fetch Units'), 'Error', 'error'));
    }

    // Set timeout to execute after 1 second
    setTimeout(() => {
      // If system units not found in localStorage
      if (!checkLocalStorageValue('system-units')) {
        // Store default unit set and system units in localStorage
        localStorage.setItem('unit_set_dict', JSON.stringify(response_final));
        localStorage.setItem('system-units', JSON.stringify({
          temp: response_final.Temperature,
          pressure: response_final.Pressure,
          flow: response_final['Volume Flow'],
          flux: response_final.Flux,
          power: response_final.Power,
          volume: response_final['Liquid Volume'],
          type: response_final.type
        }));
      }
    }, 1000);
    Promise.all([dbTransaction()]).then((res) => {
      // @sudarsana here we removed the LocalStorage now, because when open any file after edting the text it is not getting lastest update
      localStorage.setItem('globalExitBtn', 'false');
      setChecked(false);
      setFetchLoading(false);
      if ((window.location.href).split('?').length === 1) { // eslint-disable-next-line
        itemToBePassIn_ro_elem_shared_access = itemToBePassIn_ro_elem_shared_access ? itemToBePassIn_ro_elem_shared_access : '';
        // when user upload any file from landin page.
        // i have set the localstorage value 'uploadwinfile'
        if (localStorage.getItem('uploadwinfile')) {
          const data = JSON.parse(localStorage.getItem('uploadwinfile'));
          localStorage.removeItem('uploadwinfile');
          setVisiblePi(false);
          fetchData(data.filename, data.flag, data.data);
          setVisibleDefaultuints(false);
          setFetchLoading(false);
        } else {
          setVisibleDefaultuints(true);
          // setVisiblePi(true);
        }
      }

      const decData = decrypt_data(res[0].data);
      res[0].data = decData;
      cf_dict = map(get(decData, 'cf_dict', {}), (val) => val); // decData.cf_dict;
      setDbTransactionDetails(decData);
      setUserDictData(decData.users_dict);
      const { users_dict, antiscalant_dict } = decData;
      localStorage.setItem('Active_DualequationCCPP', JSON.stringify(antiscalant_dict?.Active_DualequationCCPP || {}));
      const curr_user_email = sessionStorage.getItem('user_email');
      isCfAdmin = users_dict?.[curr_user_email]?.AccountType === 'WF5 Administrator' ?? false;

      localStorage.setItem('winflows_db_auth_dict', JSON.stringify(res[0].data.winflows_db_auth_dict)); // admin auth dict.
      localStorage.setItem('db_version', JSON.stringify(res[0].data.version_dict));
      ro_elem_access(res[0].data.elements_dict, res[0].data.users_dict); // ro_element_access
      const isElementModelAccess = ro_elem_shared_access(itemToBePassIn_ro_elem_shared_access);
      setIsElementModelAccess(!isElementModelAccess);

      updateControlsButtonTitle();
      localStorage.removeItem('streamDataHighlited');
      getUserListData();
      // if open any EDI flowsheet check stack model is present or not current user
      // if stack model is not present edi add the red boder getBorderColor(ele, 'add');
      if (localStorage.getItem('edi-dict')) {
        // define blank array edi_dict_stack_model
        const edi_dict_stack_model = [];
        const models = Object.values(decData.edi_dict);
        models.forEach((ele) => {
          // put value in edi_dict_stack_model if passcode is 0
          if (ele.PassCode === '0') {
            edi_dict_stack_model.push(ele.StackModel);
          }
        });
        const localdata = JSON.parse(localStorage.getItem('edi-dict'));
        if (localdata && localdata.EDI) {
          Object.keys(localdata.EDI).forEach((ele) => {
            // check the stack model in present or not in edi_dict_stack_model array
            // if value is not their add border color in edi unitop
            if (edi_dict_stack_model.indexOf(localdata.EDI[ele].model_type) === -1) {
              getBorderColor(ele, 'add');
            }
          });
        }
      }
      if (getProjectInfoOpenFlag()) {
        setVisiblePi(true);
        setIsElementModelAccess(false);
      } else {
        setVisiblePi(false);
      }
      setProjectInfoOpenFlag(false);

    }).catch(() => {
      setFetchLoading(false);
      updateControlsButtonTitle();
      openModelPopUp('Failed to fetch DB transaction record', 'Error', 'error');
      localStorage.setItem('globalExitBtn', 'false');
      setChecked(false);
    });
  }, [window.location.search, trigger]);
  useEffect(() => {
    resetVariable();
    removeItemFromLocalStorage();
    window.onbeforeunload = () => {
      const cf_keys = [];
      const cf_dict_final = JSON.parse(localStorage.getItem('cf-dict')) || {};
      removeItemFromLocalStorage();
      if (localStorage.getItem('db_version')) {
        localStorage.removeItem('db_version');
      }
      if (Object.keys(cf_dict_final).length > 0) {
        Object.entries(cf_dict_final.cf).forEach(([key]) => {
          cf_keys.push(key);
        });
        for (let i = 0; i < cf_keys.length; i++) {
          localStorage.removeItem(`${cf_keys[i]}-key`);
        }
      }
    };
    // setTimeout(() => {
    //   const flowNodes = document.querySelector('.react-flow__node');
    //   if(!flowNodes){
    //     setVisiblePi(true);
    //   }
    //   else{
    //     setVisiblePi(false);
    //   }
    // }, 4001);

    return () => {
      window.onbeforeunload = null;
    };
  }, []);
  // upgraded version 11 elements changes @sudarsana
  const [elements, setElements, onNodesChange] = useNodesState(initialElements);
  const initialEdges = [];
  // upgaraded version 11 Edge changes @sudarsana
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const { getViewport, setViewport, toObject } = useReactFlow();
  const saveTimerRef = useRef(null);
  // @sudarsana here this function regarding when user click on home button and if user click No button
  // then current file key should be removed from localStorage
  autoRemoveFiles = () => {
    const edges = rfInstance?.toObject()?.edges ?? [];
    const nodes = rfInstance?.toObject()?.nodes ?? [];
    // console.log('presentData', presentData);
    const flowData = [...edges, ...nodes];
    const flowDataIds = (flowData).map(el => el.id).sort().join(',');
    let savedFiles = JSON.parse(localStorage.getItem('savedFiles') || '[]');

    Object.keys(localStorage).forEach((key) => {
      const localValue = localStorage.getItem(key);
      if (!localValue) return;

      try {
        const localData = JSON.parse(localValue);
        const localIds = (localData.flow?.elements || []).map(el => el.id).sort().join(',');
        if (flowDataIds === localIds) {
          localStorage.removeItem(key);
          // console.log(`✅ Removed matching key: ${key}`);
          savedFiles = savedFiles.filter(fileName => fileName !== key);
        } else {
          // console.log(`❌ No match for key: ${key}`);
        }
      } catch (e) {
        // console.warn(`⚠️ Error parsing localStorage item for key: ${key}`, e);
      }
    });
    localStorage.setItem('savedFiles', JSON.stringify(savedFiles));
  };

  // ? Debounced auto-save
  const triggerAutoSave = useCallback(
    debounce(() => {
      // @sudarsana here entire code logic is copied from onSave file information becasue when autoSave need to trigger the variable name
      // let formData_ro = {};
      // let payloadData_ro = {};
      let formData_clro = {};
      let payloadData_clro = {};
      let unitSet_dict = {};
      let ABoptions = {};
      let formData_cf = {};
      let formData_pump = {};
      let formData_hppump = {};
      let formData_mixSplit = {};
      // let payloadData_feed = {};
      // let formData_feed = {};
      let product_flow_dict_val = {};
      let formData_stripper = {};
      let formData_dosing = {};
      let formData_edi = {};
      const element_color = {};
      let projectInfo_dict = {};
      let specifyFlow_data = {};
      let feed_flow_dict_val = {};
      let wex_dict = {};
      let pex_dict = {};
      let pelton_dict = {};
      let turbo_dict = {};
      const unittop_sneak_peak_view = {};

      const keys = ['feed-dict', 'ro-dict', 'dosing-dict', 'edi-dict', 'mixSplit-dict', 'cf-dict', 'hp-pump-dict', 'stripper-dict', 'pump-dict'];
      let forms = {};
      keys.forEach(key => {
        const value = localStorage.getItem(key);
        if (value) {
          try {
            forms[key] = JSON.parse(value);
          } catch (e) {
            console.error(`Error parsing localStorage item ${key}:`, e);
          }
        }
      });

      if (localStorage.getItem('clro-dict')) {
        formData_clro = get(JSON.parse(localStorage.getItem('clro-dict')), 'ro', {});
      }
      if (localStorage.getItem('clro_payload')) {
        payloadData_clro = get(JSON.parse(localStorage.getItem('clro_payload')), 'ro', {});
      }
      if (localStorage.getItem('dosing-dict')) {
        formData_dosing = get(JSON.parse(localStorage.getItem('dosing-dict')), 'Chemical_Dosing', {});
        unittop_sneak_peak_view.Chemical_Dosing = [];
        const getAllKey = Object.keys(formData_dosing);
        getAllKey.forEach((eleItem) => {
          unittop_sneak_peak_view.Chemical_Dosing.push(formData_dosing[eleItem].dosing_chemical);
        });
      }
      if (localStorage.getItem('edi-dict')) {
        formData_edi = get(JSON.parse(localStorage.getItem('edi-dict')), 'EDI', {});
        unittop_sneak_peak_view.EDI = [];
        const getAllKey = Object.keys(formData_edi);
        getAllKey.forEach((eleItem) => {
          unittop_sneak_peak_view.EDI.push(formData_edi[eleItem].model_type);
        });
      }
      if (localStorage.getItem('cf-dict')) {
        formData_cf = JSON.parse(localStorage.getItem('cf-dict'));
      }
      if (localStorage.getItem('pump-dict')) {
        formData_pump = JSON.parse(localStorage.getItem('pump-dict'));
      }
      if (localStorage.getItem('hp-pump-dict')) {
        formData_hppump = JSON.parse(localStorage.getItem('hp-pump-dict'));
      }
      if (localStorage.getItem('mixSplit-dict')) {
        formData_mixSplit = get(JSON.parse(localStorage.getItem('mixSplit-dict')), 'mixSplit', {});
      }
      if (localStorage.getItem('system-units')) {
        unitSet_dict = JSON.parse(localStorage.getItem('system-units'));
      }
      if (localStorage.getItem('options')) {
        ABoptions = JSON.parse(localStorage.getItem('options'));
      }
      if (localStorage.getItem('stripper-dict')) {
        formData_stripper = get(JSON.parse(localStorage.getItem('stripper-dict')), 'st', {});
        unittop_sneak_peak_view.Stripper = [];
        const getAllKey = Object.keys(formData_stripper);
        getAllKey.forEach((eleItem) => {
          if (formData_stripper[eleItem].stripper_flag) {
            if (formData_stripper[eleItem].target_co2 !== 0) {
              unittop_sneak_peak_view.Stripper.push('CO2');
            }
            if (formData_stripper[eleItem].target_h2s !== 0) {
              unittop_sneak_peak_view.Stripper.push('H2S');
            }
            if (formData_stripper[eleItem].target_nh3 !== 0) {
              unittop_sneak_peak_view.Stripper.push('NH3');
            }
          }
        });
      }
      if (localStorage.getItem('press_exc-dict')) {
        pex_dict = get(JSON.parse(localStorage.getItem('press_exc-dict')), 'press_exc', {});
      }
      if (localStorage.getItem('work_exc-dict')) {
        wex_dict = get(JSON.parse(localStorage.getItem('work_exc-dict')), 'work_exc', {});
        unittop_sneak_peak_view.ERD = [];
        const getAllKey = Object.keys(wex_dict);
        getAllKey.forEach((eleItem) => {
          unittop_sneak_peak_view.ERD.push(wex_dict[eleItem].erd_type == 'wex' ? 'Work Exchanger' : 'Pressure Exchanger');
        });
      }
      if (localStorage.getItem('pelton_wheel-dict')) {
        pelton_dict = get(JSON.parse(localStorage.getItem('pelton_wheel-dict')), 'pelton_exc', {});
        unittop_sneak_peak_view.ERD = [];
        const getAllKey = Object.keys(pelton_dict);
        getAllKey.forEach(() => {
          unittop_sneak_peak_view.ERD.push('Pelton Wheel');
        });
      }
      if (localStorage.getItem('turbo_charger-dict')) {
        turbo_dict = get(JSON.parse(localStorage.getItem('turbo_charger-dict')), 'TRD_data', {});
        unittop_sneak_peak_view.ERD = [];
        const getAllKey = Object.keys(turbo_dict);
        getAllKey.forEach(() => {
          unittop_sneak_peak_view.ERD.push('Turbocharger');
        });
      }

      if (localStorage.getItem('project_info')) {
        projectInfo_dict = JSON.parse(localStorage.getItem('project_info'));
        // ProjectInfo + Details on Save AS
        projectInfo_dict = {
          ...projectInfo_dict, filename: `${text}.json`, last_edited_on: getCurrentDate(),
          unittop_sneak_peak_view, flow_type: flowPassData
        };
        localStorage.setItem('project_info', JSON.stringify(projectInfo_dict));
      } else {
        // if file name is exist we are providing user to save that file and assign the project name as file name. --->kranthi
        // checking for file is existed or not --->kranthi
        if (text) {
          const locprojectInfo = {
            ...contactInfo, email: getUserEmail, project_name: (text).trim(), filename: `${text}.json`,
            created_on: getCurrentDate(), last_edited_on: getCurrentDate()
          };
          projectInfo_dict = locprojectInfo;
          localStorage.setItem('project_info', JSON.stringify(locprojectInfo));
        }
        // else {
        //   // if projectName is empty in projectInfo dict
        //   openModelPopUp('Please enter valid project name', 'Warning', 'warning');
        //   localStorage.setItem('Pinfo', 'empty');
        //   return;
        // }
      }
      if (localStorage.getItem('flow_dict')) {
        specifyFlow_data = JSON.parse(localStorage.getItem('flow_dict'));
      }

      if (localStorage.getItem('feed_flow_dict')) {
        feed_flow_dict_val = JSON.parse(localStorage.getItem('feed_flow_dict'));
      }

      if (localStorage.getItem('product_flow_dict')) {
        product_flow_dict_val = JSON.parse(localStorage.getItem('product_flow_dict'));
      }
      const flowData = { elements: [...elements, ...edges] };
      for (let i = 0; i < flowData.elements.length; i++) {
        if (flowData.elements[i].id && !flowData.elements[i].id.includes('reactflow__edge')) {
          flowData.elements[i].name = localStorage.getItem(flowData.elements[i].id);
          element_color[flowData.elements[i].id] = $(`.Node_${flowData.elements[i].id}`).parent().parent().css('border-left-color');
        }
      }
      const flow = {
        flow: { elements: [...elements, ...edges] }, // ? use your actual node state
        viewport: getViewport(),
        // forms: {
        // ...JSON.parse(localStorage.getItem('feed-dict')),
        // }
        formData_feed: JSON.parse(localStorage.getItem('form')),
        payloadData_feed: JSON.parse(localStorage.getItem('feed-dict')),
        formData_ro: get(JSON.parse(localStorage.getItem('ro-dict')), 'ro', {}),
        payloadData_ro: get(JSON.parse(localStorage.getItem('ro_payload')), 'ro', {}),
        formData_clro: formData_clro,
        payloadData_clro: payloadData_clro,
        formData_dosing: formData_dosing,
        formData_edi: formData_edi,
        formData_cf: formData_cf,
        formData_pump: formData_pump,
        formData_hppump: formData_hppump,
        formData_mixSplit: formData_mixSplit,
        unitSet_dict: unitSet_dict,
        ABoptions: ABoptions,
        formData_stripper: formData_stripper,
        pex_dict: pex_dict,
        wex_dict: wex_dict,
        pelton_dict: pelton_dict,
        turbo_dict: turbo_dict,
        element_color: element_color,
        unitop_source: unitop_source,
        unitop_target: unitop_target,
        projectInfo_dict: projectInfo_dict,
        specifyFlow_data: specifyFlow_data,
        feed_flow_dict_val: feed_flow_dict_val,
        product_flow_dict_val: product_flow_dict_val
      };
      // console.log('getvalues', text);

      // Create NEW filename with current timestamp
      // const newTimestamp = formatDate(Date.now());
      textfile = (text === '')
        ? `autoSave_${initialTimestamp.current}`
        : `${text}_autoSave_${initialTimestamp.current}`;

      // Get all saved files
      let savedFiles = JSON.parse(localStorage.getItem('savedFiles') || '[]');

      // Extract all timestamps from the new textfile
      const timestampPattern = /\d{2}-\d{2}-\d{2}_\d{2}:\d{2}:\d{2}/g;
      const newTimestamps = textfile.match(timestampPattern) || [];

      // Find old files that contain any of these timestamps
      const oldFiles = savedFiles.filter(file => {
        // Skip the current textfile itself
        if (file === textfile) return false;

        // Check if any timestamp from new file exists in old file
        return newTimestamps.some(timestamp => file.includes(timestamp));
      });

      // Remove ALL old autosave files from localStorage
      oldFiles.forEach(oldFile => {
        localStorage.removeItem(oldFile);
        // console.log('🗑️ Removed old autosave:', oldFile);
      });

      // Update savedFiles array - remove all old autosave files
      savedFiles = savedFiles.filter(file => !oldFiles.includes(file));
      // here need to get autoSaveFile Formate is with emptyName is only autoSave_HH-MM-SS
      let cleanedKey;
      if (textfile.startsWith('autoSave_')) {
        let lastIndex = textfile.lastIndexOf('autoSave');
        let timestamp = textfile.substring(lastIndex + 'autoSave'.length);
        // Remove leading underscore if present
        timestamp = timestamp.startsWith('_') ? timestamp.substring(1) : timestamp;
        cleanedKey = 'autoSave_' + timestamp;
      } else {
        let lastIndex = textfile.lastIndexOf('autoSave');
        cleanedKey = lastIndex !== -1
          ? textfile.substring(0, textfile.indexOf('autoSave')) + textfile.substring(lastIndex)
          : textfile;
      }
      if (!savedFiles.includes(cleanedKey)) {
        savedFiles.unshift(cleanedKey);
      }
      // Save new autosave and update savedFiles list
      if (flow.flow.elements.length > 0) {
        localStorage.setItem(cleanedKey, JSON.stringify(flow));
        localStorage.setItem('savedFiles', JSON.stringify(savedFiles));
      }
      // console.log('✅ Auto-saved flow:', textfile);
    }, 500),
    [elements, edges, getViewport]
  );

  // ? Save on node/edge changes and form filed triggerAutoSave @sudarsana
  useEffect(() => {
    if (localStorage.getItem('autoSaveStreamNumber')) {
      dragdrop.current = true;
      localStorage.removeItem('autoSaveStreamNumber');
      setTimeout(() => {
        dragdrop.current = false;
      });
    }
    if (dragdrop.current || okbuttonFormAutoSave) {
      triggerAutoSave();
    }
    if (okbuttonFormAutoSave) {
      setokbuttonFormAutoSave(false);
    }
    // here when we change the dependency this triggerAutoSave will exceuted
    // okbuttonFormAutoSave this is for if any Form open if you click ok button triggerAutoSave wiil executed
  }, [elements, edges, triggerAutoSave, okbuttonFormAutoSave, edgeText, visibleSpecifyFlow, checked]);

  // ? Restore saved flow on mount
  // useEffect(() => {
  //   const saved = localStorage.getItem('my-react-flow');
  //   if (saved) {
  //     const { nodes: savedNodes, edges: savedEdges, viewport } = JSON.parse(saved);
  //     const elements = [...savedNodes, ...savedEdges];
  //     console.log(elements);
  //     setElements(savedNodes || []);
  //     setEdges(savedEdges || []);
  //     if (viewport) setViewport(viewport);
  //   }
  // }, [setElements, setEdges, setViewport]);

  // upgarded version 11 connecting the edges @sudarsana
  const onConnectingNode = useCallback((params) => {
    setChecked(false);
    setEdges((eds) => addEdge(params, eds));
    localStorage.setItem('globalExitBtn', 'true');
  }, [setEdges]);
  // upgarded version 11 for Edgeupdate code changes @sudarsana
  const onEdgeUpdate = useCallback(
    (oldEdge, newConnection) => {
      // sudarsana fixed the bug GB:2885
      // Need to add this for bug fixing GB:3042 because when updating the edge faling connection validation
      if (Object.keys(connectionInfo).length === 0) {
        const edges = rfInstance?.toObject()?.edges ?? [];
        edges.forEach(edge => {
          if (!edge.source.includes('mixsplit')) {
            const sourceKey = edge.source + edge.sourceHandle;
            connectionInfo[sourceKey] = edge.sourceHandle;
          }
          if (!edge.target.includes('mixsplit')) {
            const targetKey = edge.target + edge.targetHandle;
            connectionInfo[targetKey] = edge.targetHandle;
          }
        });
      }
      if (oldEdge.targetHandle != 'a_bp' && oldEdge.targetHandle != 'a_w' && oldEdge.targetHandle != 'c_w' &&
        (wexpex_all_unitop.length === 0 || (wexpex_all_unitop.length >= 6 && wexpex_all_unitop[4].id != oldEdge.target && wexpex_all_unitop[1].id != oldEdge.target && wexpex_all_unitop[3].id != oldEdge.target)) &&
        (oldEdge.data.subnetwork != false) && // this is for RO-HP subnetwork
        (peltonwheel_all_unitop.length === 0 || (peltonwheel_all_unitop.length >= 5 && peltonwheel_all_unitop[2].id != oldEdge.target && peltonwheel_all_unitop[1].id != oldEdge.target)) &&
        (turbocharger_all_unitop.length === 0 || (turbocharger_all_unitop.length >= 4 && turbocharger_all_unitop[1].id != oldEdge.target && turbocharger_all_unitop[2].id != oldEdge.target))) {
        setEdges((edges) => {
          const updatedEdges = edges.map((item) => {
            if (item.data) {
              item.data.update_connection_number = false;
            }
            return item;
          });
          return updatedEdges;
        });

        if (connectionInfo[newConnection.target + newConnection.targetHandle] != newConnection.targetHandle || newConnection.target.replace(/[\d_]+/g, '') == 'mixsplit') {
          // @sudarsana invalidConnection in flexible edges in version 11
          let finaldata = false;
          if (newConnection.source === newConnection.target) {
            finaldata = true;
          } else {
            if (newConnection.source && newConnection.target) {
              let distanationarray = [];
              const source = newConnection.source.split('_')[0];
              let destination = newConnection.target.split('_')[0];
              // start -- @sudarsana bug fixing here invalidConnection in NF-HP unitop 'hppump' is same as RO-HP also
              //  to fix that bug we called rfInstance and get NF-HP unitop and applied the conditions
              //  console.log('rfinstanstce ', rfInstance?.toObject()?.edges ?? []);
              const edges = rfInstance?.toObject()?.edges ?? [];
              const filteredEdges = edges.filter(
                (values) => values.source.startsWith('hppump') && values.target.startsWith('nfPump')
              );
              if (filteredEdges.length > 0) {
                // console.log('filteredEdges', filteredEdges);
                distanationarray = filteredEdges.map((values) => values.source);
                destination = distanationarray.includes(newConnection.target) ? 'nfhppump' : newConnection.target.split('_')[0];
              }
              // end bug fixing
              for (let i = 0; i < invalidConnection.length; i++) {
                const ele = invalidConnection[i];
                if (uniqueValue[ele.source].indexOf(source) >= 0 && uniqueValue[ele.Destination].indexOf(destination) >= 0) {
                  const sourceHandle = handleValue[ele.sourcePort];
                  const targetHandle = handleValue[ele.targetPort];
                  if (sourceHandle === newConnection.sourceHandle && targetHandle === newConnection.targetHandle) {
                    finaldata = true;
                    if (ele.Msg) {
                      document.querySelector('#toatster-msg span').innerHTML = ele.Msg;
                      document.querySelector('#toatster-msg').style.display = 'block';
                      setTimeout(() => {
                        document.querySelector('#toatster-msg').style.display = 'none';
                        document.querySelector('#toatster-msg span').innerHTML = '';
                      }, 3000);
                    }
                    break;
                  }
                }
              }
            }
          }
          if (!finaldata) {
            setEdges((els) => updateEdge(oldEdge, newConnection, els));
          }
          delete connectionInfo[oldEdge.target + oldEdge.targetHandle];
          if (wexpex_all_unitop.length >= 6) {
            if (oldEdge.target === wexpex_all_unitop[0].id && wexpex_all_unitop[0].id.replace(/[\d_]+/g, '') === 'mixsplit') {
              delete connectionInfo_source_target[newConnection.source];
            }
          }
          connectionInfo[oldEdge.source + oldEdge.sourceHandle] = oldEdge.sourceHandle; // by Sudarsana for proximity connection
          // @sudarsana mixsplit validation condition  in flexiable edges in version 11
          if (newConnection.target.replace(/[\d_]+/g, '') !== 'mixsplit') {
            connectionInfo[newConnection.target + newConnection.targetHandle] = newConnection.targetHandle;
          }
          // @sudarsana added here for connection not working in update edge
          updateconnectionsource = newConnection.source + newConnection.sourceHandle;
          updateconnectionInfoDelete = true;
        }
      }
    }, [edges]); // required for bug fixing dependency
  const getClosestEdge = useCallback((node) => {
    let closestNode = {};
    // Need to add this for bug fixing GB:3042 because when updating the edge faling connection validation
    if (Object.keys(connectionInfo).length === 0) {
      const edges = rfInstance?.toObject()?.edges ?? [];
      edges.forEach(edge => {
        if (!edge.source.includes('mixsplit')) {
          const sourceKey = edge.source + edge.sourceHandle;
          connectionInfo[sourceKey] = edge.sourceHandle;
        }
        if (!edge.target.includes('mixsplit')) {
          const targetKey = edge.target + edge.targetHandle;
          connectionInfo[targetKey] = edge.targetHandle;
        }
      });
    }
    const storeNodes = JSON.parse(localStorage.getItem('storeNodes'));
    const groupROHPItem = storeNodes.find(item => item.id.startsWith('groupROHP_'));
    // const groupNFHPItem = storeNodes.find(item => item.id.startsWith('groupNFHP_'));
    let filterData = [];
    if (groupROHPItem) {
      const roPumpData = storeNodes.filter(innerItem => innerItem.id.startsWith('roPump') && !innerItem.id.match(/_\\d+$/));
      const hpPumpData = storeNodes.filter(innerItem => innerItem.id.startsWith('hppump') && !innerItem.id.match(/_\\d+$/));
      filterData = hpPumpData.concat(roPumpData);
    }
    // if (groupNFHPItem) {
    //   const roPumpData = storeNodes.filter(innerItem => innerItem.id.startsWith('nfPump') && !innerItem.id.match(/_\\d+$/));
    //   const hpPumpData = storeNodes.filter(innerItem => innerItem.id.startsWith('hppump') && !innerItem.id.match(/_\\d+$/));
    //   filterData = hpPumpData.concat(roPumpData);
    // }
    const getdatafilter = storeNodes.filter((item) => !item.id.startsWith('groupROHP_') && !item.id.startsWith('rectangle_'));
    // const getNFdatafilter = storeNodes.filter((item) => !item.id.startsWith('groupNFHP_') && !item.id.startsWith('rectangle_'));
    // condition for proximity connection for subnetwork
    if ((node.id).replace(/_\d+$/, '') === 'groupROHP') {
      filterData.forEach((node) => {
        closestNode = getdatafilter.reduce(
          (res, n) => {
            if (n.id !== node.id) {
              const dx = n.positionAbsolute.x - node.positionAbsolute.x;
              const dy = n.positionAbsolute.y - node.positionAbsolute.y;
              const d = Math.sqrt(dx * dx + dy * dy);
              if (d < res.distance && d < MIN_DISTANCE) {
                res.distance = d;
                res.node = n;
              }
            }
            return res;
          }, {
          distance: Number.MAX_VALUE,
          node: null,
        });
        if (!closestNode.node) {
          return null;
        }
        const closeNodeIsSource = closestNode.node.positionAbsolute.x < node.positionAbsolute.x;
        const source = closeNodeIsSource ? closestNode.node.id : node.id;
        const target = closeNodeIsSource ? node.id : closestNode.node.id;
        if ((wexpex_all_unitop.length > 0 && target === wexpex_all_unitop[0].id)) {
          return false;
        }
        if ((wexpex_all_unitop.length > 0 && source === wexpex_all_unitop[0].id)) {
          return false;
        }
        if ((wexpex_all_unitop.length > 0 && source === wexpex_all_unitop[1].id)) {
          return false;
        }
        // @sudarsana no need for proximity connection for mixsplit
        if ((source).replace(/_\d+$/, '') === 'mixsplit' || (target).replace(/_\d+$/, '') === 'mixsplit') {
          return false;
        }
        onConnect({ source: source, sourceHandle: 'c', target: target, targetHandle: 'a' });
      });
      // } else if ((node.id).replace(/_\d+$/, '') === 'groupNFHP') {
      //   filterData.forEach((node) => {
      //     closestNode = getNFdatafilter.reduce(
      //       (res, n) => {
      //         if (n.id !== node.id) {
      //           const dx = n.positionAbsolute.x - node.positionAbsolute.x;
      //           const dy = n.positionAbsolute.y - node.positionAbsolute.y;
      //           const d = Math.sqrt(dx * dx + dy * dy);
      //           if (d < res.distance && d < MIN_DISTANCE) {
      //             res.distance = d;
      //             res.node = n;
      //           }
      //         }
      //         return res;
      //       }, {
      //       distance: Number.MAX_VALUE,
      //       node: null,
      //     });
      //     if (!closestNode.node) {
      //       return null;
      //     }
      //     const closeNodeIsSource = closestNode.node.positionAbsolute.x < node.positionAbsolute.x;
      //     const source = closeNodeIsSource ? closestNode.node.id : node.id;
      //     const target = closeNodeIsSource ? node.id : closestNode.node.id;
      //     if ((wexpex_all_unitop.length > 0 && target === wexpex_all_unitop[0].id)) {
      //       return false;
      //     }
      //     if ((wexpex_all_unitop.length > 0 && source === wexpex_all_unitop[0].id)) {
      //       return false;
      //     }
      //     if ((wexpex_all_unitop.length > 0 && source === wexpex_all_unitop[1].id)) {
      //       return false;
      //     }
      //     // @sudarsana no need for proximity connection for mixsplit
      //     if ((source).replace(/_\d+$/, '') === 'mixsplit' || (target).replace(/_\d+$/, '') === 'mixsplit') {
      //       return false;
      //     }
      //     onConnect({ source: source, sourceHandle: 'c', target: target, targetHandle: 'a' });
      //   });
    } else {
      // @ sudarsana condtion for original proximity connection normal nodes
      let d = 0;
      closestNode = storeNodes.filter((item) => !item.id.startsWith('groupROHP_')).reduce(
        (res, n) => {
          if (n.id !== node.id) {
            const dx = n.positionAbsolute.x - node.positionAbsolute.x;
            const dy = n.positionAbsolute.y - node.positionAbsolute.y;
            d = Math.sqrt(dx * dx + dy * dy);
            if (d < res.distance && d < MIN_DISTANCE) {
              res.distance = d;
              res.node = n;
            }
          }
          return res;
        }, {
        distance: Number.MAX_VALUE,
        node: null,
      });
      if (!closestNode.node) {
        return null;
      }
      // by Sudarsana for proximity connection
      const closeNodeIsSource = closestNode.node.positionAbsolute.x < node.positionAbsolute.x;
      const sources = closeNodeIsSource ? closestNode.node.id : node.id;
      const target = closeNodeIsSource ? node.id : closestNode.node.id;
      let sourceHandle = 'd';
      if ((sources).replace(/_\d+$/, '') === 'TC' && turbocharger_all_unitop.length > 0) {
        sourceHandle = 'd_tc';
      } else if ((sources).replace(/_\d+$/, '') === 'wex' && wexpex_all_unitop.length > 0) {
        sourceHandle = 'd_w';
      } else if ((sources).replace(/_\d+$/, '') === 'peltonwheel' && peltonwheel_all_unitop.length > 0) {
        sourceHandle = 'd';
      } else if ((sources).replace(/_\d+$/, '') === 'roPump' && (target).replace(/_\d+$/, '') == 'wasteout') {
        sourceHandle = 'd';
      }
      if ((wexpex_all_unitop.length > 0 && target === wexpex_all_unitop[0].id)) {
        return false;
      }
      if ((wexpex_all_unitop.length > 0 && sources === wexpex_all_unitop[0].id)) {
        return false;
      }
      if ((wexpex_all_unitop.length > 0 && sources === wexpex_all_unitop[1].id)) {
        return false;
      }
      // @sudarsana no need for proximity connection for mixsplit
      if ((sources).replace(/_\d+$/, '') === 'mixsplit' || (target).replace(/_\d+$/, '') === 'mixsplit') {
        return false;
      }
      if (((sources).replace(/_\d+$/, '') == 'wasteout') || (sources).replace(/_\d+$/, '') == 'product' || (target).replace(/_\d+$/, '') == 'feed') {
        return false;
      } else if ((sources).replace(/_\d+$/, '') === 'TC' || (sources).replace(/_\d+$/, '') === 'wex' || (sources).replace(/_\d+$/, '') === 'peltonwheel'
        || (((sources).replace(/_\d+$/, '') === 'roPump' && (target).replace(/_\d+$/, '') == 'wasteout'))) {
        onConnect({ source: sources, sourceHandle: sourceHandle, target: target, targetHandle: 'a' });
      } else {
        onConnect({ source: sources, sourceHandle: 'c', target: target, targetHandle: 'a' });
      }
    }
  }, [edges]);

  const onNodeDrag = useCallback(
    (_, node) => {
      const mixspiltnode = node.id;
      const getmixsplitnode = mixspiltnode.replace(/_\d+$/, '');
      // @sudarsana Disable proximity connection feature for MixSplit unitop.
      if (getmixsplitnode != 'mixsplit') {
        const closeEdge = getClosestEdge(node);
        setEdges((es) => {
          const nextEdges = es.filter((e) => e.className !== 'temp');
          if (
            closeEdge &&
            !nextEdges.find(
              (ne) =>
                ne.source === closeEdge.source && ne.target === closeEdge.target,
            )
          ) {
            closeEdge.className = 'temp';
            nextEdges.push(closeEdge);
          }
          return nextEdges;
        });
        // Dispatch custom event so EdgeIntersections can recompute during drag
        window.dispatchEvent(new CustomEvent('rf-node-drag', { detail: { id: node.id, position: node.position } }));
      }
    },
    [getClosestEdge, setEdges],
  );

  // @shekhar add hover event on every stream connection  Start
  const addMouseHoverEvent = () => {
    // reactFlowEdges get the all stream connection in html document
    const reactFlowEdges = document.querySelectorAll('.react-flow__edges path.react-flow__edge-interaction');
    if (reactFlowEdges.length > 0) {
      reactFlowEdges.forEach((ele, ind) => {
        if (!ele.classList.contains('click-active')) {
          ele.classList.add('click-active');
          ele.addEventListener('mouseover', (event) => {
            // console.log(ele);
            // add stroke-width on mouse hover on stream conection
            const edgePath = ele.closest('g').querySelector('.react-flow__edge-path');
            edgePath.style.setProperty('stroke-width', '8', 'important');
            const stream_ouput_data = localStorage.getItem('stream_ouput_data');
            // `buttonElement.current[2] is' calculate button is disabled and stream_ouput_data value is null stream information is not visiable.
            if ((buttonElement.current[2].className.indexOf('disabled') < 0) && stream_ouput_data) {
              const streamno = ele.closest('.react-flow__viewport').querySelectorAll('.react-flow__edgelabel-renderer input')[ind].value;
              const finalStreamData = streamDataInformation(streamno);
              if (finalStreamData.length) {
                setStreamInfoData(finalStreamData);
                streamInfoFlag = false;
                const finalLeft = (event.clientX || event.pageX) + 20;
                let finalTop = (event.clientY || event.pageY) + 20;
                // if top grater than final top minus the height in final top by default add 200 height
                if (window.innerHeight < (finalTop + 165)) {
                  finalTop -= 200;
                }
                // set let and top stream info box
                stramInfoElement.current.style.left = `${(finalLeft - (275 / 2))}px`;
                stramInfoElement.current.style.top = `${finalTop}px`;
                stramInfoElement.current.style.display = 'block';
              }
            }
          });
          ele.addEventListener('mouseleave', () => {
            setTimeout(() => {
              if (streamInfoFlag) {
                streamInfoFlag = false;
                stramInfoElement.current.style.display = 'none';
              }
            }, 100);
            // remove stroke-width in mouse leave on stream conection
            ele.closest('g').querySelector('.react-flow__edge-path').style.setProperty('stroke-width', '', '');
            streamInfoFlag = true;
          });
        }
      });
    }
    // add change EventListener in input box show the model popup
    document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele) => {
      if (ele.className.indexOf('change') < 0) {
        ele.addEventListener('change', () => {
          ele.classList.add('change');
          setTimeout(() => {
            // check modelOpenDuplicate is set or not in localStorage
            const duplicateEnter = localStorage.getItem('modelOpenDuplicate');
            if (duplicateEnter) {
              localStorage.removeItem('modelOpenDuplicate');
              setModalOption({
                ...defaultModalOptions,
                visible: true,
                title: 'Error',
                message: 'Entered stream number is duplicated!',
                yesOrNo: false,
                onNo: () => setModalOption(defaultModalOptions),
                type: 'error'
              });
            }
          }, 500);
        });
      }
    });
  };
  // @shekhar add hover event on every stream connection END
  useEffect(() => {
    updateControlsButtonTitle();
    removeLocalStorageValue('removeValue');
    setTimeout(() => {
      if (localStorage.getItem('edgeChange')) {
        localStorage.removeItem('edgeChange');
        disabledStripperAndExplorerTab();
      }
    }, 1000);
    addMouseHoverEvent();
  });
  const streamInfoShowHide = (flag) => {
    if (draggableStart) {
      if (flag) {
        streamInfoFlag = false;
      }
      stramInfoElement.current.style.display = flag ? 'block' : 'none';
    }
  };
  const onConnectStart = () => { };
  const onConnectStop = () => { };
  const onConnectEnd = () => {
    setClonedEdgeText(Number(edgeText) + 1);
    if (Object.keys(streamNum_dict).length > 0) {
      setEdgeText(Number(Math.max(...Object.keys(streamNum_dict))) + 1);
    }
  };

  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
  // when user changes any unitop value call this function and disable the stream data, Explorer, pdf report and Error helper
  const disabledStripperAndExplorerTab = () => {
    executeOptionFlag = true;
    streamInfoFlag = false;
    error_details_info = [];
    stramInfoElement.current.style.display = 'none';
    setStreamInfoData([]);
    setExecuteObj(executeDefault);
    updateControlsButtonTitle();
    setExecuteDisabled(false);
    setOpenStremOverlay(false);
    executeEDIInfoData.reportData = {};
    executeEDIInfoData.flowSheetSolvdData = {};
    setFlowSheetImage('');
  };
  // added by chandrashekhar 14-08-2024 because after deleteting ropump data has been retain in hppump
  // check for unitop whose direclty connect to ro_hp
  // turbo, pelton, wex/pex and RO_HP
  // update the localStorage value after deleting unitop
  const removeLocalStorageRoOutputData = (arr, elem, str = '') => {
    let exitsingData = '';
    let arr_data = arr.filter(ele => {
      return ele.id === elem.id;
    });
    if (arr_data.length) {
      arr_data = arr.filter(ele => {
        return ele.type === 'customnode_pump_hp';
      });
      if (arr_data.length) {
        str = arr_data[0].id;
      }
      const data = arr.filter(ele => {
        if (ele.type === 'customnode_WEX_PEX') return ele;
        if (ele.type === 'customnode_Pelton_Wheel') return ele;
        if (ele.type === 'customnode_Turbo_Charger') return ele;
      });
      if (data.length) {
        exitsingData = data[0].id;
      }
    }
    if (str) {
      let ro_output_data = localStorage.getItem('ro_ouput_data');
      if (ro_output_data) {
        ro_output_data = JSON.parse(ro_output_data);
        delete ro_output_data[localStorage.getItem(str)];
        if (exitsingData) {
          delete ro_output_data[localStorage.getItem(exitsingData)];
        }
        localStorage.setItem('ro_ouput_data', JSON.stringify(ro_output_data));
      }
      let hp_pump_dict = localStorage.getItem('hp-pump-dict');
      if (hp_pump_dict) {
        hp_pump_dict = JSON.parse(hp_pump_dict);
        if (hp_pump_dict.hppump && hp_pump_dict.hppump[str]) {
          delete hp_pump_dict.hppump[str];
          if (Object.keys(hp_pump_dict.hppump).length) {
            localStorage.setItem('hp-pump-dict', JSON.stringify(hp_pump_dict));
          } else {
            localStorage.removeItem('hp-pump-dict');
          }
        }
      }
    }
  };
  // #### function for deletion of unitop ########
  // #### function to delete unitop ########
  const handleConfirm = (isClose = false, elem) => {
    const { type } = elem;
    let previousUnitsData = [];
    let item = type;
    let identify_erd = 'na';
    if (elem.id) {
      del_element_check = 0;
    }
    // #### if edge deletion #######
    if (elem.sourceHandle) {
      if (localStorage.getItem('streamNum_dict'))
        streamNum_dict = JSON.parse(localStorage.getItem('streamNum_dict'));
      localStorage.setItem('globalExitBtn', 'true');
      setChecked(false);
      dragdrop.current = true;
      jsLogger.info(`Edge deleted btwn -->> ${elem.id.split('reactflow__')[1]}s : Edge Number -> ${streamNum_dict[elem.data.text]}`);  // log edge deletions
      delete connectionInfo[elem.source + elem.sourceHandle];
      delete connectionInfo[elem.target + elem.targetHandle];
      delete streamNum_dict[elem.data.text];
      delete streamNum_dict[Object.keys(streamNum_dict).find(key => streamNum_dict[key] === elem.data.text)];
      localStorage.setItem('streamNum_dict', JSON.stringify(streamNum_dict));
      delete connectionInfo_source_target[elem.source];
      if (localStorage.getItem('mixSplit-dict') && elem.source.replace(/[\d_]+/g, '') == 'mixsplit') {
        removeItemsInLocalStorage('mixSplit-dict', 'mixSplit', elem.source);
        getBorderColor(elem.source, 'add');
      }
      // const edgesdata = rfInstance?.toObject()?.edges ?? [];
      connectionInfo = {}; // for bug fixing added this as empty GB-3042 for incase if multiple connection happened single unitop, then it will helpful for details
      // const d = document.getElementById(elem.id).getAttribute('d');
      // localStorage.setItem('d', d);
      // console.log(d);
    }
    // #### if unitop deletion #######
    else {
      jsLogger.info(`${elem.id} is deleted`);  // log unitOp deletions
      setChecked(false);
      dragdrop.current = true;
      // ######## identify_erd is a flag used to identify which erd is selected for delete #######
      if (identify_erd === 'na') {
        wexpex_all_unitop.forEach((item) => {
          if ((elem.id).includes(item.id)) {
            identify_erd = 'wexpex';
          }
        });
      }
      if (identify_erd === 'na') {
        peltonwheel_all_unitop.forEach((item) => {
          if ((elem.id).includes(item.id)) {
            identify_erd = 'pelton';
          }
        });
      }
      if (identify_erd === 'na') {
        turbocharger_all_unitop.forEach((item) => {
          if ((elem.id).includes(item.id)) {
            identify_erd = 'turbo';
          }
        });
      }

      if (identify_erd === 'wexpex') {
        wexpex_all_unitop.forEach((item_wexpex) => {
          Object.keys(connectionInfo).filter(
            (item) => {
              if (item.includes(item_wexpex.id)) {
                delete connectionInfo[item];
                // 8th Sept23: added by Akhil for code to remove the incoming edge of first mixSplit under WEX/PEX subnetwork
                const sourceOfFirstMixSplitinWexPex = Object.keys(connectionInfo_source_target).filter(key => connectionInfo_source_target[key] === wexpex_all_unitop[0].id)[0];
                delete connectionInfo[`${sourceOfFirstMixSplitinWexPex}c`];
                // 8th Sept23: added by Akhil for code to remove the outgoing edge of wex/pex & RO_ERD under WEX/PEX subnetwork
                const targetOfFirstMixSplitinWexPex = connectionInfo_source_target[item_wexpex.id];
                delete connectionInfo[`${targetOfFirstMixSplitinWexPex}a`];
              }
            });
        });
        isWexPex = false;
        withoutDeletionDublicateERD = false;
        wex_call_count = 0;
        localStorage.removeItem('press_exc-dict');
        localStorage.removeItem('work_exc-dict');
      }
      if (identify_erd === 'pelton') {
        peltonwheel_all_unitop.forEach((item_pw) => {
          Object.keys(connectionInfo).filter((item) => {
            if (item.includes(item_pw.id)) {
              delete connectionInfo[item];
            }
          });
        });
        // 12th Sept23: added by Akhil for code to remove the incoming edge of first hppump under pelton wheel subnetwork
        const sourceOfHPPumpinPelton = Object.keys(connectionInfo_source_target).filter(key => connectionInfo_source_target[key] === peltonwheel_all_unitop[0].id)[0];
        delete connectionInfo[`${sourceOfHPPumpinPelton}c`];
        // 12th Sept23: added by Akhil for code to remove the outgoing edge of pelton wheel
        const targetOfPWinPelton = connectionInfo_source_target[peltonwheel_all_unitop[1].id];
        delete connectionInfo[`${targetOfPWinPelton}a`];
        // 12th Sept23: added by Akhil for code to remove the outgoing edge of RO-ERD
        const targetOfROERDinPelton = connectionInfo_source_target[peltonwheel_all_unitop[2].id];
        delete connectionInfo[`${targetOfROERDinPelton}a`];
        isPeltonWheel = false;
        withoutDeletionDublicatePeltonWheel = false;
        localStorage.removeItem('pelton_wheel-dict');
      }

      if (identify_erd === 'turbo') {
        turbocharger_all_unitop.forEach((item_tc) => {
          Object.keys(connectionInfo).filter(
            (item) => {
              if (item.includes(item_tc.id)) {
                delete connectionInfo[item];
              }
            });
        });
        isturbocharger = false;
        withoutDeletionDublicateTurbo = false;

        // 12th Sept23: added by Akhil for code to remove the incoming edge of first hppump under TC subnetwork
        const sourceOfHPPumpinTC = Object.keys(connectionInfo_source_target).filter(key => connectionInfo_source_target[key] === turbocharger_all_unitop[0].id)[0];
        delete connectionInfo[`${sourceOfHPPumpinTC}c`];
        // 12th Sept23: added by Akhil for code to remove the outgoing edge of TC
        const targetOfTCinTC = connectionInfo_source_target[turbocharger_all_unitop[1].id];
        delete connectionInfo[`${targetOfTCinTC}a`];
        // 12th Sept23: added by Akhil for code to remove the outgoing edge of RO-ERD
        const targetOfROERDinTC = connectionInfo_source_target[turbocharger_all_unitop[2].id];
        delete connectionInfo[`${targetOfROERDinTC}a`];
        localStorage.removeItem('turbo_charger-dict');
      }
      // @sudarsana here exiting code commented because issue is happing on connection between in hppump and pump
      // so we removed inculde statement and maked as "==="
      const res_source = Object.entries(connectionInfo).filter(([k]) => {
        return k.slice(0, -1) === elem.id;
      });
      if (res_source)
        res_source.map((item, index) => { delete connectionInfo[res_source[index][0]]; });
      if (elem.id.replace(/[\d_]+/g, '') == 'roPump' || elem.id.replace(/[\d_]+/g, '') == 'nfPump') {
        const res_source_hppump = Object.entries(connectionInfo).filter(([k]) => k.includes(`hppump_${elem.id[elem.id.length - 1]}`));
        if (res_source_hppump && res_source_hppump.length) {
          // added by chandrashekhar 14-08-2024 because after deleteting ropump data has been retain in hppump start
          const data = res_source_hppump[0][0].split(res_source_hppump[0][1])[0];
          removeLocalStorageRoOutputData([], elem, data);
          // added by chandrashekhar 14-08-2024 because after deleteting ropump data has been retain in hppump end
          res_source_hppump.map((item, index) => {
            delete connectionInfo[res_source_hppump[index][0]];
          });
        }
        const res_source_peltonwheel = Object.entries(connectionInfo).filter(([k]) => k.includes(`peltonwheel_${elem.id[elem.id.length - 1]}`));
        if (res_source_peltonwheel)
          res_source_peltonwheel.map((item, index) => { delete connectionInfo[res_source_peltonwheel[index][0]]; });
      }
      // Source
      let source_index = unitop_source.map((item, index) => {
        if (elem.id.replace(/[\d_]+/g, '') != 'roPump' || elem.id.replace(/[\d_]+/g, '') != 'nfPump') {
          // @sudarsana commeted this "item.includes(elem.id)" added in this if condtion  "item.slice(0, -1) === (elem.id)"
          if (item.slice(0, -1) === (elem.id))
            return (index);
          else
            return -1;
        }
        else {

          if (item.includes(`hppump_${elem.id[elem.id.length - 1]}`) || item.includes(elem.id)) {
            return (index);
          }
          else {
            return -1;
          }
        }
      });
      source_index = source_index.filter((item) => { return item >= 0; });

      // Target
      let target_index = unitop_target.map((item, index) => {
        if (elem.id.replace(/[\d_]+/g, '') != 'roPump' || elem.id.replace(/[\d_]+/g, '') != 'nfPump') {
          if (item.includes(elem.id))
            return (index);
          else
            return -1;
        }
        else {
          if (item.includes(`hppump_${elem.id[elem.id.length - 1]}`) || item.includes(elem.id)) {
            return (index);
          }
          else {
            return -1;
          }
        }
      });
      target_index = target_index.filter((item) => { return item >= 0; });

      // ######## delete connectionInfo dict based on SourceIndex and TargetIndex ######
      if (source_index.length > 0) {
        for (let i = 0; i < source_index.length; i++) {
          if (source_index[i] >= 0) {
            const key = Object.entries(connectionInfo).find(([k]) => k.includes(unitop_target[source_index[i]]));
            if (key)
              delete connectionInfo[key[0]];
          }
        }
        for (let i = 0; i < target_index.length; i++) {
          if (target_index[i] >= 0) {
            const key = Object.entries(connectionInfo).find(([k]) => k.includes(unitop_source[target_index[i]]));
            if (key)
              delete connectionInfo[key[0]];
          }
        }
      } else {
        // product, waste unitop
        for (let i = 0; i < target_index.length; i++) {
          if (target_index[i] >= 0) {
            const key = Object.entries(connectionInfo).find(([k]) => k.includes(unitop_target[target_index[i]]));
            if (key)
              delete connectionInfo[key[0]];
            const key1 = Object.entries(connectionInfo).find(([k]) => k.includes(unitop_source[target_index[i]]));
            if (key1)
              delete connectionInfo[key1[0]];
          }
        }
      }
      // ########## end #######

      // ########## clearing unitop_source and unitop_target list values and re-adjust their postion ########
      for (let i = 0; i < source_index.length; i++) {
        unitop_target[source_index[i]] = 'xx';
      }
      for (let i = 0; i < target_index.length; i++) {
        unitop_source[target_index[i]] = 'xx';
      }

      unitop_source = unitop_source.filter((item) => { return (!item.includes(elem.id) && item != 'xx'); }); // unitop_source.filter((item)=>{return (item != elem.id && item != 'xx')});
      unitop_target = unitop_target.filter((item) => { return (!item.includes(elem.id) && item != 'xx'); }); // unitop_target.filter((item)=>{return (item != elem.id && item != 'xx')});

      if (elem.id.replace(/[\d_]+/g, '') == 'roPump' || elem.id.replace(/[\d_]+/g, '') == 'nfPump') {
        // for hppump removal
        unitop_source = unitop_source.filter((item) => { return (!item.includes(`hppump_${elem.id[elem.id.length - 1]}`) && item != 'xx'); }); // unitop_source.filter((item)=>{return (item != elem.id && item != 'xx')});
        unitop_target = unitop_target.filter((item) => { return (!item.includes(`hppump_${elem.id[elem.id.length - 1]}`) && item != 'xx'); });
      }
      // ########### end ########
      if (elem.id.replace(/[\d_]+/g, '') == 'roPump') {
        // for peltonwheel removal
        unitop_source = unitop_source.filter((item) => { return (!item.includes(`peltonwheel_${elem.id[elem.id.length - 1]}`) && item != 'xx'); }); // unitop_source.filter((item)=>{return (item != elem.id && item != 'xx')});
        unitop_target = unitop_target.filter((item) => { return (!item.includes(`peltonwheel_${elem.id[elem.id.length - 1]}`) && item != 'xx'); });
      }

      // ###### clear mixer-splitter related array based on id ########
      if (mixSplit_target.indexOf(elem.id) !== -1) {
        let mixSplit_id = mixSplit_source[mixSplit_target.indexOf(elem.id)];
        if (mixSplit_id.replace(/[\d_]+/g, '') == 'hppump') {
          mixSplit_id = mixSplit_source[mixSplit_target.indexOf(mixSplit_id)];
        }
        if (mixSplit_id) {
          if (localStorage.getItem('mixSplit-dict') && mixSplit_id.replace(/[\d_]+/g, '') == 'mixsplit') {
            removeItemsInLocalStorage('mixSplit-dict', 'mixSplit', mixSplit_id);
            mixSplit_source.splice(mixSplit_source[mixSplit_target.indexOf(elem.id)], 1);
            mixSplit_target.splice(mixSplit_target.indexOf(elem.id), 1);
            getBorderColor(mixSplit_id, 'add');
          }
        }
        if (elem.id.replace(/[\d_]+/g, '') == 'mixsplit') {
          removeItemsInLocalStorage('mixSplit-dict', 'mixSplit', elem.id);
          getBorderColor(elem.id, 'add');
          mixSplit_source.splice(mixSplit_source[mixSplit_target.indexOf(elem.id)], 1);
          mixSplit_target.splice(mixSplit_target.indexOf(elem.id), 1);
        }

      }
      // ####### end ########

      setTimeout(() => {
        if (document.querySelectorAll('.react-flow__edge.react-flow__edge-custom').length) {
          const obj = {};
          streamNum_dict = {};
          document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele) => {
            obj[ele.value] = +ele.value;
          });
          localStorage.setItem('streamNum_dict', JSON.stringify(obj));
          streamNum_dict = JSON.parse(localStorage.getItem('streamNum_dict'));
        }
      }, 100);
    }
    if (type === 'customnode_feed') item = 'feed';
    if (type === 'customnode_productOut') item = 'ro';
    if (type === 'customnode_productOut_NF') item = 'nf';
    /*
    * When open flowsheet exits Feed, Product, RO_HP
    * delete any one we have update the localstroage value
    * flow_dict, feed_flow_dict and product_flow_dict
    * If user delete the Feed we have update localStorage flow_dict and feed_flow_dict and
    * user delete the product and RO_HP we have update the  localStorage flow_dict and product_flow_dict
    * get the name of unitop using localStorage.getItem(elem.id);
    * delete are using for delete the object key and value delete flow_dict_data[localStorage.getItem(elem.id)];
    * check if item === 'feed' || type === 'customnode_product' || type === 'customnode_ROpump' then
    * localstorage is updated.
    */
    if (item === 'feed' || type === 'customnode_product' || type === 'customnode_ROpump' || type === 'customnode_NFpump') {
      let flow_dict_data = localStorage.getItem('flow_dict');
      if (flow_dict_data) {
        flow_dict_data = JSON.parse(flow_dict_data);
        delete flow_dict_data[localStorage.getItem(elem.id)];
        localStorage.setItem('flow_dict', JSON.stringify(flow_dict_data));
      }
      if (item === 'feed') {
        let feedValue_dict = localStorage.getItem('feed_flow_dict');
        if (feedValue_dict) {
          feedValue_dict = JSON.parse(feedValue_dict);
          delete feedValue_dict.feed_flow.feed_value[localStorage.getItem(elem.id)];
          localStorage.setItem('feed_flow_dict', JSON.stringify(feedValue_dict));
        }
      } else if (type === 'customnode_product' || type === 'customnode_ROpump' || type === 'customnode_NFpump') {
        let productFlowDictVal = localStorage.getItem('product_flow_dict');
        if (productFlowDictVal) {
          productFlowDictVal = JSON.parse(productFlowDictVal);
          delete productFlowDictVal.product_flow.product_value[localStorage.getItem(elem.id)];
          localStorage.setItem('product_flow_dict', JSON.stringify(productFlowDictVal));
        }
      }
    }
    if (isClose) {
      setModalOption(defaultModalOptions);
      setModalIsOpen_alert(false);
      for (let i = 0; i < node1.length; i++) {
        if (node1[i].id == elem.id) {
          node1.splice(i, 1);
        }
      }
      // fixing the validation of peltonwheel connection @sudarsana
      peltonwheel_all_unitop.filter((pelton) => {
        for (let i = 0; i < Object.keys(connectionInfo_source_target).length; i++) {
          const mapping = Object.keys(connectionInfo_source_target)[i];
          if (connectionInfo_source_target[mapping] === pelton.id) {
            delete connectionInfo[`${pelton.id}c`];
            delete connectionInfo[`${pelton.id}a`];
          }
        }
      });
      // @sudarsana added here to solve the update edge issue connection after deleting
      if (updateconnectionInfoDelete) {
        delete connectionInfo[updateconnectionsource];
        updateconnectionInfoDelete = false;
      }
      // deleting the element and edge in version 11 code @sudarsana
      setElements(nds => {
        const updatedElements = nds.filter(node => node.id !== elem.id);
        // start --> here we written the logic for delection of unitops for all and again drag new unitops connection that stream number should start from '1'
        const uniqueEdges = edge_id_details.reduce((acc, current) => {
          const x = acc.find(item => item.source === current.source && item.target === current.target && item.type === current.type);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []); // this was written for remove the duplicate of array of edge_id_details
        const matchingEdges = uniqueEdges.filter(edge => edge.source === elem.id || edge.target === elem.id);
        // matchingEdges logic written for get the data both source and target
        if (!(elem.id).includes('reactflow__edge') || elem.id.replace(/[\d_]+/g, '') !== 'roPump' || elem.id.replace(/[\d_]+/g, '') !== 'nfPump') { // here this condition should satisfy only untiop deletion not for edge deletion
          matchingEdges.forEach((edge) => {
            const connectDeletion = Object.keys(streamNum_dict).find(key => {
              return streamNum_dict[key] === edge.data.text;
            });
            if (connectDeletion) {
              delete connectionInfo[edge.source + edge.sourceHandle]; // it wil get source for which connection need to delete
              delete connectionInfo[edge.target + edge.targetHandle]; // it wil get target for which connection need to delete
            }
          });
          if (updatedElements.length === 0) {
            edge_id_details = [];
          }
        }
        // end
        return updatedElements;
      });
      setEdges(nds => nds.filter(edge => edge.source !== elem.id && edge.target !== elem.id));
      setEdges(nds => {
        const updatedEdge = nds.filter(edge => edge.id !== elem.id);
        return updatedEdge;
      });
      if (elem.id) {
        const elemId = elem.id;
        setTimeout(() => {
          localStorage.removeItem(elemId);
        }, 0);
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'roPump') {
        const key_hppump = getKeyByValue(connectionInfo_source_target, elem.id);
        const res_source = Object.entries(connectionInfo).find(([k]) => k.includes(key_hppump));
        // @ sudarsana added to delete the groupROHP box in ROHP and CLRO
        const group = key_hppump ? `groupROHP_${parseInt(key_hppump.match(/\d+/)[0], 10)}` : '';
        if (res_source) {
          delete connectionInfo[res_source[0]];
        }
        delete connectionInfo_source_target[key_hppump];
        for (let i = 0; i < node1.length; i++) {
          if (node1[i].id == key_hppump || node1[i].id == group) {
            if (node1.some(node => node.id === key_hppump) && node1.some(node => node.id === group)) {
              setElements(nds => {
                // Filter out the element with the specified ID added in version 11 code @sudarsana
                const updatedElements = nds.filter(node => node.id !== node1[i].id);
                const uniqueEdges = edge_id_details.reduce((acc, current) => {
                  const x = acc.find(item => item.source === current.source && item.target === current.target && item.type === current.type);
                  if (!x) {
                    return acc.concat([current]);
                  } else {
                    return acc;
                  }
                }, []);
                const matchingEdges = uniqueEdges.filter(edge => (edge.target === key_hppump || edge.source === elem.id || edge.target === elem.id));
                if (!(elem.id).includes('reactflow__edge')) {
                  matchingEdges.forEach(edge => {
                    // Delete the text property from the data object of each edge
                    // Also delete the corresponding entry in streamNum_dict using the text value
                    // removed unwanted code commented
                    const keyToDelete = Object.keys(streamNum_dict).find(key => streamNum_dict[key] === edge.data.text);
                    if (keyToDelete) {
                      delete connectionInfo[edge.source + edge.sourceHandle];
                      delete connectionInfo[edge.target + edge.targetHandle];
                    }
                  });
                }
                return updatedElements;
              });
              setEdges(nds => {
                // Filter out edges where the source or target matches the specified node ID added in version 11 code @sudarsana
                const updatedEdges = nds.filter(edge => edge.source !== node1[i].id && edge.target !== node1[i].id);
                return updatedEdges;
              });
              deleteUnitop.push(node1[i]);
            }
          }
        }
        if (identify_erd === 'wexpex') {
          wexpex_all_unitop.forEach((item) => {
            // const key_hppump = getKeyByValue(connectionInfo_source_target, elem.id);
            setElements(nds => {
              // Filter out the element with the specified ID added in version 11 code @sudarsana
              const updatedElements = nds.filter(node => node.id !== item.id);

              const uniqueEdges = wexped_id_details.reduce((acc, current) => {
                const x = acc.find(item => item.source === current.source && item.target === current.target && item.type === current.type);
                if (!x) {
                  return acc.concat([current]);
                } else {
                  return acc;
                }
              }, []);

              if (!(elem.id).includes('reactflow__edge')) {
                uniqueEdges.forEach(edge => {
                  // Delete the text property from the data object of each edge
                  // Also delete the corresponding entry in streamNum_dict using the text value
                  const keyToDelete = Object.keys(streamNum_dict).find(key => streamNum_dict[key] === edge.data.text);
                  if (keyToDelete) {
                    // delete streamNum_dict[keyToDelete];
                    // delete streamNum_dict[edge.data.text];
                    delete connectionInfo[edge.source + edge.sourceHandle];
                    delete connectionInfo[edge.target + edge.targetHandle];
                  }
                });
              }
              return updatedElements;
            });
            // // Here the logic to delete the streamNum_dict after deletion in version 11 @sudarsana
            setEdges(nds => {
              // Filter out edges where the source or target matches the specified node ID added in version 11 code @sudarsana
              const updatedEdges = nds.filter(edge => edge.source !== item.id && edge.target !== item.id);
              return updatedEdges;
            });
            delete connectionInfo_source_target[item.id];
            removeLocalStorageRoOutputData(wexpex_all_unitop, elem);
          });
          previousUnitsData = [...wexpex_all_unitop];
          wexpex_all_unitop = [];
        }
        if (identify_erd === 'pelton') {
          peltonwheel_all_unitop.forEach((item) => {
            const key_hppump = getKeyByValue(connectionInfo_source_target, elem.id);
            setElements(nds => {
              // Filter out the element with the specified ID
              const updatedElements = nds.filter(node => node.id !== item.id);
              const uniqueEdges = pelton_id_details.reduce((acc, current) => {
                const x = acc.find(item => item.source === current.source && item.target === current.target && item.type === current.type);
                if (!x) {
                  return acc.concat([current]);
                } else {
                  return acc;
                }
              }, []);
              const matchingEdges = uniqueEdges.filter(edge => (edge.target === key_hppump || edge.source === elem.id || edge.target === elem.id));
              if (!(elem.id).includes('reactflow__edge')) {
                matchingEdges.forEach(edge => {
                  // Delete the text property from the data object of each edge
                  // Also delete the corresponding entry in streamNum_dict using the text value
                  const keyToDelete = Object.keys(streamNum_dict).find(key => streamNum_dict[key] === edge.data.text);
                  if (keyToDelete) {
                    // delete streamNum_dict[keyToDelete];
                    // delete streamNum_dict[edge.data.text];
                    delete connectionInfo[edge.source + edge.sourceHandle];
                    delete connectionInfo[edge.target + edge.targetHandle];
                  }
                });
              }
              return updatedElements;
            });
            setEdges(nds => {
              // Filter out edges where the source or target matches the specified node ID
              const updatedEdges = nds.filter(edge => edge.source !== item.id && edge.target !== item.id);
              return updatedEdges;
            });
            removeLocalStorageRoOutputData(peltonwheel_all_unitop, elem);
          });
          previousUnitsData = [...peltonwheel_all_unitop];
          peltonwheel_all_unitop = [];
        }
        if (identify_erd === 'turbo') {
          turbocharger_all_unitop.forEach((item) => {
            setElements(nds => {
              // Filter out the element with the specified ID
              const updatedElements = nds.filter(node => node.id !== item.id);
              edge_id_details.reduce((acc, current) => {
                const x = acc.find(item => item.source === current.source && item.target === current.target && item.type === current.type);
                if (!x) {
                  return acc.concat([current]);
                } else {
                  return acc;
                }
              }, []);
              turbo_id_details.reduce((acc, current) => {
                const x = acc.find(item => item.source === current.source && item.target === current.target && item.type === current.type);
                if (!x) {
                  return acc.concat([current]);
                } else {
                  return acc;
                }
              }, []);
              if (!(elem.id).includes('reactflow__edge')) {
                turbo_id_details.forEach(edge => {
                  // Delete the text property from the data object of each edge
                  // Also delete the corresponding entry in streamNum_dict using the text value
                  const keyToDelete = Object.keys(streamNum_dict).find(key => streamNum_dict[key] === edge.data.text);
                  if (keyToDelete) {
                    delete connectionInfo[edge.source + edge.sourceHandle];
                    delete connectionInfo[edge.target + edge.targetHandle];
                  }
                });
              }
              return updatedElements;
            });
            // Here the logic to delete the streamNum_dict after deletion
            setEdges(nds => {
              // Filter out edges where the source or target matches the specified node ID
              const updatedEdges = nds.filter(edge => edge.source !== item.id && edge.target !== item.id);
              return updatedEdges;
            });
            removeLocalStorageRoOutputData(turbocharger_all_unitop, elem);
          });
          previousUnitsData = [...turbocharger_all_unitop];
          turbocharger_all_unitop = [];
        }
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'nfPump') {
        const key_hppump = getKeyByValue(connectionInfo_source_target, elem.id);
        const res_source = Object.entries(connectionInfo).find(([k]) => k.includes(key_hppump));
        // @ sudarsana added to delete the groupROHP box in ROHP and CLRO
        const group = key_hppump ? `groupROHP_${parseInt(key_hppump.match(/\d+/)[0], 10)}` : '';
        if (res_source) {
          delete connectionInfo[res_source[0]];
        }
        delete connectionInfo_source_target[key_hppump];
        for (let i = 0; i < node1.length; i++) {
          if (node1[i].id == key_hppump || node1[i].id == group) {
            if (node1.some(node => node.id === key_hppump) && node1.some(node => node.id === group)) {
              setElements(nds => {
                // Filter out the element with the specified ID added in version 11 code @sudarsana
                const updatedElements = nds.filter(node => node.id !== node1[i].id);
                const uniqueEdges = edge_id_details.reduce((acc, current) => {
                  const x = acc.find(item => item.source === current.source && item.target === current.target && item.type === current.type);
                  if (!x) {
                    return acc.concat([current]);
                  } else {
                    return acc;
                  }
                }, []);
                const matchingEdges = uniqueEdges.filter(edge => (edge.target === key_hppump || edge.source === elem.id || edge.target === elem.id));
                if (!(elem.id).includes('reactflow__edge')) {
                  matchingEdges.forEach(edge => {
                    // Delete the text property from the data object of each edge
                    // Also delete the corresponding entry in streamNum_dict using the text value
                    // removed unwanted code commented
                    const keyToDelete = Object.keys(streamNum_dict).find(key => streamNum_dict[key] === edge.data.text);
                    if (keyToDelete) {
                      delete connectionInfo[edge.source + edge.sourceHandle];
                      delete connectionInfo[edge.target + edge.targetHandle];
                    }
                  });
                }
                return updatedElements;
              });
              setEdges(nds => {
                // Filter out edges where the source or target matches the specified node ID added in version 11 code @sudarsana
                const updatedEdges = nds.filter(edge => edge.source !== node1[i].id && edge.target !== node1[i].id);
                return updatedEdges;
              });
              deleteUnitop.push(node1[i]);
            }
          }
        }
      }
      delete connectionInfo_source_target[elem.id];
      if (elem.id.replace(/[\d_]+/g, '') == 'stripper') {
        c_stripper.splice(c_stripper.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_stripper.sort((a, b) => { return a - b; });
        removeItemsInLocalStorage('stripper-dict', 'st', elem.id);
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'feed') {
        c_feed.splice(c_feed.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_feed.sort((a, b) => { return a - b; });
        removeItemsInLocalStorage('form', 'feed', elem.id);
        removeItemsInLocalStorage('feed-dict', 'feed', elem.id);
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'ro') {
        removeItemsInLocalStorage('ro-dict', 'ro', elem.id);
        removeItemsInLocalStorage('ro_payload', 'ro', elem.id);
        removeItemsInLocalStorage('ro_argo_temp', 'ro', elem.id);
        c_ro.splice(c_ro.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_ro.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'nf') {
        removeItemsInLocalStorage('ro-dict', 'ro', elem.id);
        removeItemsInLocalStorage('ro_payload', 'ro', elem.id);
        c_ro.splice(c_ro.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_ro.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'edi') {
        removeItemsInLocalStorage('edi-dict', 'EDI', elem.id);
        /*
         after flowsheet calculated delete the edi-form previously retain the data new edi form
         now id deleting the edi-output-dict data to remove the previous edi-form data
        */
        removeItemsInLocalStorage('edi-output-dict', 'EDI', elem.id);
        c_edi.splice(c_edi.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_edi.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'pump') {
        removeItemsInLocalStorage('pump-dict', 'pump', elem.id);
        c_pump.splice(c_pump.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_pump.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'roPump') {
        removeItemsInLocalStorage('ro-dict', 'ro', elem.id);
        removeItemsInLocalStorage('ro_payload', 'ro', elem.id);
        removeItemsInLocalStorage('ro_argo_temp', 'ro', elem.id);
        if (elem.type === 'customnode_CLROpump') {
          removeItemsInLocalStorage('clro-dict', 'ro', elem.id);
          removeItemsInLocalStorage('clro_payload', 'ro', elem.id);
          // Added by Abhishek on 28-dec-23 for rohp coming as clro after deleting clro
          const deletedClroIndex = clro_all_unitop.indexOf(clro_all_unitop.find(item => item.id === elem.id));
          clro_all_unitop.splice(deletedClroIndex, 3); // if we have more than one clro then we r only removing deleted clro by Abhishek on 29-Dec-23
        }
        const peltonwheelData = peltonwheel_all_unitop.filter((peltonData) => {
          return peltonData.id === elem.id;
        });
        if (peltonwheelData.length) {
          for (let i = 0; i < peltonwheel_all_unitop.length; i++) {
            const elemId = peltonwheel_all_unitop[i].id;
            if (elemId.indexOf('peltonwheel') >= 0) {
              removeItemsInLocalStorage('pelton_wheel-dict', 'pelton_exc', elemId);
            } else if (elemId.indexOf('hppump') >= 0) {
              removeItemsInLocalStorage('hp-pump-dict', 'hppump', elemId);
            } else if (elemId.indexOf('roPump') >= 0) {
              removeItemsInLocalStorage('ro-dict', 'ro', elemId);
              removeItemsInLocalStorage('ro_payload', 'ro', elemId);
              removeItemsInLocalStorage('ro_argo_temp', 'ro', elemId);
            }
          }
        }
        const turbochargerData = turbocharger_all_unitop.filter((turbocharger) => {
          return turbocharger.id === elem.id;
        });
        if (turbochargerData.length) {
          for (let i = 0; i < turbocharger_all_unitop.length; i++) {
            const elemId = turbocharger_all_unitop[i].id;
            if (elemId.indexOf('TC') >= 0) {
              removeItemsInLocalStorage('turbo_charger-dict', 'TRD_data', elemId);
            } else if (elemId.indexOf('hppump') >= 0) {
              removeItemsInLocalStorage('hp-pump-dict', 'hppump', elemId);
            } else if (elemId.indexOf('roPump') >= 0) {
              removeItemsInLocalStorage('ro-dict', 'ro', elemId);
              removeItemsInLocalStorage('ro_payload', 'ro', elemId);
              removeItemsInLocalStorage('ro_argo_temp', 'ro', elem.id);
            }
          }
        }
        const wexpexData = wexpex_all_unitop.filter((wexpex) => {
          return wexpex.id === elem.id;
        });
        if (wexpexData.length) {
          for (let i = 0; i < wexpex_all_unitop.length; i++) {
            const elemId = wexpex_all_unitop[i].id;
            if (elemId.indexOf('wex') >= 0 || elemId.indexOf('pex') >= 0) {
              removeItemsInLocalStorage('work_exc-dict', 'work_exc', elemId);
              removeItemsInLocalStorage('press_exc-dict', 'press_exc', elemId);
            } else if (elemId.indexOf('mixsplit') >= 0) {
              removeItemsInLocalStorage('mixSplit-dict', 'mixSplit', elemId);
            } else if (elemId.indexOf('hppump') >= 0) {
              removeItemsInLocalStorage('hp-pump-dict', 'hppump', elemId);
            } else if (elemId.indexOf('roPump') >= 0) {
              removeItemsInLocalStorage('ro-dict', 'ro', elemId);
              removeItemsInLocalStorage('ro_payload', 'ro', elemId);
              removeItemsInLocalStorage('ro_argo_temp', 'ro', elem.id);
            }
          }
        }
        const roPumpData = roPump_all_unitops.filter((roPump) => {
          return roPump.id === elem.id;
        });
        if (roPumpData.length) {
          for (let i = 0; i < roPump_all_unitops.length; i++) {
            const elemId = roPump_all_unitops[i].id;
            if (elemId.indexOf('hppump') >= 0) {
              removeItemsInLocalStorage('hp-pump-dict', 'hppump', elemId);
            } else if (elemId.indexOf('roPump') >= 0) {
              removeItemsInLocalStorage('ro-dict', 'ro', elemId);
              removeItemsInLocalStorage('ro_payload', 'ro', elemId);
              removeItemsInLocalStorage('clro-dict', 'ro', elemId);
              removeItemsInLocalStorage('clro_payload', 'ro', elemId);
              removeItemsInLocalStorage('ro_argo_temp', 'ro', elem.id);
            }
          }
        }
        c_roPump.splice(c_roPump.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_roPump.sort((a, b) => { return a - b; });
        c_pump_hp.splice(c_pump_hp.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_pump_hp.sort((a, b) => { return a - b; });
        // array should be empty after deleteing pelton wheel by sudarsana
        c_pelton_wheel.splice(c_pelton_wheel.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_pelton_wheel.sort((a, b) => { return a - b; });
        // array should be empty after deleteing  Turbo charger by sudarsana
        c_Turbo_Charger.splice(c_Turbo_Charger.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_Turbo_Charger.sort((a, b) => { return a - b; });
        c_box_RO_HP.splice(c_box_RO_HP.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_box_RO_HP.sort((a, b) => { return a - b; });
        // @sudarsana wex/pex id delection
        c_boosterPump.splice(c_boosterPump.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_boosterPump.sort((a, b) => { return a - b; });

        // making connection empty after deleting only  peltonwheel connections by sudarsana
        const filteredKeys = Object.keys(connectionInfo).filter(key => !key.includes('peltonwheel') && !key.includes('hppump'));
        const filteredObject = Object.fromEntries(filteredKeys.map(key => [key, connectionInfo[key]]));
        const result = {};
        const keysOfB = Object.keys(filteredObject);
        for (let i = 0; i < keysOfB.length; i++) {
          const key = keysOfB[i];
          if (Object.prototype.hasOwnProperty.call(filteredObject, key) && Object.prototype.hasOwnProperty.call(connectionInfo, key) && connectionInfo[key] === filteredObject[key]) {
            result[key] = filteredObject[key];
          }
        }
        connectionInfo = result;
        if (turbocharger_all_unitop.length > 0) {
          turbochargeLength = true;
        }
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'nfPump') {
        removeItemsInLocalStorage('ro-dict', 'ro', elem.id);
        removeItemsInLocalStorage('ro_payload', 'ro', elem.id);
        c_roPump.splice(c_roPump.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_roPump.sort((a, b) => { return a - b; });
        c_pump_hp.splice(c_pump_hp.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_pump_hp.sort((a, b) => { return a - b; });
        c_box_RO_HP.splice(c_box_RO_HP.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_box_RO_HP.sort((a, b) => { return a - b; });

        // making connection empty after deleting only  peltonwheel connections by sudarsana
        const filteredKeys = Object.keys(connectionInfo).filter(key => !key.includes('peltonwheel') && !key.includes('hppump'));
        const filteredObject = Object.fromEntries(filteredKeys.map(key => [key, connectionInfo[key]]));
        const result = {};
        const keysOfB = Object.keys(filteredObject);
        for (let i = 0; i < keysOfB.length; i++) {
          const key = keysOfB[i];
          if (Object.prototype.hasOwnProperty.call(filteredObject, key) && Object.prototype.hasOwnProperty.call(connectionInfo, key) && connectionInfo[key] === filteredObject[key]) {
            result[key] = filteredObject[key];
          }
        }
        connectionInfo = result;
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'product') {
        c_product.splice(c_product.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_product.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'wasteout') {
        c_wasteout.splice(c_wasteout.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_wasteout.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'mixsplit') {
        c_mixsplit.splice(c_mixsplit.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_mixsplit.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'chemicaldosing') {
        removeItemsInLocalStorage('dosing-dict', 'Chemical_Dosing', elem.id);
        /*
         after flowsheet calculated delete the Chemical_Dosing-form previously retain the data new Chemical_Dosing form
         now id deleting the cd-output-dict data to remove the previous Chemical_Dosing-form data
        */
        removeItemsInLocalStorage('cd-output-dict', 'Chemical_Dosing', elem.id);
        c_chemical_dosing.splice(c_chemical_dosing.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_chemical_dosing.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'wex') {
        c_wex.splice(c_wex.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_wex.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'peltonwheel') {
        c_pelton_wheel.splice(c_pelton_wheel.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_pelton_wheel.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'TC') {
        c_Turbo_Charger.splice(c_Turbo_Charger.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_Turbo_Charger.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'cartridge') {
        removeItemsInLocalStorage('cf-dict', 'cf', elem.id);
        /*
         after flowsheet calculated delete the CF-form previously retain the data new CF form
         now id deleting the cf-output-dict data to remove the previous CF-form data
        */
        removeItemsInLocalStorage('cf-output-dict', 'cf-output', elem.id);
        cartridge_feed.splice(cartridge_feed.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        cartridge_feed.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'hppump') {
        c_pump_hp.splice(c_pump_hp.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_pump_hp.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'groupROHP') {
        c_box_RO_HP.splice(c_box_RO_HP.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_box_RO_HP.sort((a, b) => { return a - b; });
      }
      if (elem.id.replace(/[\d_]+/g, '') == 'rectangle') {
        c_rectangle.splice(c_rectangle.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_rectangle.sort((a, b) => { return a - b; });
      }
      // @sudarsana added boosterpump in wex/pex
      if (elem.id.replace(/[\d_]+/g, '') == 'boosterpump') {
        c_boosterPump.splice(c_boosterPump.indexOf(Number(elem.id.substring(elem.id.indexOf('_') + 1))), 1);
        c_boosterPump.sort((a, b) => { return a - b; });
      }
    }
    // @sudarsana this logic is main important for after deleting the unitops make sure stremNum_dict is empty
    if (!(elem.id).includes('reactflow__edge')) {
      setTimeout(() => {
        localStorage.setItem('streamNum_dict', JSON.stringify({}));
        // @sudarsana (08/28/2024) here added connectionInfo empty for logic after deletion make it as a empty
        // again this connectionInfo re-filling On Drop and onConnection Functions
        connectionInfo = {};
        if (document.querySelectorAll('.react-flow__edge.react-flow__edge-custom').length === 0) {
          streamNum_dict = {};
        }
        if (Object.keys(streamNum_dict).length === 0) {
          setEdgeText(0);
        }
      }, 1000);
    }
    // @sudarsana bug fixing after saving the file in case the connection info data not deleted --> starting code
    // commeted code @sudarsana for bug fixing GB-2008
    // @sudarsana bug fixing ending code
    disabledStripperAndExplorerTab();
    /**
     * remove the localstorage value when user delete the RO with Pump
     * roPump delete in localStorage but hppump value is not deleted
     * so generate the error
     * error is when user drag `RO with Pump` add two value in localStorage roPump and hppump
     * when delete the ropump remove the `roPump` localStorage value but `hppump` is not deleted
     * add this line to remove the hppump value in localStorage `localStorage.removeItem(`hppump_${elem.id.slice(-1)}`);`
     */
    setTimeout(() => {
      if (type === 'customnode_ROpump') {
        localStorage.removeItem(`hppump_${elem.id.slice(-1)}`);
        previousUnitsData.forEach((localVal) => {
          localStorage.removeItem(localVal.id);
        });
      } else if (type === 'customnode_CLROpump') {
        localStorage.removeItem(`hppump_${elem.id.slice(-1)}`);
      }
      convasEmptyFun();
    }, 500);
  };
  const handleClick = (e) => {
    if (e == 'editfile') {
      openEditMenu();
    }
    oldText.current = text;
    setClonedText(text);
    setModalOption(defaultModalOptions);
  };

  const handleCloseModal = (ele, arg) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      message: t(`Do you want to delete this ${arg}?`),
      yesOrNo: true,
      onNo: () => closeModelOption(),
      onYes: () => handleConfirm(true, ele),
      type: 'warning'
    });
  };

  function handleEnter(event) {
    if (event.keyCode === 13) {
      event.target.blur();
    }
  }

  const deleteUnitTop = (event, node) => {
    event.stopPropagation();
    setVisibleFeed(false);
    del_element_check = 1;
    handleCloseModal(node, 'unitop');
    localStorage.setItem('globalExitBtn', 'true');
    convasEmptyFun();
  };
  const deleteUnitTopgroupRAAFeed = (event, node) => {
    event.stopPropagation();
    if (node.id.replace(/[\d_]+/g, '') == 'groupRAAFeed') {
      setElements((prevElements) => {
        const updated = (prevElements ?? []).filter((el) => {
          return el.id !== node.id && el.parentNode !== node.id;
        });
        const hasGroupRAAFeed = updated.some(el => el.id.replace(/[\d_]+/g, '').includes('groupRAAFeed'));
        if (updated.length === 0 || !hasGroupRAAFeed) {
          groupFeeddAA.length = 0;
          withoutDuplicateWaterCompWithAA = false;
        }
        return updated;
      });
    }
    if (node.id.replace(/[\d_]+/g, '') == 'groupRAAFeed') {
      // c_feedAA.splice(c_feedAA.indexOf(Number(node.id.substring(node.id.indexOf('_') + 1))), 1);
      // c_feedAA.sort((a, b) => { return a - b; });
      // c_feed_AA.splice(c_feed_AA.indexOf(Number(node.id.substring(node.id.indexOf('_') + 1))), 1);
      // c_feed_AA.sort((a, b) => { return a - b; });
      c_box_Feed_AA.splice(c_box_Feed_AA.indexOf(Number(node.id.substring(node.id.indexOf('_') + 1))), 1);
      c_box_Feed_AA.sort((a, b) => { return a - b; });
      removeItemFromLocalStorage();
      localStorage.removeItem('Wateranalysis');
      localStorage.removeItem('Argo');
    }
  };
  const onMouseEnterNode = (e, id) => {
    if (preValFlag) {
      preValFlag = false;
      preVal = { 'target': e.target, 'val': e.target.value, 'id': id };
      // @sudarsana added styles for changing the name of unitops version 11
      e.target.style.outline = '1px solid rgb(0, 174, 199)';
      e.target.style.border = 'none';
      onClickElements = false;
    }
  };
  const onBluerNode = (e, id) => {
    const currentValue = e.target.value;
    const dataFlag = checkDuplicateValue(currentValue, id);
    if (dataFlag) {
      document.body.classList.add('duplicate');
      duplicateNodeFlag = true;
      openModelPopUp('Please provide a new name for the unitop as the current one is already available on the flowsheet.', 'Warning', 'warning');
    } else {
      if (currentValue !== preVal.val) {
        disabledStripperAndExplorerTab();
      }
      preValFlag = true;
      e.target.style.outline = 'none'; // @sudarsana Remove outline when editing ends in version11
      onClickElements = true;
    }
  };

  const closeModelOption = () => {
    if (handleClickStr === 'blank') {
      handleClick();
    } else if (handleClickStr === 'editfile') {
      handleClick('editfile');
    }
    if (!preValFlag) {
      returnDuplicateValue();
    } else {
      if (duplicateNodeFlag) {
        returnDuplicateValue();
      }
      setModalOption(defaultModalOptions);
    }
    document.body.classList.remove('duplicate');
    setCallExecuteFun(false);
    setFindAllConnection(false);
    updateControlsButtonTitle();
    const val = localStorage.getItem('streamDataHighlited');
    if (val) {
      if (val === 'less') {
        streamDataHighlited(buttonElement, 'less');
      } else {
        streamDataHighlited(buttonElement, '');
      }
    }
    localStorage.removeItem('streamDataHighlited');
    // TO do Project Info
    if (openProjectInfo && openPI_onNew_yes) {
      setVisiblePi(true);
    }
    const pinfo = localStorage.getItem('Pinfo');
    if (pinfo && pinfo == 'empty') {
      streamDataHighlited(projectInfo, 'empty');
    }
    localStorage.removeItem('Pinfo');
    openProjectInfo = false;
    openPI_onNew_yes = false;

    // CLRO access
    const CLROinfo = localStorage.getItem('CLROinfo');
    if (CLROinfo && CLROinfo == 'empty') {
      clearCanvas();
    }
    localStorage.removeItem('CLROinfo');
  };

  const returnDuplicateValue = () => {
    const { id, val, target } = preVal;
    localStorage.setItem(id, val);
    target.value = val;
    setModalOption(defaultModalOptions);
    preValFlag = true;
    if (duplicateNodeFlag) {
      document.body.classList.remove('duplicate');
      duplicateNodeFlag = false;
    }
    updateControlsButtonTitle();
  };
  const hoverSource = (e) => {
    e.target.style.transform = 'scale(2)';
    if (e.target.style.background === 'blue' || e.target.style.background === 'green')
      e.target.style.top = '45%';
    if (e.target.style.left === '50%')
      e.target.style.left = '45%';
    if (e.target.style.left === '70%')
      e.target.style.left = '65%';
    if (e.target.style.left === '30%')
      e.target.style.left = '20%';
  };
  const exithoverSource = (e) => {
    e.target.style.transform = 'scale(1)';
    if (e.target.style.background === 'blue' || e.target.style.background === 'green')
      e.target.style.top = '45%';
    if (e.target.style.left === '50%')
      e.target.style.left = '45%';
    if (e.target.style.left === '70%')
      e.target.style.left = '65%';
    if (e.target.style.left === '30%')
      e.target.style.left = '20%';
  };
  const getFlowSheetDataUrlImages = async (img) => {
    // written by and commented by chandrashekhar
    // uncomment code when image converted in white URL and add in google doc
    // Path:- components\pdf-options\jsontocsvConvertion.js line 1522 START

    // let imagePath = await getImagePath({ "base64_string": img });
    // if (imagePath && imagePath.data && imagePath.data.body) {
    //   imagePath = JSON.parse(imagePath.data.body);
    // }
    // imagePath = imagePath.presigned_url;
    // const imgWidthHeight = new Image();
    // imgWidthHeight.onload = () => {
    //   imagePath = { src: imagePath, width: imgWidthHeight.width / 1.5, height: imgWidthHeight.height / 1.5 };
    //   setFlowSheetImage(imagePath);
    //   fetchLoadingData({
    //     loader: false,
    //     data: '',
    //     msg: 'success',
    //     warningArr: executefetchLoadings.warningArr,
    //     img
    //   });
    //   document.querySelectorAll('.nodeimg').forEach((ele) => {
    //     const errorTag = ele.closest('.custom-node-element').querySelector('.unitop-error-icon-div');
    //     if (errorTag) {
    //       errorTag.classList.remove('hide-close');
    //     }
    //   });
    // };
    // imgWidthHeight.src = imagePath;
    // written by and commented by chandrashekhar
    // uncomment code when image converted in white URL and add in google doc
    // Path:- components\pdf-options\jsontocsvConvertion.js line 1522 END

    const imgWidthHeight = new Image();
    imgWidthHeight.onload = () => {
      const imagePath = { src: img, width: imgWidthHeight.width, height: imgWidthHeight.height };
      setFlowSheetImage(imagePath);
      fetchLoadingData({
        loader: false,
        data: '',
        msg: 'success',
        warningArr: executefetchLoadings.warningArr,
        img
      });
      document.querySelectorAll('.nodeimg').forEach((ele) => {
        const errorTag = ele.closest('.custom-node-element').querySelector('.unitop-error-icon-div');
        if (errorTag) {
          errorTag.classList.remove('hide-close');
        }
      });
    };
    imgWidthHeight.src = img;
  };
  // @chandrashaker and @sudarsana -GB-2534 - This is bug fixing function when we closing the file share Form and when click on excute buuton , execute file is not calling
  const setVisiblefileSharing = (str) => {
    setVisible_fileSharing(str);
    setFindAllConnection(str);
    setCallExecuteFun(str);
  };
  const CustomNode = (node) => {
    const { id, type } = node;
    let typeClro = '';
    if (type === 'customnode_CLROpump') {
      typeClro = 'CLRO';
    }
    ro_payloadData = {}; // karnthi added for this to solve the issue for split flow in resert and clear canvas for removal
    ro_dictData = {}; // @sudarsana added for this after reset and clear canvas that permeate pressure and interstage boostPump values should be clear
    if (localStorage.getItem('ro_payload')) {
      ro_payloadData = JSON.parse(localStorage.getItem('ro_payload'));
    };
    const ro_payloadData_Ro = ro_payloadData.ro || {};
    // @sudarsana taking the ro-dict from localstorage for implementing the permeate pressure and interstage boostPump for non-zero code changes
    if (localStorage.getItem('ro-dict')) {
      ro_dictData = JSON.parse(localStorage.getItem('ro-dict'));
    }
    const ro_dictData_Ro = ro_dictData.ro || {};
    const unitopCurrentId = id.replace(/[\d_]+/g, '');
    const checkUnitopExitsId = checkExitsLocalStorageValue(unitopCurrentId);
    // @sudarsana Removed animateNode function to prevent the expansion nodes in version 11
    if (unitopCurrentId == 'mixsplit') {
      // @sudarsana Changed the width and height in version 11
      $(`.Node_${id}`).css({ 'width': '38px' });
      $(`#${id} input[type=image]`).css({ 'width': '30', 'height': '20' });
    }
    // @sudarsana Changed the width and height in version 11
    // reduce the unitop width and image width ----> kranthi
    // @sudarsana added rectangle unitop changes saparately
    else if (unitopCurrentId != 'rectangle') {
      $(`.Node_${id}`).css({ 'width': '50px', 'display': 'flex', 'flex-flow': 'column', 'align-items': 'center' });
      // @sudarsana here added the height setting for edujustment for unitops GB-2285
      $(`#${id} input[type=image]`).css({ 'width': '30', 'height': `${(unitopCurrentId === 'feed' || unitopCurrentId == 'product' || unitopCurrentId == 'wasteout') ? '30' : '25'}` });
    } else {
      $(`.Node_${id}`).css({ 'width': '60px', 'height': '60px' });
      $(`#${id} input[type=image]`).css({ 'height': '150' });
    }
    // @sudarsana here for adding the images for permeate pressure and interstage boostPump , need to change the height and width in ro and pump
    if (unitopCurrentId === 'ro' || unitopCurrentId === 'roPump' || unitopCurrentId === 'nfPump' || unitopCurrentId === 'nf' || unitopCurrentId === 'RO-AO') {
      $(`.Node_${id}`).css({ 'width': '50px', 'display': 'flex', 'flex-flow': 'column', 'align-items': 'center' });
      $(`#${id} input[type=image]`).css({ 'width': '29', 'height': '22' });
    }
    $(`.Node_${id}`).parent().parent().css({ 'padding': '10px' });
    $(`.${id}`).css('display', 'block');

    if (unitopCurrentId == 'product' || unitopCurrentId == 'wasteout') {
      $(`.Node_${id}`).parent().parent().css('border-color', '#ddd');
    }
    // ############ stripper ################
    if (unitopCurrentId == 'stripper') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `STR_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleStripper(!val); // Hidding Stripper Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `STR_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              // Replaced onClick instand of OnMouseDown in version 11 @sudarsana
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_stripper" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`StripperText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes from ${e.target.defaultValue} to ${e.target.value}`); onBluerNode(e, id); }}
                  // onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to ${localValue} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `STR_${checkUnitopExitsId}`)}
                  onChange={(e) => { setStripperName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={stripperImage}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
        </div>
      );
    }
    // ############ Feed #################
    if (unitopCurrentId == 'feed') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `Feed_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleFeed(!val); // Hidding Feed Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `Feed_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_feed" style={{ marginTop: '-5px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag asdasds"
                  type="text"
                  id={`feedText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to Feed_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `Feed_${checkUnitopExitsId}`)}
                  onChange={(e) => { setFeedItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('flow_dict', JSON.stringify({})); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={Feed}
                width="50"
                height="40"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Outlet" style={{ background: 'blue' }} onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" />
          </Tooltip>
        </div>
      );
    }

    // ############ RO + pump #################
    if (unitopCurrentId == 'roPump') {
      default_pump_ro_connection.roID = id;
      const ro_payloadData_details = ro_payloadData_Ro[id] || {};
      const ro_dict_detials = ro_dictData_Ro[id] || {};
      const propertyName = 'argo_dict';
      const ro_argo_details = ro_payloadData_details[propertyName] || {};
      let display_roPump4th_node = false;
      if (ro_payloadData_details.split_flow) {
        if (ro_payloadData_details.split_flow === 0) {
          display_roPump4th_node = false;
        } else {
          display_roPump4th_node = true;
        }
      }
      // @sudarsana added the code for display_pressureVessels and display_BoostPressure when values are updated zero and non-zero values - start
      let display_pressureVessels = false;
      let display_BoostPressure = false;
      let display_argodetails = false;
      if (Object.keys(ro_dict_detials).length !== 0) {
        const grid_data = ro_dict_detials['grid-data'];
        for (let i = 0; i < grid_data.length; i++) {
          if (grid_data[i].permeatePressure == '0.00' || 0) {
            display_pressureVessels = false;
          } else {
            display_pressureVessels = true;
            break;
          }
        }
        for (let i = 0; i < grid_data.length; i++) {
          if (['0.00', 0, ''].indexOf(grid_data[i].interStageBoostPressure) >= 0) {
            // if (grid_data[i].interStageBoostPressure == '0.00' || 0) {
            display_BoostPressure = false;
          } else {
            display_BoostPressure = true;
            break;
          }
        }
      }
      // end
      if (Object.keys(ro_argo_details).length !== 0) {
        display_argodetails = ro_argo_details.argo_flag;
      }
      // // name changes for ERD in wex/pex by sudarsana
      // let ROPumpText = 'ROHP';
      let ROPump = 'ROHP';
      let flag = 'ropump';
      for (let i = 0; i < clro_all_unitop.length; i++) {
        if (default_pump_ro_connection.roID === clro_all_unitop[i].id) {
          // ROPumpText = 'CLRO';
          ROPump = 'CLRO';
          flag = 'clro';
        }
      }
      for (let i = 0; i < wexpex_all_unitop.length; i++) {
        if (default_pump_ro_connection.roID === wexpex_all_unitop[i].id) {
          // ROPumpText = 'ROERD';
          ROPump = 'ROERD';
          flag = 'wexpex';
          withoutDeletionDublicateERD = true;
        }
      }
      for (let i = 0; i < peltonwheel_all_unitop.length; i++) {
        if (default_pump_ro_connection.roID === peltonwheel_all_unitop[i].id) {
          // ROPumpText = 'ROPW';
          ROPump = 'ROPW';
          flag = 'peltonwheel';
          withoutDeletionDublicatePeltonWheel = true;
        }
      }
      for (let i = 0; i < turbocharger_all_unitop.length; i++) {
        if (default_pump_ro_connection.roID === turbocharger_all_unitop[i].id) {
          // ROPumpText = 'ROTC';
          ROPump = 'ROTC';
          flag = 'TC';
          withoutDeletionDublicateTurbo = true;
        }
      }
      let isShowError = false;// Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `${ROPump}_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      // if (unitop_name.includes('CLRO') || ROPump.includes('CLRO')) {
      if (typeClro === 'CLRO') {
        // ROPumpText = 'CLRO';
        ROPump = 'DSSRO';
        // ROPump = 'CLRO';
        flag = 'clro';
        // Declare a variable to hold payload data
        let clro_payloadData;
        // Check if there is any data stored in local storage under the key 'clro_payload'
        if (localStorage.getItem('clro_payload')) {
          // If there is, parse the JSON string into an object and assign it to clro_payloadData
          clro_payloadData = JSON.parse(localStorage.getItem('clro_payload'));
          // Access the 'ro' property of the payload data, or default to an empty object if it doesn't exist
          const clro_payloadData_Ro = clro_payloadData?.ro || {};
          // Access the property of the 'ro' object with the key equal to 'id', or default to an empty object if it doesn't exist
          const clro_payloadData_details = clro_payloadData_Ro[id] || {};
          // Define the property name to be accessed
          const propertyName = 'argo_dict';
          // Access the 'argo_dict' property of the details object, or default to an empty object if it doesn't exist
          const clro_argo_details = clro_payloadData_details[propertyName] || {};
          // If the 'argo_dict' object is not empty
          if (Object.keys(clro_argo_details).length !== 0) {
            // Access the 'argo_flag' property of the 'argo_dict' object and assign it to 'display_argodetails'
            display_argodetails = clro_argo_details.argo_flag;
          }
        };
      }
      const report_visibility = (event, val) => {
        setVisibleRo(!val); // Hidding Ro Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = (localStorage.getItem(id) ? localStorage.getItem(id) : `${ROPump}_${id.replace(/\D/g, '')}`);
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_roPump" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`ROPumpText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to ${ROPump}_${id.replace(/\D/g, '')} `); onBluerNode(e, id); }}
                  // @sudarsana increment does not happen correctly issue fixes added id.replace(/\D/g, '')}`
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `${ROPump}_${id.replace(/\D/g, '')}`)}
                  onChange={(e) => {
                    setRoPumpItemName(e.target.value);
                    localStorage.setItem(id, e.target.value);
                    localStorage.setItem('flow_dict', JSON.stringify({}));
                    localStorage.setItem('globalExitBtn', 'true');
                    setChecked(false);
                  }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={RO}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
            {/* @sudarsana added the html tag to display the images of pressure icon and boost icon  */}
            <span className={id} >
              {display_BoostPressure &&
                <img style={{ position: 'absolute', bottom: '-17px', left: '-14px' }} className='UnitopName a' src={boostIcon} />
              }
              {display_pressureVessels &&
                <img style={{ position: 'absolute', bottom: '-17px', right: '-14px' }} className='UnitopName b' src={pressureIcon} />
              }
              {display_argodetails &&
                <img style={{ position: 'absolute', top: '-12px', left: '-14px' }} className='UnitopName c' src={ArgoIcon} />
              }
              {
                // ROPumpText === 'CLRO' &&
                typeClro === 'CLRO' &&
                <img style={{ position: 'absolute', bottom: '-17px', left: '-14px' }} className='UnitopName d' src={clroboostIcon} />
              }
            </span>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
          <Tooltip title="Waste" >
            <Handle id="d" type="source" position="bottom" style={{ background: 'red' }} />
          </Tooltip>
          {/* @sudarsana Re-Rendering is not happening in version 11 so changed display_roPump4th_node logic */}
          <Tooltip title="split flow" >
            <Handle id="s" className='cls_e' type="source" position="top" style={{ background: 'black', opacity: display_roPump4th_node ? '1' : '0' }} />
          </Tooltip>
          {(isPeltonWheel) && (flag === 'peltonwheel') && <> {
            validate_onNewConnect_PW({ source: id, sourceHandle: 'd', target: `${peltonwheel_connection.roID}`, targetHandle: 'a_pw' })
          } </>
          }
          {(isturbocharger) && (flag === 'TC') && <> {
            validate_onNewConnect_TC({ source: id, sourceHandle: 'd', target: `${turbocharger_connection.roID}`, targetHandle: 'c_tc' })
          } </>
          }
        </div>
      );
    }
    // ############ NF + pump #################
    if (unitopCurrentId == 'nfPump') {
      default_pump_ro_connection.roID = id;
      const ro_payloadData_details = ro_payloadData_Ro[id] || {};
      const ro_dict_detials = ro_dictData_Ro[id] || {};
      const propertyName = 'argo_dict';
      const ro_argo_details = ro_payloadData_details[propertyName] || {};
      let display_roPump4th_node = false;
      if (ro_payloadData_details.split_flow) {
        if (ro_payloadData_details.split_flow === 0) {
          display_roPump4th_node = false;
        } else {
          display_roPump4th_node = true;
        }
      }
      // @sudarsana added the code for display_pressureVessels and display_BoostPressure when values are updated zero and non-zero values - start
      let display_pressureVessels = false;
      let display_BoostPressure = false;
      let display_argodetails = false;
      if (Object.keys(ro_dict_detials).length !== 0) {
        const grid_data = ro_dict_detials['grid-data'];
        for (let i = 0; i < grid_data.length; i++) {
          if (grid_data[i].permeatePressure == '0.00' || 0) {
            display_pressureVessels = false;
          } else {
            display_pressureVessels = true;
            break;
          }
        }
        for (let i = 0; i < grid_data.length; i++) {
          if (['0.00', 0, ''].indexOf(grid_data[i].interStageBoostPressure) >= 0) {
            // if (grid_data[i].interStageBoostPressure == '0.00' || 0) {
            display_BoostPressure = false;
          } else {
            display_BoostPressure = true;
            break;
          }
        }
      }
      // end
      if (Object.keys(ro_argo_details).length !== 0) {
        display_argodetails = ro_argo_details.argo_flag;
      }
      const ROPump = 'NFHP';
      const flag = 'nfpump';
      let isShowError = false;// Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `${ROPump}_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleNF(!val); // Hidding Ro Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = (localStorage.getItem(id) ? localStorage.getItem(id) : `${ROPump}_${id.replace(/\D/g, '')}`);
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_roPump" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`ROPumpText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to ${ROPump}_${id.replace(/\D/g, '')} `); onBluerNode(e, id); }}
                  // @sudarsana increment does not happen correctly issue fixes added id.replace(/\D/g, '')}`
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `${ROPump}_${id.replace(/\D/g, '')}`)}
                  onChange={(e) => {
                    setRoPumpItemName(e.target.value);
                    localStorage.setItem(id, e.target.value);
                    localStorage.setItem('flow_dict', JSON.stringify({}));
                    localStorage.setItem('globalExitBtn', 'true');
                    setChecked(false);
                  }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={RO}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
            {/* @sudarsana added the html tag to display the images of pressure icon and boost icon  */}
            <span className={id} >
              {display_BoostPressure &&
                <img style={{ position: 'absolute', bottom: '-17px', left: '-14px' }} className='UnitopName a' src={boostIcon} />
              }
              {display_pressureVessels &&
                <img style={{ position: 'absolute', bottom: '-17px', right: '-14px' }} className='UnitopName b' src={pressureIcon} />
              }
              {display_argodetails &&
                <img style={{ position: 'absolute', top: '-12px', left: '-14px' }} className='UnitopName c' src={ArgoIcon} />
              }
              {/* {
                // ROPumpText === 'CLRO' &&
                typeClro === 'CLRO' &&
                <img style={{ position: 'absolute', bottom: '-17px', left: '-14px' }} className='UnitopName d' src={clroboostIcon} />
              } */}
            </span>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
          <Tooltip title="Waste" >
            <Handle id="d" type="source" position="bottom" style={{ background: 'red' }} />
          </Tooltip>
          {/* @sudarsana Re-Rendering is not happening in version 11 so changed display_roPump4th_node logic */}
          <Tooltip title="split flow" >
            <Handle id="s" className='cls_e' type="source" position="top" style={{ background: 'black', opacity: display_roPump4th_node ? '1' : '0' }} />
          </Tooltip>
          {/* {(isPeltonWheel) && (flag === 'peltonwheel') && <> {
            validate_onNewConnect_PW({ source: id, sourceHandle: 'd', target: `${peltonwheel_connection.roID}`, targetHandle: 'a_pw' })
          } </>
          }
          {(isturbocharger) && (flag === 'TC') && <> {
            validate_onNewConnect_TC({ source: id, sourceHandle: 'd', target: `${turbocharger_connection.roID}`, targetHandle: 'c_tc' })
          } </>
          } */}
        </div>
      );
    }
    // ################ RO #####################
    if (unitopCurrentId == 'ro') {
      ro_connection.roID = id;
      const ro_payloadData_details = ro_payloadData_Ro[id] || {};
      const ro_dict_detials = ro_dictData_Ro[id] || {};
      const propertyName = 'argo_dict';
      const ro_argo_details = ro_payloadData_details[propertyName] || {};
      let display_cls4th_node = false;
      if (ro_payloadData_details.split_flow) {
        if (ro_payloadData_details.split_flow === 0) {
          display_cls4th_node = false;
        } else {
          display_cls4th_node = true;
        }
      }
      // @sudarsana added the code for display_pressureVessels and display_BoostPressure when values are updated zero and non-zero values - start
      let display_pressureVessels = false;
      let display_BoostPressure = false;
      let display_argodetails = false;
      if (Object.keys(ro_dict_detials).length !== 0) {
        const grid_data = ro_dict_detials['grid-data'];
        for (let i = 0; i < grid_data.length; i++) {
          if (grid_data[i].permeatePressure == '0.00' || 0) {
            display_pressureVessels = false;
          } else {
            display_pressureVessels = true;
            break;
          }
        }
        for (let i = 0; i < grid_data.length; i++) {
          // if (grid_data[i].interStageBoostPressure == '0.00' || 0) {
          if (['0.00', 0, ''].indexOf(grid_data[i].interStageBoostPressure) >= 0) {
            display_BoostPressure = false;
          } else {
            display_BoostPressure = true;
            break;
          }
        }
      }
      if (Object.keys(ro_argo_details).length !== 0) {
        display_argodetails = ro_argo_details.argo_flag;
      }
      // end
      let isShowError = false;// Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `RO_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleRo(!val); // Hidding Ro Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `RO_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_cls" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`ROText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to RO_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `RO_${checkUnitopExitsId}`)}
                  onChange={(e) => { setROItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('flow_dict', JSON.stringify({})); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={RO}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
            {/* @sudarsana added the html tag to display the images of pressure icon and boost icon  */}
            <span className={id} >
              {display_BoostPressure &&
                <img style={{ position: 'absolute', bottom: '-17px', left: '-14px' }} className='UnitopName e' src={boostIcon} />
              }
              {display_pressureVessels &&
                <img style={{ position: 'absolute', bottom: '-17px', right: '-14px' }} className='UnitopName f' src={pressureIcon} />
              }
              {display_argodetails &&
                <img style={{ position: 'absolute', top: '-12px', left: '-14px' }} className='UnitopName g' src={ArgoIcon} />
              }
            </span>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
          <Tooltip title="Waste" >
            <Handle id="d" type="source" position="bottom" style={{ background: 'red' }} />
          </Tooltip>
          {/* @sudarsana RO SplitFlow */}
          <Tooltip title="split flow">
            <Handle id="s" className='cls_e' type="source" position="top" style={{ background: 'black', opacity: display_cls4th_node ? '1' : '0' }} />
          </Tooltip>
        </div>
      );
    }
    // ################ RO #####################
    if (unitopCurrentId == 'nf') {
      ro_connection.roID = id;
      const ro_payloadData_details = ro_payloadData_Ro[id] || {};
      const ro_dict_detials = ro_dictData_Ro[id] || {};
      const propertyName = 'argo_dict';
      const ro_argo_details = ro_payloadData_details[propertyName] || {};
      let display_cls4th_node = false;
      if (ro_payloadData_details.split_flow) {
        if (ro_payloadData_details.split_flow === 0) {
          display_cls4th_node = false;
        } else {
          display_cls4th_node = true;
        }
      }
      // @sudarsana added the code for display_pressureVessels and display_BoostPressure when values are updated zero and non-zero values - start
      let display_pressureVessels = false;
      let display_BoostPressure = false;
      let display_argodetails = false;
      if (Object.keys(ro_dict_detials).length !== 0) {
        const grid_data = ro_dict_detials['grid-data'];
        for (let i = 0; i < grid_data.length; i++) {
          if (grid_data[i].permeatePressure == '0.00' || 0) {
            display_pressureVessels = false;
          } else {
            display_pressureVessels = true;
            break;
          }
        }
        for (let i = 0; i < grid_data.length; i++) {
          // if (grid_data[i].interStageBoostPressure == '0.00' || 0) {
          if (['0.00', 0, ''].indexOf(grid_data[i].interStageBoostPressure) >= 0) {
            display_BoostPressure = false;
          } else {
            display_BoostPressure = true;
            break;
          }
        }
      }
      if (Object.keys(ro_argo_details).length !== 0) {
        display_argodetails = ro_argo_details.argo_flag;
      }
      // end
      let isShowError = false;// Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `NF_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleNF(!val); // Hidding Ro Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `NF_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_cls" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`ROText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to NF_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `NF_${checkUnitopExitsId}`)}
                  onChange={(e) => { setROItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('flow_dict', JSON.stringify({})); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={RO}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
            {/* @sudarsana added the html tag to display the images of pressure icon and boost icon  */}
            <span className={id} >
              {display_BoostPressure &&
                <img style={{ position: 'absolute', bottom: '-17px', left: '-14px' }} className='UnitopName e' src={boostIcon} />
              }
              {display_pressureVessels &&
                <img style={{ position: 'absolute', bottom: '-17px', right: '-14px' }} className='UnitopName f' src={pressureIcon} />
              }
              {display_argodetails &&
                <img style={{ position: 'absolute', top: '-12px', left: '-14px' }} className='UnitopName g' src={ArgoIcon} />
              }
            </span>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
          <Tooltip title="Waste" >
            <Handle id="d" type="source" position="bottom" style={{ background: 'red' }} />
          </Tooltip>
          {/* @sudarsana RO SplitFlow */}
          <Tooltip title="split flow">
            <Handle id="s" className='cls_e' type="source" position="top" style={{ background: 'black', opacity: display_cls4th_node ? '1' : '0' }} />
          </Tooltip>
        </div>
      );
    }

    if (unitopCurrentId == 'Wateranalysis') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `Wateranalysis`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleFeed(!val); // Hidding Feed Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `Wateranalysis`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          {/* <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div> */}
          <div id="unitop_Wateranalysis" style={{ marginTop: '-5px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag asdasds"
                  type="text"
                  id={`Wateranalysis${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to Wateranalysis `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : groupFeeddAA.length > 0 ? localStorage.setItem(id, `Wateranalysis`) : ''}
                  onChange={(e) => { setFeedForAA(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('flow_dict', JSON.stringify({})); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={Feed}
                width="50"
                height="40"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          {/* <Tooltip title="Outlet" style={{ background: 'blue' }} onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" />
          </Tooltip> */}
        </div>
      );
    }
    if (unitopCurrentId == 'Argo') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `Argo`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisiableAAWithFeed(!val); // Hidding Feed Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `Argo`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          {/* <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div> */}
          <div id="unitop_feed_AA" style={{ marginTop: '-5px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag asdasds"
                  type="text"
                  id={`AOText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to Argo `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : groupFeeddAA.length > 0 ? localStorage.setItem(id, `Argo`) : ''}
                  onChange={(e) => { AATextwithFeed(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('flow_dict', JSON.stringify({})); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={RO}
                width="50"
                height="40"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
            <span className={id} >
              <img style={{ position: 'absolute', top: '-12px', left: '-14px' }} className='UnitopName c' src={ArgoIcon} />
            </span>
          </div>
          {/* <Tooltip title="Outlet" style={{ background: 'blue' }} onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" />
          </Tooltip> */}
        </div>
      );
    }
    if (unitopCurrentId == 'HorizentalStripper') {
      return (
        <div className="custom-node-element">
          <div id="unitop_rectangle">
            <div className='nodeimg1' id={id}>
              <img
                className="nodrag"
                src={horizentalStripper}
                width='200%'
                height='7px'
              />
            </div>
          </div>
        </div>
      );
    }
    // ############ HP Pump #################
    if (unitopCurrentId == 'hppump') {
      pump_connection.roID = id;
      unitopdelete.push(pump_connection.roID);
      const filteredKeys = Object.keys(connectionInfo).filter(key => !key.startsWith('peltonwheel'));
      const filteredObject = Object.fromEntries(filteredKeys.map(key => [key, connectionInfo[key]]));
      const result = {};
      const keysOfB = Object.keys(filteredObject);
      for (let i = 0; i < keysOfB.length; i++) {
        const key = keysOfB[i];
        if (Object.prototype.hasOwnProperty.call(filteredObject, key) && Object.prototype.hasOwnProperty.call(connectionInfo, key) && connectionInfo[key] === filteredObject[key]) {
          result[key] = filteredObject[key];
        }
      }
      connectionInfo = result;
      let isShowError = false;// Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `HPP_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleHpPump(!val); // Hidding HP Pump Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `HPP_${id.replace(/\D/g, '')}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div id="unitop_hppump" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`} >
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`HP_PumpText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to HPP_${id.replace(/\D/g, '')} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `HPP_${id.replace(/\D/g, '')}`)}
                  onChange={(e) => { setHP_PumpItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={Pump}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative', marginRight: '-3px' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
          {/* Change in code by Akhil on 11th Sept: to remove dependency of flags bcs of the getting conflict issues */}
          {isRoPump ? validate_onConnect_roPump() : ''}
          {isNfPump ? validate_onConnect_nfPump() : ''}
          {isclro ? validate_onConnect_clro() : ''}
          {isPeltonWheel ? validate_onNewConnect_PW({ source: id, sourceHandle: 'c', target: `roPump_${id_roPump - 1}`, targetHandle: 'a' }) : ''}
          {isturbocharger ? validate_onNewConnect_TC({ source: id, sourceHandle: 'c', target: `TC_${id_Turbo_Charger - 1}`, targetHandle: 'a_tc' }) : ''}
        </div>
      );
    }

    // ############ pump #################
    if (unitopCurrentId == 'pump') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `Pump_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0;// Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisiblePump(!val); // Hidding Pump Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `Pump_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_pump" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`PumpText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to Pump_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `Pump_${checkUnitopExitsId}`)}
                  onChange={(e) => { setPumpItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={Pump}
                style={{ zIndex: '-9', position: 'relative', marginRight: '-3px', width: '30px', height: '25px' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
        </div>
      );
    }
    // ############ EDI #################
    if (unitopCurrentId == 'edi') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `EDI_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleEDI(!val); // Hidding EDI Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `EDI_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_edi" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`EDIText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to EDI_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `EDI_${checkUnitopExitsId}`)}
                  onChange={(e) => { setEDIItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('flow_dict', JSON.stringify({})); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={EDI}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
          <Tooltip title="Electrode" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="e" type="source" position="bottom" style={{ background: 'red', left: '70%' }} />
          </Tooltip>
          <Tooltip title="Concentrate" >
            <Handle id="f" type="source" position="bottom" style={{ background: 'red', left: '30%' }} />
          </Tooltip>
        </div>
      );
    }
    // ############ Product Out #################
    if (unitopCurrentId == 'product') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `Product_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `Product_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_product" style={{ marginTop: '-5px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`ProductText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to Product_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `Product_${checkUnitopExitsId}`)}
                  onChange={(e) => { setProductItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('flow_dict', JSON.stringify({})); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={ProductOut}
                width="50"
                height="40"
                style={{ zIndex: '-9', position: 'relative', marginTop: '1px' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green', marginTop: '0.5px' }} />
          </Tooltip>
        </div>
      );
    }

    // ############ Waste Out #################
    if (unitopCurrentId == 'wasteout') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `Waste_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `Waste_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_wasteout" style={{ marginTop: '-5px' }} className={`Node_${id}`} >
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`WasteOutText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to Waste_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `Waste_${checkUnitopExitsId}`)}
                  onChange={(e) => { setWasteOutItemName(e.target.value); localStorage.setItem(id, e.target.value); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={WasteOut}
                width="50"
                height="40"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green', marginTop: '1px' }} />
          </Tooltip>
        </div>
      );
    }

    // ############ Mixer/Splitter #################
    if (unitopCurrentId == 'mixsplit') {
      mixSplit_connection.roID = id;
      unitopdelete.push(mixSplit_connection.roID);
      default_pump_ro_connection.roID = `roPump_${id_roPump - 1}`;
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `MixSplit_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleSplit(!val); // Hidding MixSplit Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `MixSplit_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_mixsplit" style={{ marginTop: '-5px' }} className={`Node_${id}`} >
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`MixSplitText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to MixSplit_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `MixSplit_${checkUnitopExitsId}`)}
                  onChange={(e) => { setMixSplitItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={MixSplit}
                width="32"
                height="25"
                style={{ zIndex: '-9', position: 'relative', marginTop: '-2px' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green', marginTop: '6px' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue', marginTop: '6px' }} />
          </Tooltip>
        </div>
      );
    }
    // ############ Cartridge #################
    if (unitopCurrentId == 'cartridge') {
      getBorderColor(id);
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `CF_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0;
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleCF(!val); // Hidding Cartridge Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val);// show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `CF_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_cartridge" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`} >
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`CartridgeText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to CF_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `CF_${checkUnitopExitsId}`)}
                  onChange={(e) => { setCartridgeItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={CF_new}
                width="55"
                height="40"
                style={{ zIndex: '-9', position: 'relative', marginLeft: '-3px' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
        </div>
      );
    }
    // ############ Chemical Dosing #################
    if (unitopCurrentId == 'chemicaldosing') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const selectedJsonValues = {
        "Sulfuric Acid": "H<sub>2</sub>SO<sub>4</sub>",
        "Hydrochloric Acid": "HCl",
        "Phosphoric Acid": "H<sub>3</sub>PO<sub>4</sub>",
        "Nitric Acid": "HNO<sub>3</sub>",
        "Carbon Dioxide": "CO<sub>2</sub>",
        "Ammonia": "NH<sub>3</sub>",
        "Caustic Soda": "NaOH",
        "Slaked Lime": "Ca(OH)<sub>2</sub>",
        "Sodium Carbonate": "Na<sub>2</sub>CO<sub>3</sub>",
        "Calcium Carbonate": "CaCO<sub>3</sub>",
        "Sodium Sulfate": "Na<sub>2</sub>SO<sub>4</sub>",
        "Sodium Cycle Softener": "Na-X"
      };
      let chemicalDosingName = '';
      try {
        const dosingDict = JSON.parse(localStorage.getItem('dosing-dict') || '{}');
        chemicalDosingName = dosingDict?.Chemical_Dosing?.[id]?.dosing_chemical || '';
      } catch (error) {
        console.error("Error getting chemical dosing data:", error);
      }
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `Dose_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0;
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleDosing(!val); // Hidding Chemocal Dosing Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `Dose_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}  {/* eslint-disable-next-line */}
          {chemicalDosingName && <div className="unitop-error-icon-div dosing-show"><Button variant="outlined" className='left_warning'><span dangerouslySetInnerHTML={{ __html: selectedJsonValues[chemicalDosingName] }} /></Button></div>}
          <div className="unitop-close-icon-div">
            <IconButton
              aria-label="new"
              onClick={(e) => deleteUnitTop(e, node)}
              size="small"
              className="unitop-close-icon"
            >
              X
            </IconButton>
          </div>
          <div id="unitop_chemical_dosing" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`}>
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`Chemical_DosingText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to Dose_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `Dose_${checkUnitopExitsId}`)}
                  onChange={(e) => { setChemicalDosingItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={Chemical_Dosing}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c" type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
        </div>
      );
    }
    // ############ WEX/PEX #################
    if (unitopCurrentId == 'wex') {
      wexpex_connection.roID = id;
      unitopdelete.push(wexpex_connection.roID);
      wex_call_count++;
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `ERD_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleWorkExchanger(!val); // Hidding WorkExechanger and Pressure EXechanger Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `ERD_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          {c_wex.length === 0 || c_wex.length > 0 ?
            (<div />) :
            <div className="unitop-close-icon-div">
              <IconButton
                aria-label="new"
                onClick={(e) => deleteUnitTop(e, node)}
                size="small"
                className="unitop-close-icon"
              >
                X
              </IconButton>
            </div>
          }
          <div id="unitop_chemical_dosing" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`} >
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`Wex_PexText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to ERD_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `ERD_${checkUnitopExitsId}`)}
                  onChange={(e) => { setwexpexItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={ERD}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a_w" type="target" position="left" style={{ background: '#008000', top: '70%' }} />
          </Tooltip>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="b_w" type="source" position="left" style={{ background: '#0000ff', top: '30%' }} />
          </Tooltip>
          <Tooltip title="Waste" >
            <Handle id="d_w" type="source" position="right" style={{ background: 'red', top: '81%' }} />
          </Tooltip>
          <Tooltip title="RO_Waste" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c_w" type="target" position="right" style={{ background: 'red', top: '30%' }} />
          </Tooltip>
          {wex_call_count === 1 ? validate_onConnect() : ''}
          {/* code to remove delete icon from unitops related to WEX/PEX subnetwork since */}
        </div>
      );
    }
    // ########### Pelton Wheel by sudarsana #############
    if (unitopCurrentId == 'peltonwheel') {
      // In connectioninfo 'peltonwheel' making to remove by sudarsana
      const filteredKeys = Object.keys(connectionInfo).filter(key => !key.startsWith('peltonwheel'));
      const filteredObject = Object.fromEntries(filteredKeys.map(key => [key, connectionInfo[key]]));
      const result = {};
      const keysOfB = Object.keys(filteredObject);
      for (let i = 0; i < keysOfB.length; i++) {
        const key = keysOfB[i];
        if (Object.prototype.hasOwnProperty.call(filteredObject, key) && Object.prototype.hasOwnProperty.call(connectionInfo, key) && connectionInfo[key] === filteredObject[key]) {
          result[key] = filteredObject[key];
        }
      }
      connectionInfo = result;
      peltonwheel_connection.roID = id;
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `PW_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleWorkExchanger(!val); // Hidding WorkExechanger and Pressure EXechanger Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `PW_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div id="unitop_chemical_dosing" style={{ marginTop: '-5px', height: '53px' }} className={`Node_${id}`} >
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`TC_PWText${id}`}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to PW_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `PW_${checkUnitopExitsId}`)}
                  onChange={(e) => { setwexpexItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={PW}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Waste" >
            <Handle id="d" type="source" position="right" style={{ background: 'red', top: '70%' }} />
          </Tooltip>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a_pw" type="target" position="right" style={{ background: 'red', top: '30%' }} />
          </Tooltip>
        </div>
      );
    }
    // ########### Turbo Charger by sudarsana #############
    if (unitopCurrentId == 'TC') {
      turbocharger_connection.roID = id;
      unitopdelete.push(turbocharger_connection.roID);
      let isShowError = false;// Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `TC_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleWexPex(!val); // Hidding Turbo charger Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val);  // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `TC_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div id="unitop_chemical_dosing" style={{ marginTop: '-5px', height: '53px' }} className={`Node_${id}`} >
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`TC_Text${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 8, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to TC_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `TC_${checkUnitopExitsId}`)}
                  onChange={(e) => { setwexpexItemName(e.target.value); localStorage.setItem(id, e.target.value); localStorage.setItem('globalExitBtn', 'true'); setChecked(false); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={TC}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Outlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="b_tc" className='cls_e' type="source" position="top" style={{ background: '#0000ff' }} />
          </Tooltip>
          <Tooltip title="Inlet" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="a_tc" type="target" position="left" style={{ background: '#0000ff', top: '30%' }} />
          </Tooltip>
          <Tooltip title="Waste" >
            <Handle id="d_tc" type="source" position="right" style={{ background: 'red', top: '70%' }} />
          </Tooltip>
          <Tooltip title="RO_Waste" onMouseOver={(e) => { hoverSource(e); }} onMouseLeave={(e) => { exithoverSource(e); }}>
            <Handle id="c_tc" type="target" position="right" style={{ background: 'red', top: '30%' }} />
          </Tooltip>
          {isturbocharger && <>
            {validate_onNewConnect_TC({ source: id, sourceHandle: 'b_tc', target: `roPump_${id_roPump - 1}`, targetHandle: 'a' })}
          </>
          }
        </div>
      );
    }
    if (unitopCurrentId == 'groupROHP') {
      return (
        <div className="" style={{ display: 'none' }} />
      );
    }
    if (unitopCurrentId == 'groupNFHP') {
      return (
        <div className="" style={{ display: 'none' }} />
      );
    }
    if (unitopCurrentId == 'groupRAAFeed') {
      if (groupFeeddAA.length > 0) {
        withoutDuplicateWaterCompWithAA = true;
      }
      return (
        <div className="unitop-close-icon-div">
          <IconButton
            aria-label="new"
            onClick={(e) => deleteUnitTopgroupRAAFeed(e, node)}
            size="small"
            className="unitop-close-icon-AAFeed"
          >
            X
          </IconButton>
        </div>
      );
    }
    if (unitopCurrentId == 'rectangle') {
      return (
        <div className="custom-node-element">
          <div id="unitop_rectangle">
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={rectangle}
                width='50%'
                height='137px'
              />
            </div>
          </div>
        </div>
      );
    }
    // @sudarsana added boosterpump return statement
    if (unitopCurrentId == 'boosterpump') {
      let isShowError = false; // Setting Errors and Warning icons to hidden
      const unitop_name = localStorage.getItem(id) ? localStorage.getItem(id) : `Booster_${checkUnitopExitsId}`; // Gettign UnitopName
      const unitop_errors = error_details_info.length >= 1 ? error_details_info.filter(d => d.name === unitop_name) : []; // Getting No. of. specific Unitop Errors
      const unitop_index = error_details_info.length >= 1 ? error_details_info.findIndex(d => d.name === unitop_name) : 0; // Getting Index of specific Unitop Errors
      if (error_details_info.length >= 1 && unitop_errors.length >= 1) { // Setting Errors and Warning icons to show when Errors are avaliable only.
        isShowError = true;
      };
      const report_visibility = (event, val) => {
        setVisibleWorkExchanger(!val); // Hidding WorkExechanger and Pressure EXechanger Model Popup
        event.stopPropagation();
        event.preventDefault();
        setActiveIndexVal(unitop_index); // updating index values in Errors window
        setVisiableError(val); // show Errors Window
      };
      // Fixing the bug issue GB-2518 @sudarsana
      const localValue = localStorage.getItem(id) ? localStorage.getItem(id) : `Booster_${checkUnitopExitsId}`;
      return (
        <div className="custom-node-element">
          {isShowError && <Reportunitop error_details_info={error_details_info} error_unitop_info={unitop_name} report_visibility={report_visibility} />}
          <div id="unitop_chemical_dosing" style={{ marginTop: '-5px', height: '50px' }} className={`Node_${id}`} >
            <div className={id} style={{ display: 'none', width: '-webkit-fill-available' }} id='tooltip'>
              <Tooltip title={localValue} placement="top" arrow>
                <input
                  className="nodrag"
                  type="text"
                  id={`boosterpumpText${id}`}
                  key={localValue}
                  style={{
                    marginTop: '-10px', width: '-webkit-fill-available', height: 10, fontSize: 7.3, border: 'none',
                    textAlign: 'center'
                  }}
                  autoComplete='off'
                  onFocus={(e) => { onMouseEnterNode(e, id); }}
                  onBlur={(e) => { jsLogger.info(`${id} UnitOps Name Text changes to Booster_${checkUnitopExitsId} `); onBluerNode(e, id); }}
                  placeholder={localStorage.getItem(id) ? null : localStorage.setItem(id, `Booster_${checkUnitopExitsId}`)}
                  onChange={(e) => { setwexpexItemName(e.target.value); localStorage.setItem(id, e.target.value); }}
                  onKeyDown={handleEnter}
                  onMouseOver={(e) => { e.target.style.color = '#0679CC'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#000'; }}
                  defaultValue={localValue}
                />
              </Tooltip>
            </div>
            <div className='nodeimg' id={id}>
              <input
                className="nodrag"
                type="image"
                src={Pump}
                width="48"
                height="36"
                style={{ zIndex: '-9', position: 'relative' }}
              />
            </div>
          </div>
          <Tooltip title="Inlet" >
            <Handle id="a_bp" type="target" position="left" style={{ background: 'green' }} />
          </Tooltip>
          {/* @sudarsana Re-Rendering is not happening in version 11 so changed display_roPump4th_node logic */}
          <Tooltip title="Outlet" >
            <Handle id="c" className='cls_e' type="source" position="right" style={{ background: 'blue' }} />
          </Tooltip>
        </div>
      );
    }
    updateControlsButtonTitle();
  };

  // Added useMemo hook to avoid the re-render in version 11 @sudarsana
  const nodeTypes = useMemo(() => ({
    customnode_feed: CustomNode,
    customnode_edi: CustomNode,
    customnode_productOut: CustomNode, // ro
    customnode_productOut_NF: CustomNode, // NF
    customnode_product: CustomNode,
    customnode_wasteout: CustomNode,
    customnode_mixsplit: CustomNode,
    customnode_cartridge: CustomNode,
    customnode_pump: CustomNode,
    customnode_pump_hp: CustomNode,
    customnode_ROpump: CustomNode, // ro_pump
    customnode_NFpump: CustomNode, // NFHP
    customnode_Feed_AO: CustomNode,
    customnode_CLROpump: CustomNode,
    customnode_stripper: CustomNode,
    customnode_chemical_dosing: CustomNode,
    customnode_WEX_PEX: CustomNode,
    customnode_Pelton_Wheel: CustomNode,
    customnode_Turbo_Charger: CustomNode,
    customnode_RO_HP_group: CustomNode,    // creted  group Ro_HP in version 11 @sudarsana
    customnode_NF_HP_group: CustomNode,    // creted  group Ro_HP in version 11 @sudarsana
    customnode_Feed_AO_group: CustomNode,
    customnode_Wateranalysis: CustomNode,
    customnode_Argo: CustomNode,
    customnode_rectangle: CustomNode,
    customnode_horizental: CustomNode,    // creted image rectangle in version 11 @sudarsana
    customnode_boosterPump: CustomNode,  // creted boosterpump in version 11 @sudarsana
  }), []);

  const saveFeedInputForm = (filename, email, type) => {
    filename = filename.trim();
    if (type == 'share') {
      setState_loader({ showResults: false });
      setSelectedFileName(filename);
      openModelPopUp(t('File shared successfully!.'), 'Success!', 'success');
    } else {
      setState_loader({ showResults: false });
      setSelectedFileName(filename);
      if (type == 'share') {
        openModelPopUp(t('File shared successfully!.'), 'Success!', 'success');
      } else {
        const oldFilesAr = getMyAndSharedFile();
        curFnaam = `${filename}.json`;
        if (oldFilesAr && curFnaam && oldFilesAr[curFnaam]) {
          oldFilesAr[curFnaam].created_on = (oldFilesAr[curFnaam].created_on).trim() ? oldFilesAr[curFnaam].created_on : getCurrentDate();
          oldFilesAr[curFnaam].last_edited_on = getCurrentDate();
          setMyAndSharedFile(oldFilesAr); // reset my&sahredFile
        } else {
          const pinf = JSON.parse(localStorage.getItem('project_info'));
          const obj = { ...pinf, notes: '', unittop_sneak_peak_view: {}, filename: `${pinf.project_name}.json` };
          const key = `${pinf.project_name}.json`;
          oldFilesAr[key] = obj;
          setMyAndSharedFile({ ...oldFilesAr }); // reset my&sahredFile
        }
        localStorage.setItem('globalExitBtn', 'false');
        isFileSaved = true;
        if (newFileFlag) {
          openModelPopUp(t('File saved successfully.'), t('Successfully Done'), 'success');
          setAfterSavingClick(true);
          clearCanvas();
        } else {
          // adding by chandrashekhar when user click on save button after changing a file name GB-2485
          setSaveTrigger(false);
          setAfterSavingClick(true);
          // let replceUrl = window.location.href.split('?');
          // replceUrl[1] = `${filename}.json`;
          // replceUrl = replceUrl.join('?');
          // window.history.pushState({}, null, replceUrl);
          // window.history.replaceState({}, null, replceUrl);
          openModelPopUp(t('File saved successfully.'), t('Successfully Done'), 'success');
          // adding by chandrashekhar when user click on save button after changing a file name GB-2485
        }
      }
    }
  };

  // const saveFile = (fileName, email, flowsheetData, type) => {
  //   setState_loader({ showResults: true });
  //   axios({
  //     method: 'post',
  //     url: `https://fzdb4yphq8.execute-api.us-east-1.amazonaws.com/dev/filestore?param1=${fileName}&param2=${email}`,
  //     headers: {},
  //     data: flowsheetData,
  //   }).then(() => {
  //     saveFeedInputForm(fileName.replace('.json', ''), email, type);
  //   }).catch(() => {
  //     setState_loader({ showResults: false });
  //     openModelPopUp('Failed to fetch feed input.', 'Error', 'error');
  //   });
  // };

  // ########### Save As feature to overrride same file feature #######################

  // const handleConfirm_fileReplace = (
  //   isClose = false,
  //   arg1,
  //   arg2,
  //   arg3,
  //   arg4
  // ) => {
  //   if (isClose) {
  //     setModalOption(defaultModalOptions);
  //     setModalIsOpen_alert(false);
  //     saveFile(arg1, arg2, arg3, arg4);
  //   }
  // };

  // const handleFileReplaceModal = (arg1, arg2, arg3, arg4) => {
  //   let fileName = '';
  //   if (arg1.includes('-sharedFile')) {
  //     fileName = `${arg1.split('-sharedFile')[0]}.win`;
  //   } else {
  //     fileName = `${arg1.split('.json')[0]}.win`;
  //   }
  //   setModalOption({
  //     ...defaultModalOptions,
  //     visible: true,
  //     message: `Do you want to replace existing file ${fileName}?`,
  //     yesOrNo: true,
  //     onNo: () => setModalOption(defaultModalOptions),
  //     onYes: () => handleConfirm_fileReplace(true, arg1, arg2, arg3, arg4),
  //     type: 'warning'
  //   });
  //   setState_loader({ showResults: false });
  // };

  // Added useMemo hook for avoid - rerender in version 11 @sudarsana
  const edgeTypes = useMemo(() => ({
    custom: CustomEdge
  }), []);

  const handleChangeEdgeText = (e) => {
    // console.log('handleChangeEdgeText : ', e);
    setEdgeText(e);
  };
  // ######### WEX/PEX subnetwork connection validation code added by Akhil ###########
  const validate_onConnect = () => {
    // Added on 8th Sept by Akhil: To reduce the rendering once unitop gets stored into Array
    // then making the connection
    if (wexpex_all_unitop.length >= 6) {
      onConnect_new({ source: wexpex_all_unitop[0].id, sourceHandle: 'c', target: wexpex_all_unitop[2].id, targetHandle: 'a' });
      onConnect_new({ source: wexpex_all_unitop[0].id, sourceHandle: 'c', target: wexpex_all_unitop[3].id, targetHandle: 'a_w' });
      onConnect_new({ source: wexpex_all_unitop[1].id, sourceHandle: 'c', target: wexpex_all_unitop[4].id, targetHandle: 'a' });
      // @sudarsana added code for boosterpump connection and commented previous logic
      onConnect_new({ source: wexpex_all_unitop[2].id, sourceHandle: 'b_w', target: wexpex_all_unitop[5].id, targetHandle: 'a_bp' });
      onConnect_new({ source: wexpex_all_unitop[3].id, sourceHandle: 'c', target: wexpex_all_unitop[1].id, targetHandle: 'a' });
      onConnect_new({ source: wexpex_all_unitop[4].id, sourceHandle: 'd', target: wexpex_all_unitop[2].id, targetHandle: 'c_w' });
      // @sudarsana added code for boosterpump connection
      onConnect_new({ source: wexpex_all_unitop[5].id, sourceHandle: 'c', target: wexpex_all_unitop[1].id, targetHandle: 'a' });

      setTimeout(() => {
        wexpex_all_unitop.forEach((item) => {
          removeCrossIcon(item);
        });
      }, 100);
    };
  };

  // ############### for WEX/PEX subnetwork connection #############
  const onConnect_new = (params) => {
    jsLogger.info('onConnect new clicked');
    if (checked_ResetButton == 0 && checked_newButton == 0 && isWexPex && params.source && params.target && params.target != 'undefined') {
      const streamNum_dict_new = {};
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].source && elements[i].data.streamNum_dict) {
          streamNum_dict_new[elements[i].data.text] = elements[i].data.text;
          localStorage.setItem('streamNum_dict', JSON.stringify(streamNum_dict_new));
        }
      }
      if (params.source.replace(/[\d_]+/g, '') !== 'mixsplit') {
        connectionInfo[params.source + params.sourceHandle] = params.sourceHandle;
      }
      if (params.target.replace(/[\d_]+/g, '') !== 'mixsplit') {
        connectionInfo[params.target + params.targetHandle] = params.targetHandle;
      }

      if (params.source.replace(/[\d_]+/g, '') == 'hppump' && params.target.replace(/[\d_]+/g, '') == 'roPump') {
        if (mixSplit_source.indexOf(params.source) == -1) {
          mixSplit_source.push(params.source);
          mixSplit_target.push(params.target);
        }
      } else {
        mixSplit_source.push(params.source);
        mixSplit_target.push(params.target);
      }
      if (params.source.replace(/[\d_]+/g, '') === 'mixsplit') {
        getBorderColor(params.source, 'add');
      }
      connectionInfo_source_target[params.source] = params.target;
      unitop_source.push(params.source + params.sourceHandle);
      unitop_target.push(params.target + params.targetHandle);

      if (localStorage.getItem('loadCheck') == null) {
        let edge = {};  // declared edge empty object for version 11 @sudarsana
        setTimeout(() => {
          let targetHandle_cf;
          let sourceHandle_cf;
          setElements((els) => {
            if (params.sourceHandle == 'c') {
              if (params.target.includes('wex'))
                targetHandle_cf = 'a_w';// && 'a_w';
              else
                targetHandle_cf = 'a';
              sourceHandle_cf = 'c';
            }
            if (params.sourceHandle == 'e') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'e';
            }
            if (params.sourceHandle == 'f') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'f';
            }
            if (params.sourceHandle == 'd') {
              targetHandle_cf = 'a'; // && 'c_w';
              if (params.target.includes('wex'))
                targetHandle_cf = 'c_w';
              else
                targetHandle_cf = 'a';
              sourceHandle_cf = 'd';
            }
            if (params.sourceHandle == 's') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 's';
            }
            if (params.sourceHandle == 'b_w') {
              targetHandle_cf = 'a_bp';
              sourceHandle_cf = 'b_w';
            }
            if (params.sourceHandle == 'd_w') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'd_w';
            }

            if (localStorage.getItem('loadCheck') == null) {
              if ((params.source.replace(/[\d_]+/g, '') === 'hppump' && params.target.replace(/[\d_]+/g, '') === 'roPump') || (params.source.replace(/[\d_]+/g, '') === 'hppump' && params.target.replace(/[\d_]+/g, '') === 'nfPump')) {
                if (Object.keys(streamNum_dict).length > 0) {
                  setTimeout(() => {
                    setEdgeText(Number(Math.max(...Object.keys(streamNum_dict))) + 1);
                  }, 0);
                } else {
                  setTimeout(() => {
                    setEdgeText(Number(edgeText) + 1);
                  }, 0);
                }
              }
            }

            const updatedElements = [...els];  // created one array for updatedElements for version 11 @sudarsana
            edge = {
              source: params.source ?? '',
              target: params.target ?? '',
              type: 'custom',
              arrowHeadType: 'arrowclosed',
              data: { text: ((Object.keys(streamNum_dict).length > 0) ? (Number(Math.max(...Object.keys(streamNum_dict))) + 1) : Number(edgeText) + 1), setEdgeText, handleChangeEdgeText, streamNum_dict, source: params.source, setModalOption, connection_number, setChecked },
              style: { stroke: 'lightblue', strokeWidth: 2 },
              sourceHandle: sourceHandle_cf, // (params.targetHandle == 'a')?"c":"d",
              targetHandle: targetHandle_cf, // (params.sourceHandle == 'c')?"a":"b",
              markerEnd: {
                type: MarkerType.ArrowClosed // Added for ArrowClosed connection version 11 @sudarsana
              },
            };
            onConnectingNode(edge); //  added for new logic for version 11 connection @sudarsana
            unitop_edge.push(edge.data.text);
            wexped_id_details.push(edge);
            return updatedElements; // created one array for updatedElements for version 11 @sudarsana
          });
        });
      }
    }
  };
  // Added by Akhil on 10th Sept: for RO-HP connection validation
  const validate_onConnect_roPump = () => {
    // @ sudarsana here changed length == 3 after implementing parentNode in version 11
    // by @ sudarsana addde here roPumpUnitops: false for update target edge should not update in subnetwork
    if (roPump_all_unitops.length == 3) {
      onConnect({ source: roPump_all_unitops[1].id, sourceHandle: 'c', target: roPump_all_unitops[0].id, targetHandle: 'a', roPumpUnitops: false });
      roPump_all_unitops = [];
    }
  };
  const validate_onConnect_nfPump = () => {
    // @ sudarsana here changed length == 3 after implementing parentNode in version 11
    // by @ sudarsana addde here roPumpUnitops: false for update target edge should not update in subnetwork
    if (roPump_all_unitops.length == 3) {
      onConnect({ source: roPump_all_unitops[1].id, sourceHandle: 'c', target: roPump_all_unitops[0].id, targetHandle: 'a', roPumpUnitops: false });
      roPump_all_unitops = [];
    }
  };

  // by abhishek  // idher change kerne se ropunp mai connection gone, and 2nd clro is coming as roPump
  const validate_onConnect_clro = () => {
    // by @ sudarsana here changed the length numbers here overall length value is 3 and commeted exiting code
    // by @ sudarsana addde here roPumpUnitops: false for update target edge should not update in subnetwork
    if (clro_all_unitop.length !== 0) { // Added by Abhishek on 28-dec-23 for rohp coming as clro after deleting clro
      onConnect({ source: clro_all_unitop[clro_all_unitop.length - 2].id, sourceHandle: 'c', target: clro_all_unitop[clro_all_unitop.length - 3].id, targetHandle: 'a', roPumpUnitops: false });
    }
  };

  // ######## for making the manual connections and automated RO-HP connection #####
  // @sudarsana Rao , this logic for updating the value after removing entire stream_dict is empty
  const updateValue = () => {
    setTimeout(() => {
      if (document.querySelectorAll('.react-flow__edge.react-flow__edge-custom').length) {
        const obj = {};
        document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele) => {
          obj[ele.value] = +ele.value; // starting increment the values here
        });
        // Save the updated values to localStorage
        localStorage.setItem('streamNum_dict', JSON.stringify(obj)); // here entire dictinary is apending onces connection done
        streamNum_dict = JSON.parse(localStorage.getItem('streamNum_dict'));
      }
    }, 100);
  };
  const onConnect = (params) => {
    let log_edgeno = '';
    // @sudarsana (08/28/2024) when user deleting edge or unitops this logic is used to re-filling the entire connectionInfo dictionary
    if (Object.keys(connectionInfo).length === 0) {
      const edges = rfInstance?.toObject()?.edges ?? [];
      edges.forEach(edge => {
        if (!edge.source.includes('mixsplit')) {
          const sourceKey = edge.source + edge.sourceHandle;
          connectionInfo[sourceKey] = edge.sourceHandle;
        }
        if (!edge.target.includes('mixsplit')) {
          const targetKey = edge.target + edge.targetHandle;
          connectionInfo[targetKey] = edge.targetHandle;
        }
      });
    }
    updateValue(); // calling the function here

    let wexpex_unitop_check = 0;
    // @sudarsana added the  logic for in RO ERD with WEX /PEX, only one input stream should be allowed into the first mixer splitter - start
    const values_wexpex = Object.keys(connectionInfo_source_target).map((key) => {
      return connectionInfo_source_target[key];
    });
    if (wexpex_all_unitop.length >= 6) {
      if (values_wexpex.includes(params.target) && params.target === wexpex_all_unitop[0].id && wexpex_all_unitop[0].id.replace(/[\d_]+/g, '') === 'mixsplit') {
        document.querySelector('#toatster-msg span').innerHTML = "Only one inlet stream is allowed";
        document.querySelector('#toatster-msg').style.display = 'block';
        setTimeout(() => {
          document.querySelector('#toatster-msg').style.display = 'none';
          document.querySelector('#toatster-msg span').innerHTML = '';
        }, 3000);
        return;
      }
    }
    // end
    if (!isWexPex && wexpex_all_unitop.length > 0) {
      wexpex_all_unitop.filter((item) => {
        if (item.id === params.target && params.target != wexpex_all_unitop[0].id) {
          wexpex_unitop_check = 1;
        }
      });
    }
    let peltonwheel_unitop_check = 0;
    if (!isPeltonWheel && peltonwheel_all_unitop.length > 0) {
      peltonwheel_all_unitop.filter((item) => {
        if (item.id === params.target && params.target != peltonwheel_all_unitop[0].id) {
          peltonwheel_unitop_check = 1;
        }
      });
    }
    let tc_unitop_check = 0;
    if (!isturbocharger && turbocharger_all_unitop.length > 0) {
      turbocharger_all_unitop.filter((item) => {
        if (item.id === params.target && params.target != turbocharger_all_unitop[0].id) {
          tc_unitop_check = 1;
        }
      });
    }
    if (checked_ResetButton == 0 && checked_newButton == 0 && wexpex_unitop_check === 0 && peltonwheel_unitop_check === 0 && tc_unitop_check === 0 && connectionInfo[params.source + params.sourceHandle] != params.sourceHandle && connectionInfo[params.target + params.targetHandle] != params.targetHandle) {
      let finaldata = false;
      dragdrop.current = true;
      if (params.source === params.target) {
        finaldata = true;
      } else {
        if (params.source && params.target) {
          let distanationarray = [];
          const source = params.source.split('_')[0];
          // start -- @sudarsana bug fixing here invalidConnection in NF-HP unitop 'hppump' is same as RO-HP also
          //  to fix that bug we called rfInstance and get NF-HP unitop and applied the conditions
          let destination = params.target.split('_')[0];
          // console.log('rfinstanstce ', rfInstance?.toObject()?.edges ?? []);
          const edges = rfInstance?.toObject()?.edges ?? [];
          const filteredEdges = edges.filter(
            (values) => values.source.startsWith('hppump') && values.target.startsWith('nfPump')
          );
          if (filteredEdges.length > 0) {
            // console.log('filteredEdges', filteredEdges);
            distanationarray = filteredEdges.map((values) => values.source);
            destination = distanationarray.includes(params.target) ? 'nfhppump' : params.target.split('_')[0];
          }
          // end bug fixing
          for (let i = 0; i < invalidConnection.length; i++) {
            const ele = invalidConnection[i];
            if (uniqueValue[ele.source].indexOf(source) >= 0 && uniqueValue[ele.Destination].indexOf(destination) >= 0) {
              const sourceHandle = handleValue[ele.sourcePort];
              const targetHandle = handleValue[ele.targetPort];
              if (sourceHandle === params.sourceHandle && targetHandle === params.targetHandle) {
                finaldata = true;
                if (ele.Msg) {
                  document.querySelector('#toatster-msg span').innerHTML = ele.Msg;
                  document.querySelector('#toatster-msg').style.display = 'block';
                  setTimeout(() => {
                    document.querySelector('#toatster-msg').style.display = 'none';
                    document.querySelector('#toatster-msg span').innerHTML = '';
                  }, 3000);
                }
                break;
              }
            }
          }
        }
      }
      if (!finaldata && params.source && params.target && params.target != 'undefined') {
        const streamNum_dict_new = {};
        for (let i = 0; i < edges.length; i++) {
          if (edges[i].source && edges[i].data.streamNum_dict) {
            streamNum_dict_new[edges[i].data.text] = edges[i].data.text;
            localStorage.setItem('streamNum_dict', JSON.stringify(streamNum_dict_new));
          }
        }
        if (params.source.replace(/[\d_]+/g, '') !== 'mixsplit') {
          connectionInfo[params.source + params.sourceHandle] = params.sourceHandle;
        }
        if (params.target.replace(/[\d_]+/g, '') !== 'mixsplit') {
          connectionInfo[params.target + params.targetHandle] = params.targetHandle;
        }
        if (params.source.replace(/[\d_]+/g, '') == 'hppump' && params.target.replace(/[\d_]+/g, '') == 'roPump') {
          if (mixSplit_source.indexOf(params.source) == -1) {
            mixSplit_source.push(params.source);
            mixSplit_target.push(params.target);
          }
        } else {
          mixSplit_source.push(params.source);
          mixSplit_target.push(params.target);
        }
        if (params.source.replace(/[\d_]+/g, '') === 'mixsplit') {
          getBorderColor(params.source, 'add');
        }
        connectionInfo_source_target[params.source] = params.target;
        unitop_source.push(params.source + params.sourceHandle);
        unitop_target.push(params.target + params.targetHandle);
        let edge = {};  // declared edge empty object for version 11 @sudarsana
        if (localStorage.getItem('loadCheck') == null) {
          setTimeout(() => {
            let targetHandle_cf;
            let sourceHandle_cf;
            setElements((els) => {
              if (params.sourceHandle == 'c') {
                if (params.target.includes('wex'))
                  targetHandle_cf = 'a_w';// && 'a_w';
                else
                  targetHandle_cf = 'a';
                sourceHandle_cf = 'c';
              }
              if (params.sourceHandle == 'e') {
                targetHandle_cf = 'a';
                sourceHandle_cf = 'e';
              }
              if (params.sourceHandle == 'f') {
                targetHandle_cf = 'a';
                sourceHandle_cf = 'f';
              }
              if (params.sourceHandle == 'd') {
                targetHandle_cf = 'a'; // && 'c_w';
                if (params.target.includes('wex'))
                  targetHandle_cf = 'c_w';
                else
                  targetHandle_cf = 'a';
                sourceHandle_cf = 'd';
              }
              if (params.sourceHandle == 's') {
                targetHandle_cf = 'a';
                sourceHandle_cf = 's';
              }
              if (params.sourceHandle == 'b_w') {
                targetHandle_cf = 'a_bp';
                sourceHandle_cf = 'b_w';
              }
              //
              if (params.sourceHandle == 'd_w') {
                targetHandle_cf = 'a';
                sourceHandle_cf = 'd_w';
              }
              // turbo charge connection
              if (params.sourceHandle == 'd_tc') {
                targetHandle_cf = 'a';
                sourceHandle_cf = 'd_tc';
              }

              if (localStorage.getItem('loadCheck') == null) {
                if ((params.source.replace(/[\d_]+/g, '') === 'hppump' && params.target.replace(/[\d_]+/g, '') === 'roPump') || (params.source.replace(/[\d_]+/g, '') === 'hppump' && params.target.replace(/[\d_]+/g, '') === 'nfPump')) {
                  if (Object.keys(streamNum_dict).length > 0) {
                    setTimeout(() => {
                      setEdgeText(Number(Math.max(...Object.keys(streamNum_dict))) + 1);
                    }, 0);
                  } else {
                    setTimeout(() => {
                      setEdgeText(Number(edgeText) + 1);
                    }, 0);
                  }
                }
              }

              const updatedElements = [...els];  // created one array for updatedElements for version 11 @sudarsana
              // taking the edge details from saved files
              const edge_details = [...new Set(edge_details_SaveFiles)];
              // this entire condtion saved file and open the file and make connection for increment process
              if (edge_details.length >= 1) {
                const sourceYIncrementsMax1 = edge_details.reduce((acc, edge) => {
                  if (edge.data && edge.data.sourceYIncrement) {
                    acc.push(edge.data.sourceYIncrement);
                  }
                  return acc;
                }, []);
                // taking the maximum increment value from saved file
                if (sourceYIncrementsMax1.length > 0) {
                  const sourceYIncrementsMax = Math.max(...sourceYIncrementsMax1);
                  sourceYIncrement = Math.max(sourceYIncrement, sourceYIncrementsMax + increment);
                }
              }
              // taking maximum value of saved file because of when we make the new connection in saved file, it should be start from end of connection maximum value
              sourceYIncrement += increment;
              edge = {
                source: params.source ?? '',
                target: params.target ?? '',
                type: 'custom',
                arrowHeadType: 'arrowclosed',
                data: { text: ((Object.keys(streamNum_dict).length > 0) ? (Number(Math.max(...Object.keys(streamNum_dict))) + 1) : Number(edgeText) + 1), setEdgeText, handleChangeEdgeText, streamNum_dict, source: params.source, setModalOption, connection_number, update_connection_number, sourceYIncrement, sourcePostion, subnetwork: params.roPumpUnitops },
                style: { stroke: 'lightblue', strokeWidth: 2 },
                sourceHandle: sourceHandle_cf, // (params.targetHandle == 'a')?"c":"d",
                targetHandle: targetHandle_cf, // (params.sourceHandle == 'c')?"a":"b",
                markerEnd: {
                  type: MarkerType.ArrowClosed // Added for ArrowClosed connection version 11 @sudarsana
                },
                updatable: 'target'
              };
              onConnectingNode(edge); //  added for new logic for version 11 connection @sudarsana
              unitop_edge.push(edge.data.text);
              edge_id_details.push(edge);
              if (!log_edgeno) {
                log_edgeno = `Edge created btwn -->> ${params.source}:${params.sourceHandle} -> ${params.target}:${params.targetHandle} | Edge No : ${edge.data.text}`;
                jsLogger.info(`${log_edgeno}`);
              }
              return updatedElements;  // added return updatedElements @sudarsana
            });
          });
        }
      }
      executeOptionFlag = true;
    }
  };
  // created new connection for pelton wheel by sudarsana
  const validate_onNewConnect_PW = (params) => {
    if (peltonwheel_all_unitop.length > 0) {
      peltonwheel_all_unitop.forEach((item) => {
        if (item.id === params.source) {
          onConnect_new_PW(params);
        }
      });
    }
  };
  // created new connection for TurboCharger by sudarsana
  const validate_onNewConnect_TC = (params) => {
    if (turbocharger_all_unitop.length > 0) {
      turbocharger_all_unitop.forEach((item) => {
        if (item.id === params.source) {
          onConnect_new_TC(params);
        }
      });
    }
  };
  // ###### pelton Wheel subnetwork connection ##########
  const onConnect_new_PW = (params) => {
    if (checked_ResetButton == 0 && checked_newButton == 0 && isPeltonWheel && connectionInfo[params.source + params.sourceHandle] != params.sourceHandle && connectionInfo[params.target + params.targetHandle] != params.targetHandle && del_element_check != 1) {
      const streamNum_dict_new = {};
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].source && elements[i].data.streamNum_dict) {
          streamNum_dict_new[elements[i].data.text] = elements[i].data.text;
          localStorage.setItem('streamNum_dict', JSON.stringify(streamNum_dict_new));
        }
      }
      if (params.source.replace(/[\d_]+/g, '') !== 'mixsplit') {
        connectionInfo[params.source + params.sourceHandle] = params.sourceHandle;
      }
      if (params.target.replace(/[\d_]+/g, '') !== 'mixsplit') {
        connectionInfo[params.target + params.targetHandle] = params.targetHandle;
      }

      if (params.source.replace(/[\d_]+/g, '') == 'hppump' && params.target.replace(/[\d_]+/g, '') == 'roPump') {
        if (mixSplit_source.indexOf(params.source) == -1) {
          mixSplit_source.push(params.source);
          mixSplit_target.push(params.target);
        }
      } else {
        mixSplit_source.push(params.source);
        mixSplit_target.push(params.target);
      }
      if (params.source.replace(/[\d_]+/g, '') === 'mixsplit') {
        getBorderColor(params.source, 'add');
      }
      connectionInfo_source_target[params.source] = params.target;
      unitop_source.push(params.source + params.sourceHandle);
      unitop_target.push(params.target + params.targetHandle);
      let edge = {};
      if (localStorage.getItem('loadCheck') == null) {
        setTimeout(() => {
          let targetHandle_cf;
          let sourceHandle_cf;
          setElements((els) => {
            if (params.sourceHandle == 'c') {
              if (params.target.includes('wex'))
                targetHandle_cf = 'a_w';// && 'a_w';
              else
                targetHandle_cf = 'a';
              sourceHandle_cf = 'c';
            }
            if (params.sourceHandle == 'e') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'e';
            }
            if (params.sourceHandle == 'f') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'f';
            }
            if (params.sourceHandle == 'd') {
              targetHandle_cf = 'a'; // && 'c_w';
              if (params.target.includes('wex'))
                targetHandle_cf = 'c_w';
              else if (params.target.includes('peltonwheel'))
                targetHandle_cf = 'a_pw';
              else
                targetHandle_cf = 'a';
              sourceHandle_cf = 'd';
            }
            if (params.sourceHandle == 's') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 's';
            }
            if (params.sourceHandle == 'b_w') {
              targetHandle_cf = 'a_bp';
              sourceHandle_cf = 'b_w';
            }
            if (params.sourceHandle == 'd_w') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'd_w';
            }

            if (localStorage.getItem('loadCheck') == null) {
              if (params.source.replace(/[\d_]+/g, '') === 'hppump' && params.target.replace(/[\d_]+/g, '') === 'roPump') {
                if (Object.keys(streamNum_dict).length > 0) {
                  setTimeout(() => {
                    setEdgeText(Number(Math.max(...Object.keys(streamNum_dict))) + 1);
                  }, 0);
                } else {
                  setTimeout(() => {
                    setEdgeText(Number(edgeText) + 1);
                  }, 0);
                }
              }
            }

            const updatedElements = [...els]; // created one array for updatedElements for version 11 @sudarsana
            edge = {
              source: params.source ?? '',
              target: params.target ?? '',
              type: 'custom',
              arrowHeadType: 'arrowclosed',
              data: { text: ((Object.keys(streamNum_dict).length > 0) ? (Number(Math.max(...Object.keys(streamNum_dict))) + 1) : Number(edgeText) + 1), setEdgeText, handleChangeEdgeText, streamNum_dict, source: params.source, setModalOption, connection_number },
              style: { stroke: 'lightblue', strokeWidth: 2 },
              sourceHandle: sourceHandle_cf, // (params.targetHandle == 'a')?"c":"d",
              targetHandle: targetHandle_cf, // (params.sourceHandle == 'c')?"a":"b",
              markerEnd: {
                type: MarkerType.ArrowClosed // Added for ArrowClosed connection version 11 @sudarsana
              },
            };
            onConnectingNode(edge); //  added for new logic for version 11 connection @sudarsana
            unitop_edge.push(edge.data.text);
            pelton_id_details.push(edge);
            return updatedElements;  // added return updatedElements @sudarsana
          });
        });
      }
    }
  };

  // ##### TC subnetwork connection ######
  const onConnect_new_TC = (params) => {

    if (checked_ResetButton == 0 && checked_newButton == 0 && isturbocharger && connectionInfo[params.source + params.sourceHandle] != params.sourceHandle && connectionInfo[params.target + params.targetHandle] != params.targetHandle && del_element_check != 1) {
      const streamNum_dict_new = {};
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].source && elements[i].data.streamNum_dict) {
          streamNum_dict_new[elements[i].data.text] = elements[i].data.text;
          localStorage.setItem('streamNum_dict', JSON.stringify(streamNum_dict_new));
        }
      }
      if (params.source.replace(/[\d_]+/g, '') !== 'mixsplit') {
        connectionInfo[params.source + params.sourceHandle] = params.sourceHandle;
      }
      if (params.target.replace(/[\d_]+/g, '') !== 'mixsplit') {
        connectionInfo[params.target + params.targetHandle] = params.targetHandle;
      }

      if (params.source.replace(/[\d_]+/g, '') == 'hppump' && params.target.replace(/[\d_]+/g, '') == 'roPump') {
        if (mixSplit_source.indexOf(params.source) == -1) {
          mixSplit_source.push(params.source);
          mixSplit_target.push(params.target);
        }
      }
      else {
        mixSplit_source.push(params.source);
        mixSplit_target.push(params.target);
      }
      if (params.source.replace(/[\d_]+/g, '') === 'mixsplit') {
        getBorderColor(params.source, 'add');
      }
      connectionInfo_source_target[params.source] = params.target;
      unitop_source.push(params.source + params.sourceHandle);
      unitop_target.push(params.target + params.targetHandle);
      let edge = {};
      if (localStorage.getItem('loadCheck') == null) {
        setTimeout(() => {
          let targetHandle_cf;
          let sourceHandle_cf;
          setElements((els) => {
            if (params.sourceHandle == 'c') {
              if (params.target.includes('wex'))
                targetHandle_cf = 'a_w';// && 'a_w';
              else if (params.target.includes('TC'))
                targetHandle_cf = 'a_tc';
              else
                targetHandle_cf = 'a';
              sourceHandle_cf = 'c';
            }
            if (params.sourceHandle == 'e') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'e';
            }
            if (params.sourceHandle == 'f') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'f';
            }
            if (params.sourceHandle == 'd') {
              targetHandle_cf = 'a'; // && 'c_w';
              if (params.target.includes('wex'))
                targetHandle_cf = 'c_w';
              else if (params.target.includes('TC'))
                targetHandle_cf = 'c_tc';
              else
                targetHandle_cf = 'a';
              sourceHandle_cf = 'd';
            }
            if (params.sourceHandle == 's') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 's';
            }
            if (params.sourceHandle == 'b_w') {
              targetHandle_cf = 'a_bp';
              sourceHandle_cf = 'b_w';
            }
            //
            if (params.sourceHandle == 'd_w') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'd_w';
            }
            if (params.sourceHandle == 'b_tc') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'b_tc';
            }
            if (params.sourceHandle == 'd_tc') {
              targetHandle_cf = 'a';
              sourceHandle_cf = 'd_tc';
            }

            if (localStorage.getItem('loadCheck') == null) {
              if (params.source.replace(/[\d_]+/g, '') === 'hppump' && params.target.replace(/[\d_]+/g, '') === 'roPump') {
                if (Object.keys(streamNum_dict).length > 0) {
                  setTimeout(() => {
                    setEdgeText(Number(Math.max(...Object.keys(streamNum_dict))) + 1);
                  }, 0);
                } else {
                  setTimeout(() => {
                    setEdgeText(Number(edgeText) + 1);
                  }, 0);
                }
              }
            }

            const updatedElements = [...els];  // created one array for updatedElements for version 11 @sudarsana
            edge = {
              source: params.source ?? '',
              target: params.target ?? '',
              type: 'custom',
              arrowHeadType: 'arrowclosed',
              data: { text: ((Object.keys(streamNum_dict).length > 0) ? (Number(Math.max(...Object.keys(streamNum_dict))) + 1) : Number(edgeText) + 1), setEdgeText, handleChangeEdgeText, streamNum_dict, source: params.source, setModalOption, connection_number },
              style: { stroke: 'lightblue', strokeWidth: 2 },
              sourceHandle: sourceHandle_cf, // (params.targetHandle == 'a')?"c":"d",
              targetHandle: targetHandle_cf, // (params.sourceHandle == 'c')?"a":"b",
              markerEnd: {
                type: MarkerType.ArrowClosed // Added for ArrowClosed connection version 11 @sudarsana
              },
            };
            onConnectingNode(edge);  //  added for new logic for version 11 connection @sudarsana
            unitop_edge.push(edge.data.text);
            turbo_id_details.push(edge);
            return updatedElements;
          });
        });
        if (turbochargeLength) {
          if (localStorage.getItem('turbo_charger-dict')) {
            localStorage.removeItem('turbo_charger-dict');
          }
        }
      }
    }
  };

  // function to animate the connection for outgoing connection when user clicks any untiop
  const GetOutgoingConnection = (ob, elms) => {
    setElements(() => {
      for (let i = 0; i < elms.length; i++) {
        if (elms[i].source != undefined && elms[i].source == ob) {
          elms[i].animated = true;
        } else {
          elms[i].animated = false;
        }
      }
      return [...elms];
    });
    updateControlsButtonTitle();
  };

  // ######### Added by Akhil on 10th Nov 24 -> function to update stream number for mixSplit unitop when Automate stream ID features are enabled ######

  function createNewMixSplitDict(mixSplit_dict, mixsplit_streamdict) {
    const newMixSplit = { mixSplit: {} };

    Object.keys(mixSplit_dict.mixSplit).forEach(mixSplitKey => {
      const originalStreams = mixSplit_dict.mixSplit[mixSplitKey];
      newMixSplit.mixSplit[mixSplitKey] = {};

      Object.keys(mixsplit_streamdict).forEach(streamMapping => {
        if (mixsplit_streamdict[streamMapping] === mixSplitKey) {
          const [oldStream, newStream] = streamMapping.split(",");
          if (Object.prototype.hasOwnProperty.call(originalStreams, oldStream)) {
            newMixSplit.mixSplit[mixSplitKey][newStream] = originalStreams[oldStream];
          }
        }
      });
    });
    return newMixSplit;
  }
  // ######## function to implement stream alignment from left to right ###############
  const onStreamAlign = () => {
    let x_axis_cordinate = [];
    const x_axis_val = [];
    const mixsplit_streamdict = {};
    const mixSplit_dict_local = JSON.parse(localStorage.getItem('mixSplit-dict'));
    streamNum_dict = {};
    // ### to get the stream box co-ordinates and values #########
    document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele, index) => {
      x_axis_cordinate.push(parseFloat(ele.style.transform.split('translate')[2].split(',')[0].split('px')[0].split('(')[1]));
      x_axis_val.push(index + 1);
      /* commentd code by chandrashehar because some condition is faling START */
      // if (x_axis_cordinate.length > 0 && x_axis_cordinate.indexOf(parseFloat(ele.style.transform.split('translate')[2].split(',')[0].split('px')[0].split('(')[1])) == -1) {
      //   x_axis_cordinate.push(parseFloat(ele.style.transform.split('translate')[2].split(',')[0].split('px')[0].split('(')[1]));
      // } else {
      // // code if 2 stream textbox is positioned at same x axis then add very small number to
      // // make sure that each x axis coordinate value should be different.
      // const val_1 = ele.style.transform.split('translate');
      // let val_2 = ele.style.transform.split('translate')[2].split(',')[0].split('px')[0].split('(')[1];
      // val_2 = Number(val_2) + Number(`0.00${index}`);
      // let val_3 = val_1[val_1.length - 1].split(',');
      // val_3[0] = `(${val_2}px`;
      // val_3 = val_3.join(',');
      // val_1[val_1.length - 1] = val_3;
      // ele.style.transform = val_1.join('translate');
      // x_axis_cordinate.push(parseFloat(ele.style.transform.split('translate')[2].split(',')[0].split('px')[0].split('(')[1]));
      // }
      // // store id's starting from 1 irrespective of there assigned id's
      // x_axis_val.push(index + 1);
      /* commentd code by chandrashehar because some condition is faling END */
    });
    /**
     * code if 2 stream textbox is positioned at same x axis then add very small number to
     * make sure that each x axis coordinate value should be different.  START
     */
    // const seen = new Map();  // Create a Map to track how many times each rounded value has been seen
    // x_axis_cordinate = x_axis_cordinate.map(val => { // Iterate over each value in the x_axis_cordinate array and adjust duplicates
    //   const rounded = Number(val.toFixed(3)); // Round the value to 3 decimal places for consistent comparison
    //   if (seen.has(rounded)) { // Check if this rounded value has already been seen
    //     const count = seen.get(rounded) + 1; // If yes, increment the count for how many times it's been seen
    //     seen.set(rounded, count); // Update the count in the Map
    //     return rounded + count * 0.01; // Return the adjusted value by adding 0.01 * count to avoid duplication
    //   } else {
    //     seen.set(rounded, 0); // If it's the first time this value is seen, initialize its count to 0
    //     return rounded;  // Return the original rounded value
    //   }
    // });
    const seen = new Map(); // Create a Map to keep track of how many times each number has appeared
    x_axis_cordinate = x_axis_cordinate.map(num => { // Iterate through each number in the x_axis_cordinate array
      const count = seen.get(num) || 0;  // Get the current count of this number from the Map (default to 0 if not seen before)
      seen.set(num, count + 1); // Update the count in the Map by incrementing it
      return parseFloat((num + count * 0.01).toFixed(2)); // Add 0.01 for each duplicate occurrence and round to 2 decimal places
    });
    document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele, index) => {
      const transformParts = ele.style.transform.split('translate');    // Extract the transform string and split by 'translate'
      const lastTransform = transformParts[transformParts.length - 1];      // Get the last translate(...) part (usually the actual x,y translation)
      const [xRaw, yRaw] = lastTransform.replace(/[()px]/g, '').split(',');      // Extract current y-coordinate (we'll preserve it)
      const newX = x_axis_cordinate[index];      // Replace x-coordinate with the updated value from x_axis_cordinate
      const newTransform = `(${newX}px,${yRaw}px)`;      // Reconstruct the last translate(...) string with new x and original y
      transformParts[transformParts.length - 1] = newTransform;      // Update the last part of transformParts
      ele.style.transform = transformParts.join('translate');      // Rejoin and apply the updated transform string
    });
    /**
    * code if 2 stream textbox is positioned at same x axis then add very small number to
    * make sure that each x axis coordinate value should be different.  END
    */
    setTimeout(() => {
      x_axis_cordinate.sort((a, b) => { return a - b; });
      x_axis_val.sort((a, b) => { return a - b; });
      // ###### After sorting rearrange the stream number based on co-ordinates ##########
      document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele, index) => {
        ele.value = x_axis_val[x_axis_cordinate.indexOf(parseFloat(ele.style.transform.split('translate')[2].split(',')[0].split('px')[0].split('(')[1]))];
        // Added by Akhil on 10thNov24 to update stream num of mixSplit-dict without opening the form
        if (rfInstance.toObject().edges[index].source.includes('mixsplit')) {
          const oldNum = `stream${parseInt(rfInstance.toObject().edges[index].data.text)}`;
          const newNum = `stream${parseInt(ele.value)}`;
          mixsplit_streamdict[`${oldNum},${newNum}`] = rfInstance.toObject().edges[index].source;
        }
        rfInstance.toObject().edges[index].data.text = parseInt(ele.value);
        streamNum_dict[ele.value] = parseInt(ele.value);
      });
      // Added by Akhil on 10thNov24
      if (mixSplit_dict_local != null) {
        const newMixSplitDict = createNewMixSplitDict(mixSplit_dict_local, mixsplit_streamdict);
        localStorage.setItem('mixSplit-dict', JSON.stringify(newMixSplitDict));
      }
      rfInstance.toObject().edges.forEach((ele, index) => {
        rfInstance.toObject().edges[index].data.streamNum_dict = streamNum_dict;
      });
      // added this streamDict in localstorage because of after modifiying the stream numbers it is not saving in application
      localStorage.setItem('streamNum_dict', JSON.stringify(streamNum_dict));
    }, 1000);
    dragdrop.current = true;
  };
  const onElementClicksData = () => { };
  // Click the any unitop to call this function onClick unitop.
  const onElementClick = (event, object) => {
    // to stop event bubbling on input of unitop's name : Start
    if (event.target && event.target.localName === 'input') {
      return false;
    }
    // to stop event bubbling on input of unitop's name : End
    if (event === 'roSplit') {
      if (localStorage.getItem('ro_payload')) {
        ro_payloadData = JSON.parse(localStorage.getItem('ro_payload'));
      };
      if (ro_payloadData.ro[object].split_flow === 0) {
        edges.forEach(edge => {
          if (edge.source) {
            if (edge.source === object && edge.sourceHandle === 's') {
              // logic added to fixed the bug of spillit flow in version 11 code changes
              setEdges((els) => els.filter((e) => e !== edge));
              delete connectionInfo[edge.source + edge.sourceHandle];
              delete connectionInfo[edge.target + edge.targetHandle];
              delete streamNum_dict[edge.data.text];
              delete streamNum_dict[Object.keys(streamNum_dict).find(key => streamNum_dict[key] === edge.data.text)];
              localStorage.setItem('streamNum_dict', JSON.stringify(streamNum_dict));
            }
          }
        });
      }
      return;
    }
    // to stop event bubbling on input of unitop's name : End
    if (event === 'nfSplit') {
      if (localStorage.getItem('ro_payload')) {
        ro_payloadData = JSON.parse(localStorage.getItem('ro_payload'));
      };
      if (ro_payloadData.ro[object].split_flow === 0) {
        edges.forEach(edge => {
          if (edge.source) {
            if (edge.source === object && edge.sourceHandle === 's') {
              // logic added to fixed the bug of spillit flow in version 11 code changes
              setEdges((els) => els.filter((e) => e !== edge));
              delete connectionInfo[edge.source + edge.sourceHandle];
              delete connectionInfo[edge.target + edge.targetHandle];
              delete streamNum_dict[edge.data.text];
              delete streamNum_dict[Object.keys(streamNum_dict).find(key => streamNum_dict[key] === edge.data.text)];
              localStorage.setItem('streamNum_dict', JSON.stringify(streamNum_dict));
            }
          }
        });
      }
      return;
    }
    event.stopPropagation();
    GetOutgoingConnection(object.id, elements);
    if (object.type === 'customnode_feed' || object.type === 'customnode_Wateranalysis') {
      setVisibleFeed(true);
      setFeedItem(object);
    } else if (object.type === 'customnode_Argo') {
      setVisiableAAWithFeed(true);
      setArgoDetails(object);
    } else if ((object.type === 'customnode_productOut') || (object.type === 'customnode_ROpump') || (object.type === 'customnode_CLROpump')) {
      setVisibleRo(true);
      setRoDetails(object);
    } else if ((object.type === 'customnode_productOut_NF') || (object.type === 'customnode_NFpump')) {
      setVisibleNF(true);
      setRoDetails(object);
    } else if (object.type === 'customnode_pump') {
      setPumpDetails(object);
      setVisiblePump(true);
    } else if (object.type === 'customnode_chemical_dosing') {
      setDosingDetails(object);
      setVisibleDosing(true);
    } else if (object.type === 'customnode_WEX_PEX') {
      setWexPexDetails(object);
      setVisibleWexPex(true);
    } else if (object.type === 'customnode_Pelton_Wheel') {
      setWexPexDetails(object);
      setVisibleWexPex(true);
    } else if (object.type === 'customnode_Turbo_Charger') {
      setWexPexDetails(object);
      setVisibleWexPex(true);
    } else if (object.type === 'customnode_edi') {
      setEDIDetails(object);
      setVisibleEDI(true);
    } else if (object.type === 'customnode_pump_hp') {
      setPumpDetails(object);
      setVisibleHpPump(true);
    } else if (object.type === 'customnode_cartridge') {
      setVisibleCF(true);
      setUnitopDetails(object);
    } else if (object.type === 'customnode_mixsplit') {
      let flag = true;
      if (document.querySelector(`.Node_${object.id}`)) {
        if (document.querySelector(`.Node_${object.id}`).closest('.react-flow__node').className.indexOf('disabled') >= 0) {
          flag = false;
        }
      }
      // @ SudarsanaRao added for bug fixing for mixsplit after edting the stream number issue
      wexpex_all_unitop.forEach((item) => {
        removeCrossIcon(item);
      });
      // end
      if (flag) {
        if (localStorage.getItem('mixSplit-dict')) {
          const localData = get(JSON.parse(localStorage.getItem('mixSplit-dict')), 'mixSplit', {});
          if (localData[object.id]) {
            setlocalData_mixSplit(localData[object.id]);
          } else {
            setlocalData_mixSplit({});
            setSplitObjData([]);
          }
        }
        // disable visibleSplit in wex
        setVisibleSplit(true);
        for (let i = 0; i < (wexpex_all_unitop.length); i++) {
          if (object.id === wexpex_all_unitop[i].id) {
            setVisibleSplit(false);
            break;
          }
        }
        setSplitDetails(object);
        // version 11 replaced as edges in place of elements @sudarsana
        const flow = rfInstance.toObject().edges;
        const splitData = map(flow.filter((obj) => obj.source === object.id), 'data');

        for (let i = 0; i < splitData.length; i++) {
          if (splitData[i].streamNum_dict) {
            if (splitData[i].streamNum_dict[splitData[i].text]) {
              splitData[i].text = splitData[i].streamNum_dict[splitData[i].text];
            }
          }
        }
        setSplitObjData(splitData);
      } else {
        setVisibleSplit(false);
      }
    } else if (object.type === 'customnode_stripper') {
      setStripperDetails(object);
      setVisibleStripper(true);
    } else { }
    if (object.type === 'customnode_WEX_PEX') {
      setWorkExchanger(object);
      setVisibleWorkExchanger(true);
    } if (object.type === 'customnode_Pelton_Wheel') {
      setPletonWheel(object);
      setVisiblePeltonWheel(true);
    }
    if (object.type === 'customnode_Turbo_Charger') {
      setturboChargeDetails(object);
      setVisibleTurbo(true);
    }
    setTimeout(() => {
      updateControlsButtonTitle();
    }, 3000);
    setState(object);
  };

  const onEdgeContextMenu = (event, edge) => {
    if (event.target.closest('.react-flow__edge')?.classList.contains('inactive')) {
      return; // Skip execution for inactive edges
    }
    event.preventDefault();
    setVisibleFeed(false);
    let found = false;
    let pelton = false;
    let turbo = false;
    for (let i = 0; i < wexpex_all_unitop.length; i++) {
      if (wexpex_all_unitop[i].id === edge.source) {
        found = true;
        if (wexpex_all_unitop[i].id.includes('roPump') && edge.sourceHandle === 'c') {
          found = false;
        } else if (wexpex_all_unitop[i].id.includes('wex') && edge.sourceHandle === 'd_w') {
          found = false;
        }
      }
    }
    for (let i = 0; i < peltonwheel_all_unitop.length; i++) {
      if (peltonwheel_all_unitop[i].id === edge.source) {
        pelton = true;
        if (peltonwheel_all_unitop[i].id.includes('roPump') && edge.sourceHandle === 'c') {
          pelton = false;
        } else if (peltonwheel_all_unitop[i].id.includes('peltonwheel') && edge.sourceHandle === 'd') {
          pelton = false;
        }
      }
    }
    for (let i = 0; i < turbocharger_all_unitop.length; i++) {
      if (turbocharger_all_unitop[i].id === edge.source) {
        turbo = true;
        if (turbocharger_all_unitop[i].id.includes('roPump') && edge.sourceHandle === 'c') {
          turbo = false;
        } else if (turbocharger_all_unitop[i].id.includes('TC') && edge.sourceHandle === 'd_tc') {
          turbo = false;
        }
      }
    }
    if (found);
    else if (pelton);
    else if (turbo);
    else if (edge.source.replace(/[\d_]+/g, '') === 'hppump' && edge.target.replace(/[\d_]+/g, '') === 'roPump');
    else { handleCloseModal(edge, 'connection'); }
  };

  const onEdgeMouseEnter = () => { };

  // log the file changes made by the user  // By Abhishek for file change log task
  const logFileDataChange = (fileDataWhileSaving) => {
    // console.log('fileDataWhenOpen :', fileDataWhenOpen);
    // console.log('fileDataWhileSaving :', fileDataWhileSaving);

    // saveWithChangeTracking(fileDataWhenOpen, fileDataWhileSaving);
    return getObjectDifferences(fileDataWhenOpen, fileDataWhileSaving);
  };

  // ############## Saving flowsheet file ###################

  // save-as tick icon
  const onSave = useCallback(async (fs) => {

    if (rfInstance) {
      setFindAllConnection(true);
      setCallExecuteFun(true);
      setTimeout(() => {
        let formData_ro = {};
        let payloadData_ro = {};
        let formData_clro = {};
        let payloadData_clro = {};
        let unitSet_dict = {};
        let wex_dict = {};
        let pex_dict = {};
        let pelton_dict = {};
        let turbo_dict = {};
        let ABoptions = {};
        let formData_cf = {};
        let formData_pump = {};
        let formData_hppump = {};
        let formData_mixSplit = {};
        let payloadData_feed = {};
        let formData_feed = {};
        let formData_stripper = {};
        let formData_dosing = {};
        let formData_edi = {};
        const element_color = {};
        let projectInfo_dict = {};
        let specifyFlow_data = {};
        let product_flow_dict_val = {};
        let feed_flow_dict_val = {};
        const unittop_sneak_peak_view = {};
        // @sudarsana on Saving the file Stream_dict is empty
        localStorage.setItem('streamNum_dict', JSON.stringify({}));
        const flowNodes = rfInstance.toObject().nodes; // added new logic in version 11 @sudarsana
        const flowEdges = rfInstance.toObject().edges;
        const flow = { elements: [...flowNodes, ...flowEdges] };  // Create an object with an 'elements' property @sudarsana

        if (localStorage.getItem('feed_flow_dict')) {
          feed_flow_dict_val = JSON.parse(localStorage.getItem('feed_flow_dict'));
        }
        if (localStorage.getItem('product_flow_dict')) {
          product_flow_dict_val = JSON.parse(localStorage.getItem('product_flow_dict'));
        }
        if (localStorage.getItem('flow_dict')) {
          specifyFlow_data = JSON.parse(localStorage.getItem('flow_dict'));
        }
        if (localStorage.getItem('ro-dict')) {
          formData_ro = get(JSON.parse(localStorage.getItem('ro-dict')), 'ro', {});
        }
        if (localStorage.getItem('clro-dict')) {
          formData_clro = get(JSON.parse(localStorage.getItem('clro-dict')), 'ro', {});
        }
        if (localStorage.getItem('feed-dict')) {
          payloadData_feed = get(JSON.parse(localStorage.getItem('feed-dict')), 'feed', {});
        }
        if (localStorage.getItem('dosing-dict')) {
          formData_dosing = get(JSON.parse(localStorage.getItem('dosing-dict')), 'Chemical_Dosing', {});
          unittop_sneak_peak_view.Chemical_Dosing = [];
          const getAllKey = Object.keys(formData_dosing);
          getAllKey.forEach((eleItem) => {
            unittop_sneak_peak_view.Chemical_Dosing.push(formData_dosing[eleItem].dosing_chemical);
          });
        }
        if (localStorage.getItem('edi-dict')) {
          formData_edi = get(JSON.parse(localStorage.getItem('edi-dict')), 'EDI', {});
          unittop_sneak_peak_view.EDI = [];
          const getAllKey = Object.keys(formData_edi);
          getAllKey.forEach((eleItem) => {
            unittop_sneak_peak_view.EDI.push(formData_edi[eleItem].model_type);
          });
        }
        if (localStorage.getItem('form')) {
          formData_feed = get(JSON.parse(localStorage.getItem('form')), 'feed', {});
        }
        if (localStorage.getItem('ro_payload')) {
          payloadData_ro = get(JSON.parse(localStorage.getItem('ro_payload')), 'ro', {});
        }
        if (localStorage.getItem('clro_payload')) {
          payloadData_clro = get(JSON.parse(localStorage.getItem('clro_payload')), 'ro', {});
        }
        if (localStorage.getItem('cf-dict')) {
          formData_cf = JSON.parse(localStorage.getItem('cf-dict'));
        }
        if (localStorage.getItem('pump-dict')) {
          formData_pump = JSON.parse(localStorage.getItem('pump-dict'));
        }
        if (localStorage.getItem('hp-pump-dict')) {
          formData_hppump = JSON.parse(localStorage.getItem('hp-pump-dict'));
        }
        if (localStorage.getItem('mixSplit-dict')) {
          formData_mixSplit = get(JSON.parse(localStorage.getItem('mixSplit-dict')), 'mixSplit', {});
        }
        if (localStorage.getItem('system-units')) {
          unitSet_dict = JSON.parse(localStorage.getItem('system-units'));
        }
        if (localStorage.getItem('options')) {
          ABoptions = JSON.parse(localStorage.getItem('options'));
        }
        if (localStorage.getItem('stripper-dict')) {
          formData_stripper = get(JSON.parse(localStorage.getItem('stripper-dict')), 'st', {});
          unittop_sneak_peak_view.Stripper = [];
          const getAllKey = Object.keys(formData_stripper);
          getAllKey.forEach((eleItem) => {
            if (formData_stripper[eleItem].stripper_flag) {
              if (formData_stripper[eleItem].target_co2 !== 0) {
                unittop_sneak_peak_view.Stripper.push('CO2');
              }
              if (formData_stripper[eleItem].target_h2s !== 0) {
                unittop_sneak_peak_view.Stripper.push('H2S');
              }
              if (formData_stripper[eleItem].target_nh3 !== 0) {
                unittop_sneak_peak_view.Stripper.push('NH3');
              }
            }
          });
        }
        if (localStorage.getItem('press_exc-dict')) {
          pex_dict = get(JSON.parse(localStorage.getItem('press_exc-dict')), 'press_exc', {});
        }
        if (localStorage.getItem('work_exc-dict')) {
          wex_dict = get(JSON.parse(localStorage.getItem('work_exc-dict')), 'work_exc', {});
          unittop_sneak_peak_view.ERD = [];
          const getAllKey = Object.keys(wex_dict);
          getAllKey.forEach((eleItem) => {
            unittop_sneak_peak_view.ERD.push(wex_dict[eleItem].erd_type == 'wex' ? 'Work Exchanger' : 'Pressure Exchanger');
          });
        }
        if (localStorage.getItem('pelton_wheel-dict')) {
          pelton_dict = get(JSON.parse(localStorage.getItem('pelton_wheel-dict')), 'pelton_exc', {});
          unittop_sneak_peak_view.ERD = [];
          const getAllKey = Object.keys(pelton_dict);
          getAllKey.forEach(() => {
            unittop_sneak_peak_view.ERD.push('Pelton Wheel');
          });
        }
        if (localStorage.getItem('turbo_charger-dict')) {
          turbo_dict = get(JSON.parse(localStorage.getItem('turbo_charger-dict')), 'TRD_data', {});
          unittop_sneak_peak_view.ERD = [];
          const getAllKey = Object.keys(turbo_dict);
          getAllKey.forEach(() => {
            unittop_sneak_peak_view.ERD.push('Turbocharger');
          });
        }
        for (let i = 0; i < flow.elements.length; i++) {
          if (flow.elements[i].source) {
            if (Object.keys(flow.elements[i].data.streamNum_dict).length > 0)
              // @sudarsana wrriten the condition here if it is undefinded or not
              if (flow.elements[i].data.streamNum_dict[flow.elements[i].data.text]) {
                flow.elements[i].data.text = flow.elements[i].data.streamNum_dict[flow.elements[i].data.text];
              } else {
                // if it is undineded go to this else condition
                flow.elements[i].data.text = streamNum_dict[flow.elements[i].data.text];
              }
          }
        }
        let flowsheet_file;
        if (fs.name == undefined) {
          flowsheet_file = fs;
        } else {
          flowsheet_file = fs.name;
        }
        if (flow.elements.length == 0) {
          setState_loader({ showResults: false });
          openModelPopUp('File seems empty, please create the flowsheet!', 'Error', 'error');
          setConvasEmpty(true); // convas is empty
          return;
        } else {
          setConvasEmpty(false); // convas is not empty
        }
        if (flowsheet_file.trim() == '' || flowsheet_file.trim().length <= 3) {
          setState_loader({ showResults: false });
          handleClickStr = 'blank';
          openModelPopUp('Please enter valid filename', 'Warning', 'warning');
          return;
        }

        if (localStorage.getItem('project_info')) {
          projectInfo_dict = JSON.parse(localStorage.getItem('project_info'));
          // ProjectInfo + Details on Save AS
          projectInfo_dict = {
            ...projectInfo_dict, filename: (fs.name == undefined) ? `${fs}.json` : `${fs.name}.json`,
            unittop_sneak_peak_view, flow_type: flowPassData
          };
        } else {
          // if file name is exist we are providing user to save that file and assign the project name as file name. ---->krnathi
          // checking for file is existed or not --->kranthi
          if (flowsheet_file) {
            const curTime = getCurrentDate();
            const locprojectInfo = {
              ...contactInfo, project_name: (flowsheet_file).trim(), filename: `${flowsheet_file}.json`,
              created_on: curTime, last_edited_on: curTime
            };
            projectInfo_dict = locprojectInfo;
            localStorage.setItem('project_info', JSON.stringify(locprojectInfo));
          } else {
            // if projectName is empty in projectInfo dict
            openModelPopUp('Please enter valid project name', 'Warning', 'warning');
            localStorage.setItem('Pinfo', 'empty');
            return;
          }
        }

        const curTime = getCurrentDate();
        projectInfo_dict.created_on = curTime;
        projectInfo_dict.last_edited_on = curTime;
        localStorage.setItem('project_info', JSON.stringify(projectInfo_dict));
        // added by chandrashekhar to update project name when user change the file name https://vwts.atlassian.net/browse/GB-3215
        if (projectInfo_dict.filename.indexOf(oldText) < 0) {
          projectInfo_dict.project_name = projectInfo_dict.filename.split('.json')[0];
        }
        // added by chandrashekhar to update project name when user change the file name https://vwts.atlassian.net/browse/GB-3215
        // ######## to get the filelist from s3 bucket to check whether same file is exist or not #############
        setState_loader({
          showResults: true
        });
        (async () => {
          const FlowData = {
            FileName: `${getUserEmail}_${flowsheet_file}.json`,
            FilePath: `winflows-s3/winflows_file_management/${getUserType}/${getUserEmail}/winfiles/${getUserEmail}_${flowsheet_file}.json`,
            flow,
            formData_ro,
            payloadData_ro,
            formData_clro,
            payloadData_clro,
            payloadData_feed,
            formData_dosing,
            formData_edi,
            formData_feed,
            formData_cf,
            formData_pump,
            formData_hppump,
            formData_mixSplit,
            unitSet_dict,
            ABoptions,
            formData_stripper,
            unitop_source,
            unitop_target,
            element_color,
            projectInfo_dict,
            specifyFlow_data,
            feed_flow_dict_val,
            product_flow_dict_val,
            wex_dict,
            pex_dict,
            pelton_dict,
            turbo_dict,
            wexpex_all_unitop,
            peltonwheel_all_unitop,
            turbocharger_all_unitop,
            clro_all_unitop
          };
          setFileDownload(FlowData);
          setFileDownloadName(text);
          // const cipher_new = encrypt_data(FlowData);
          setState_loader({ showResults: true });
          const getLocalUserEmail = sessionStorage.getItem('user_email');
          const params = { file_name: `${getLocalUserEmail}_${flowsheet_file}.json`, email: getLocalUserEmail, userType: getEmailUserType(getLocalUserEmail) };
          checkFileExists(params.file_name, params.email, params.userType).then((res) => {
            const { exist } = res.data;
            if (exist) {
              setState_loader({ showResults: false });
              openModelPopUp('A file with this name already exists. Please choose a different filename.', 'Warning', 'warning');
              // handleFileReplaceModal(
              //   `${flowsheet_file}.json`,
              //   getUserEmail,
              //   cipher_new, // flow,
              // );
            } else {
              for (let i = 0; i < flow.elements.length; i++) {
                if (flow.elements[i].id) {
                  flow.elements[i].name = localStorage.getItem(flow.elements[i].id);
                  element_color[flow.elements[i].id] = $(`.Node_${flow.elements[i].id}`).parent().parent().css('border-left-color');
                }
              }
              // const cipher_new = encrypt_data(FlowData);
              // axios({
              //   method: 'post',
              //   // url: `https://fzdb4yphq8.execute-api.us-east-1.amazonaws.com/dev/filestore?param1=${flowsheet_file}.json&param2=${getUserEmail}`, // old
              //   url: `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_file_save?param1=${flowsheet_file}.json&param2=${getUserEmail}&param3=${getUserType}`,
              //   headers: {},
              //   data:
              //     cipher_new
              //   // FlowData
              // })

              jsLogger.info('Save-As Button clicked');

              // save the log
              const logs = getLogs();
              // console.log('logs :', logs);

              // comm
              const changeJSON = {
                'fileName': `${flowsheet_file}.json`,
                'userEmail': getUserEmail,
                'userType': getEmailUserType(getUserEmail),
                'changeLog': { [getCurrentDate()]: logs },
                'env': process.env.REACT_APP_ENV
                // 'changeLog' : {[getCurrentDate()] : logFileDataChange(FlowData)}  //old one
              };

              // console.log('changeJSON : ', JSON.stringify(changeJSON));
              // axios({
              //   method: 'post',
              //   url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/logWinFileChange',
              //   headers: {},
              //   data: JSON.stringify(changeJSON)
              // })
              logWinFileChange(changeJSON)
                .then((res) => {
                  // console.log(res);
                  JustclearLog();
                })
                .catch((err) => {
                  console.log(err);
                });

              // open custom folder on save start
              saveWinflowsFileContent(`${flowsheet_file}.json`, getUserEmail, getEmailUserType(getUserEmail), encrypt_data(FlowData))
                // const source_Path = localStorage.getItem('folderStr');  // keep hold 'winflow/../..'
                // setSourcePath(source_Path);                             // used in source to create a file (work in saveAs & save)
                // const getParams = {
                //   email: getUserEmail,
                //   userType: getUserType,
                //   'operation': 'create',
                //   'file_name': `${getUserEmail}_${fs}.json`,
                //   'source_path': source_Path,
                //   'file_content': encrypt_data(FlowData),
                //   'projectInfo_dict': encrypt_data(FlowData.projectInfo_dict)
                // };
                // localStorage.removeItem('folderStr');
                // WinflowsFileManagmentAPI(getParams)
                // open custom folder on save end
                .then((res) => {
                  if (res.data.project_file_status === 'success' && res.data.winfile_status === 'success') {
                    // fileSavedSuccess = true;
                    saveFeedInputForm(flowsheet_file, getUserEmail, 'saveAs');
                    setModalIsOpen_saveDialog(false);
                    // @sudarsana here important logic written for autoSave feature here when user opened any saved files or click on save button
                    // here will compare all the id of nodes and connections if all id are matches than remove the key of item in localstorage
                    // start
                    const flowDataElements = (FlowData.flow?.elements || []).map(el => el.id).sort().join(',');
                    let savedFiles = JSON.parse(localStorage.getItem('savedFiles') || '[]');

                    Object.keys(localStorage).forEach((key) => {
                      const localValue = localStorage.getItem(key);
                      if (!localValue) return;

                      try {
                        const localData = JSON.parse(localValue);
                        const localElements = (localData.flow?.elements || []).map(el => el.id).sort().join(',');

                        if (flowDataElements === localElements) {
                          localStorage.removeItem(key);
                          // console.log(`✅ Removed matching flow.elements for key: ${key}`);
                          savedFiles = savedFiles.filter(fileName => fileName !== key);
                        }
                      } catch (e) {
                        // console.warn(`⚠️ Error parsing localStorage item for key: ${key}`, e);
                      }
                    });

                    // Update savedFiles even if it was removed
                    localStorage.setItem('savedFiles', JSON.stringify(savedFiles));
                    // end
                  } else {
                    setState_loader({ showResults: false });
                    openModelPopUp('Failed to save flow file', 'Error', 'error');
                  }
                }).catch(() => {
                  setState_loader({ showResults: false });
                  openModelPopUp('Failed to save flow file', 'Error', 'error');
                });
            }
          }).catch(() => {
            setState_loader({ showResults: false });
            openModelPopUp('Failed to fetch file list', 'Error', 'error');
          });
        })();
      }, 100);
    }
  }, [rfInstance]);

  // make onSave_saveButton as a global variable so that we can export it for canvas exit story by Abhishek on 4-Jan-24
  onSave_saveButton = async (type, email, saveStr = '') => {
    // added by chandrashekhar because remove the warning in console. START
    if (saveStr === 'disabled' && isConvasEmpty) {
      return false;
    }
    // added by chandrashekhar because remove the warning in console. END
    openProjectInfo = true;
    const unittop_sneak_peak_view = {};
    const flowNodes = rfInstance.toObject().nodes;
    const flowEdges = rfInstance.toObject().edges;
    const flow = { elements: [...flowNodes, ...flowEdges] };
    for (let i = 0; i < flow.elements.length; i++) {
      if (flow.elements[i].source) {
        if (Object.keys(flow.elements[i].data.streamNum_dict).length > 0) {
          if (flow.elements[i].data.streamNum_dict[flow.elements[i].data.text])
            flow.elements[i].data.text = flow.elements[i].data.streamNum_dict[flow.elements[i].data.text];
        }
      }
    }
    if (rfInstance) {
      setFindAllConnection(true);
      setCallExecuteFun(true);
      setTimeout(() => {
        let flag = 0;
        let getUserEmail = sessionStorage.getItem('user_email');
        const getUserType = getUserEmail.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
        let formData_ro = {};
        let payloadData_ro = {};
        let formData_clro = {};
        let payloadData_clro = {};
        let unitSet_dict = {};
        let ABoptions = {};
        let formData_cf = {};
        let formData_pump = {};
        let formData_hppump = {};
        let formData_mixSplit = {};
        let payloadData_feed = {};
        let formData_feed = {};
        let formData_stripper = {};
        let formData_dosing = {};
        let formData_edi = {};
        const element_color = {};
        let projectInfo_dict = {};
        let specifyFlow_data = {};
        let feed_flow_dict_val = {};
        let product_flow_dict_val = {};
        let wex_dict = {};
        let pex_dict = {};
        let pelton_dict = {};
        let turbo_dict = {};
        // @sudarsana on Saving the file Stream_dict is empty
        localStorage.setItem('streamNum_dict', JSON.stringify({}));
        if (localStorage.getItem('feed_flow_dict')) {
          feed_flow_dict_val = JSON.parse(localStorage.getItem('feed_flow_dict'));
        }
        if (localStorage.getItem('product_flow_dict')) {
          product_flow_dict_val = JSON.parse(localStorage.getItem('product_flow_dict'));
        }
        if (localStorage.getItem('flow_dict')) {
          specifyFlow_data = JSON.parse(localStorage.getItem('flow_dict'));
        }

        if (localStorage.getItem('ro-dict')) {
          formData_ro = get(JSON.parse(localStorage.getItem('ro-dict')), 'ro', {});
        }
        if (localStorage.getItem('clro-dict')) {
          formData_clro = get(JSON.parse(localStorage.getItem('clro-dict')), 'ro', {});
        }
        if (localStorage.getItem('feed-dict')) {
          payloadData_feed = get(JSON.parse(localStorage.getItem('feed-dict')), 'feed', {});
        }
        if (localStorage.getItem('dosing-dict')) {
          formData_dosing = get(JSON.parse(localStorage.getItem('dosing-dict')), 'Chemical_Dosing', {});
          unittop_sneak_peak_view.Chemical_Dosing = [];
          const getAllKey = Object.keys(formData_dosing);
          getAllKey.forEach((eleItem) => {
            unittop_sneak_peak_view.Chemical_Dosing.push(formData_dosing[eleItem].dosing_chemical);
          });
        }
        if (localStorage.getItem('edi-dict')) {
          formData_edi = get(JSON.parse(localStorage.getItem('edi-dict')), 'EDI', {});
          unittop_sneak_peak_view.EDI = [];
          const getAllKey = Object.keys(formData_edi);
          getAllKey.forEach((eleItem) => {
            unittop_sneak_peak_view.EDI.push(formData_edi[eleItem].model_type);
          });
        }
        if (localStorage.getItem('form')) {
          formData_feed = get(JSON.parse(localStorage.getItem('form')), 'feed', {});
        }
        if (localStorage.getItem('ro_payload')) {
          payloadData_ro = get(JSON.parse(localStorage.getItem('ro_payload')), 'ro', {});
        }
        if (localStorage.getItem('clro_payload')) {
          payloadData_clro = get(JSON.parse(localStorage.getItem('clro_payload')), 'ro', {});
        }
        if (localStorage.getItem('cf-dict')) {
          formData_cf = JSON.parse(localStorage.getItem('cf-dict'));
        }
        if (localStorage.getItem('pump-dict')) {
          formData_pump = JSON.parse(localStorage.getItem('pump-dict'));
        }
        if (localStorage.getItem('hp-pump-dict')) {
          formData_hppump = JSON.parse(localStorage.getItem('hp-pump-dict'));
        }
        if (localStorage.getItem('mixSplit-dict')) {
          formData_mixSplit = get(JSON.parse(localStorage.getItem('mixSplit-dict')), 'mixSplit', {});
        }
        if (localStorage.getItem('system-units')) {
          unitSet_dict = JSON.parse(localStorage.getItem('system-units'));
        }
        if (localStorage.getItem('options')) {
          ABoptions = JSON.parse(localStorage.getItem('options'));
        }
        if (localStorage.getItem('stripper-dict')) {
          formData_stripper = get(JSON.parse(localStorage.getItem('stripper-dict')), 'st', {});
          unittop_sneak_peak_view.Stripper = [];
          const getAllKey = Object.keys(formData_stripper);
          getAllKey.forEach((eleItem) => {
            if (formData_stripper[eleItem].stripper_flag) {
              if (formData_stripper[eleItem].target_co2 !== 0) {
                unittop_sneak_peak_view.Stripper.push('CO2');
              }
              if (formData_stripper[eleItem].target_h2s !== 0) {
                unittop_sneak_peak_view.Stripper.push('H2S');
              }
              if (formData_stripper[eleItem].target_nh3 !== 0) {
                unittop_sneak_peak_view.Stripper.push('NH3');
              }
            }
          });
        }
        if (localStorage.getItem('press_exc-dict')) {
          pex_dict = get(JSON.parse(localStorage.getItem('press_exc-dict')), 'press_exc', {});
        }
        if (localStorage.getItem('work_exc-dict')) {
          wex_dict = get(JSON.parse(localStorage.getItem('work_exc-dict')), 'work_exc', {});
          unittop_sneak_peak_view.ERD = [];
          const getAllKey = Object.keys(wex_dict);
          getAllKey.forEach((eleItem) => {
            unittop_sneak_peak_view.ERD.push(wex_dict[eleItem].erd_type == 'wex' ? 'Work Exchanger' : 'Pressure Exchanger');
          });
        }
        if (localStorage.getItem('pelton_wheel-dict')) {
          pelton_dict = get(JSON.parse(localStorage.getItem('pelton_wheel-dict')), 'pelton_exc', {});
          unittop_sneak_peak_view.ERD = [];
          const getAllKey = Object.keys(pelton_dict);
          getAllKey.forEach(() => {
            unittop_sneak_peak_view.ERD.push('Pelton Wheel');
          });
        }
        if (localStorage.getItem('turbo_charger-dict')) {
          turbo_dict = get(JSON.parse(localStorage.getItem('turbo_charger-dict')), 'TRD_data', {});
          unittop_sneak_peak_view.ERD = [];
          const getAllKey = Object.keys(turbo_dict);
          getAllKey.forEach(() => {
            unittop_sneak_peak_view.ERD.push('Turbocharger');
          });
        }
        if (email)
          getUserEmail = email;
        for (let i = 0; i < flow.elements.length; i++) {
          if (flow.elements[i].id && !flow.elements[i].id.includes('reactflow__edge')) {
            flow.elements[i].name = localStorage.getItem(flow.elements[i].id);
            element_color[flow.elements[i].id] = $(`.Node_${flow.elements[i].id}`).parent().parent().css('border-left-color');
          }
        }
        setCountInstance(flow.elements.length);
        setState_loader({ showResults: true });
        if (text == '' || text == 'filename') {
          flag = 1;
          setState_loader({
            showResults: false
          });
          handleClickStr = 'editfile';
          openModelPopUp(t('Kindly enter valid filename!'), 'Warning', 'warning');
          return;
        }
        if (localStorage.getItem('project_info')) {
          projectInfo_dict = JSON.parse(localStorage.getItem('project_info'));
          // ProjectInfo + Details on Save AS
          projectInfo_dict = {
            ...projectInfo_dict, filename: `${text}.json`, last_edited_on: getCurrentDate(),
            unittop_sneak_peak_view, flow_type: flowPassData
          };
          localStorage.setItem('project_info', JSON.stringify(projectInfo_dict));
        } else {
          // if file name is exist we are providing user to save that file and assign the project name as file name. --->kranthi
          // checking for file is existed or not --->kranthi
          if (text) {
            const locprojectInfo = {
              ...contactInfo, email: getUserEmail, project_name: (text).trim(), filename: `${text}.json`,
              created_on: getCurrentDate(), last_edited_on: getCurrentDate()
            };
            projectInfo_dict = locprojectInfo;
            localStorage.setItem('project_info', JSON.stringify(locprojectInfo));
          } else {
            // if projectName is empty in projectInfo dict
            openModelPopUp('Please enter valid project name', 'Warning', 'warning');
            localStorage.setItem('Pinfo', 'empty');
            return;
          }
        }
        // added by chandrashekhar to update project name when user change the file name https://vwts.atlassian.net/browse/GB-3215
        if (oldText.current.indexOf(text) < 0) {
          projectInfo_dict.project_name = text;
        }
        // added by chandrashekhar to update project name when user change the file name https://vwts.atlassian.net/browse/GB-3215
        if (flow.elements.length == 0) {
          flag = 1;
          setState_loader({ showResults: false });
          openModelPopUp('File seems empty, please create the flowsheet!', 'Error', 'error');
          setConvasEmpty(true); // convas is empty
          return;
        }
        else {
          setConvasEmpty(false); // convas is not empty
        }
        const FlowData = {
          FileName: `${getUserEmail}_${text}.json`,
          FilePath: `winflows-s3/winflows_file_management/${getUserType}/${getUserEmail}/winfiles/${getUserEmail}_${text}.json`,
          flow,
          formData_ro,
          payloadData_ro,
          formData_clro,
          payloadData_clro,
          payloadData_feed,
          formData_dosing,
          formData_edi,
          formData_feed,
          formData_cf,
          formData_pump,
          formData_hppump,
          formData_mixSplit,
          unitSet_dict,
          ABoptions,
          formData_stripper,
          unitop_source,
          unitop_target,
          element_color,
          projectInfo_dict,
          specifyFlow_data,
          feed_flow_dict_val,
          product_flow_dict_val,
          wex_dict,
          pex_dict,
          pelton_dict,
          turbo_dict,
          wexpex_all_unitop,
          peltonwheel_all_unitop,
          turbocharger_all_unitop,
          clro_all_unitop
        };
        setFileDownload(FlowData); // store file data
        setFileDownloadName(text); // store file name

        if (flag == 0) {
          if (text.includes('preconfig')) {
            setText(decodeURIComponent(text.split('/')[1]));
          }
          if (text.includes('temp_files')) {
            setText(decodeURIComponent(text.split('/')[1]));
          }
          if (text.includes('romachine')) {
            setText(decodeURIComponent(text.split('/')[1]));
          }
          if (text.includes('winflows_4_files')) {
            setText(decodeURIComponent(text.split('/')[1]));
          }
          if (type === 'downloadAs') {
            downloadFlowSheetJSON(FlowData, text);
            /**
             * comment by chandrashekhar because create a global function Start
             */
            // const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
            //   JSON.stringify(FlowData)
            // )}`;
            // const link = document.createElement('a');
            // link.href = jsonString;
            // link.download = `${text}.win`;
            // link.target = '_blank';
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            /**
             * comment by chandrashekhar because create a global function END
             */
            setState_loader({ showResults: false });
            setModalOption(defaultModalOptions);
          }
          else if (type == 'share') {
            // Update shared by whom in project_info_dict
            FlowData.projectInfo_dict.sharedby = sessionStorage.getItem('user_name');
            FlowData.projectInfo_dict.isRead = false;

            (async () => {
              setState_loader({ showResults: true });
              const getLocalUserEmail = sessionStorage.getItem('user_email');
              const params = { file_name: `${getLocalUserEmail}_${text}-sharedFile.json`, email: getLocalUserEmail, userType: getEmailUserType(getLocalUserEmail) };
              FlowData.projectInfo_dict.filename = `${text}-sharedFile.json`;
              curFnaam = FlowData.projectInfo_dict.filename;
              let sharedFileName = '';
              checkFileExists(params.file_name, params.email, params.userType).then((res) => {
                const { exist } = res.data;
                sharedFileName = `${text}-sharedFile.json`;
                if (exist) {
                  const randomNum = Math.random().toString(36).slice(2, 5);
                  sharedFileName = `${text}_${randomNum}-sharedFile.json`;
                }
                Promise.all(getUserEmail.map(userEmail => {
                  FlowData.FileName = `${userEmail}_${sharedFileName}.json`;
                  FlowData.FilePath = `winflows-s3/winflows_file_management/${getUserType}/${userEmail}/winfiles/${userEmail}_${sharedFileName}.json`;
                  const cipher_new = encrypt_data(FlowData);
                  return saveWinflowsFileContent(sharedFileName, userEmail, getEmailUserType(userEmail), cipher_new);
                }))
                  // saveWinflowsFileContent(sharedFileName, getUserEmail, getUserType, cipher_new)

                  // axios({
                  //   method: 'post',
                  //   // url: `https://fzdb4yphq8.execute-api.us-east-1.amazonaws.com/dev/filestore?param1=${text}-sharedFile.json&param2=${getUserEmail}`, old old
                  //   // url: `https://fzdb4yphq8.execute-api.us-east-1.amazonaws.com/dev/filestore?param1=${sharedFileName}&param2=${getUserEmail}`, // old
                  //   url: `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_file_save?param1=${sharedFileName}&param2=${getUserEmail}&param3=${getUserType}`,
                  //   headers: {},
                  //   // data: FlowData
                  //   data: cipher_new
                  // })
                  .then(() => {
                    setState_loader({ showResults: false });
                    openModelPopUp(t('File shared successfully!.'), 'Success!', 'success');
                  });
              });
            })();
          } else {
            FlowData.projectInfo_dict.filename = `${text}.json`;
            curFnaam = FlowData.projectInfo_dict.filename;
            // fileName_url = `https://fzdb4yphq8.execute-api.us-east-1.amazonaws.com/dev/filestore?param1=${text}.json&param2=${getUserEmail}`;  // old
            // fileName_url = `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_file_save?param1=${text}.json&param2=${getUserEmail}&param3=${getUserType}`;

            // Promise.all(getUserEmail.map(userEmail => saveWinflowsFileContent(`${text}.json`, userEmail, getUserType, encrypt_data(FlowData))))

            // to-do : By Abhishek for file change log task
            // console.log('While saving : ', FlowData);

            jsLogger.info('Save-Button clicked');

            const logs = getLogs();
            // console.log('logs :', logs);

            // comm
            const changeJSON = {
              'fileName': `${text}.json`,
              'userEmail': getUserEmail,
              'userType': getUserType,
              'changeLog': { [getCurrentDate()]: logs },
              'env': process.env.REACT_APP_ENV
              // 'changeLog' : {[getCurrentDate()] : logFileDataChange(FlowData)}  //old one
            };

            // console.log('changeJSON : ', JSON.stringify(changeJSON));
            // axios({
            //   method: 'post',
            //   url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/logWinFileChange',
            //   headers: {},
            //   data: JSON.stringify(changeJSON)
            // })
            logWinFileChange(changeJSON)
              .then((res) => {
                // console.log(res);
              })
              .catch((err) => {
                // console.log(err);
              });

            // open custom folder on save start
            saveWinflowsFileContent(`${text}.json`, getUserEmail, getUserType, encrypt_data(FlowData))
              // // // const source_Path = localStorage.getItem('folderStr');
              // const source_Path = localStorage.getItem('folderPath') || '';   // keep hold '../..' // use in api url to open a file
              // const getParams = {
              //   email: getUserEmail,
              //   userType: getUserType,
              //   'operation': 'create',
              //   'file_name': `${getUserEmail}_${text}.json`,
              //   'source_path': `winfiles/${source_Path}`, // sourcePath,
              //   'file_content': encrypt_data(FlowData),
              //   'projectInfo_dict': encrypt_data(FlowData.projectInfo_dict)
              // };
              // WinflowsFileManagmentAPI(getParams)
              // open custom folder on save end
              // axios({
              //   method: 'post',
              //   url: fileName_url,
              //   headers: {},
              //   data: encrypt_data(FlowData)
              //   // data: cipher_new // FlowData //
              // })
              .then((res) => {
                if (type === 'saveAs') {
                  elements.forEach(element => {
                    setElements((els) => removeElements([element], els));
                  });
                  setText('');
                }

                setState_loader({ showResults: false });
                setSelectedFileName(text);
                if (type === 'share') {
                  setState_loader({ showResults: false });
                  openModelPopUp(t('File shared successfully!.'), 'Success!', 'success');
                }
                else {
                  setState_loader({ showResults: false });
                  let fileshareflag = true;
                  isFileSaved = true;
                  if (type === 'downloadAssave') {
                    downloadFlowSheetJSON(FlowData, text);
                    /**
                    * comment by chandrashekhar because create a global function START
                    */
                    // const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
                    //   JSON.stringify(FlowData)
                    // )}`;
                    // const link = document.createElement('a');
                    // link.href = jsonString;
                    // link.download = `${text}.win`;
                    // link.target = '_blank';
                    // document.body.appendChild(link);
                    // link.click();
                    // document.body.removeChild(link);
                    /**
                    * comment by chandrashekhar because create a global function END
                    */
                    setState_loader({
                      showResults: false
                    });
                    setModalOption(defaultModalOptions);
                  } else {
                    if (newFileFlag) {
                      clearCanvas();
                    } else if (flagshareclick) {
                      flagshareclick = false;
                      fileshareflag = false;
                      setVisible_fileSharing(true);
                    }
                    if (fileshareflag) {
                      if (res.data.project_file_status === 'success' && res.data.winfile_status === 'success') {
                        // if (res.data.message.includes('success')) {
                        const oldFilesAr = getMyAndSharedFile();
                        curFnaam = `${text}.json`;
                        if (oldFilesAr && curFnaam && oldFilesAr[curFnaam]) {
                          oldFilesAr[curFnaam].last_edited_on = getCurrentDate();
                          setMyAndSharedFile(oldFilesAr); // reset my&sahredFile
                        }
                        openModelPopUp(t('File saved successfully.'), t('Successfully Done'), 'success');
                        // added by chandrashekhar to after click on save buttonto set value true START
                        setAfterSavingClick(true);
                        // added by chandrashekhar to after click on save buttonto set value true END
                        localStorage.setItem('globalExitBtn', 'false');
                        // @sudarsana here important logic written for autoSave feature here when user opened any saved files or click on save button
                        // here will compare all the id of nodes and connections if all id are matches than remove the key of item in localstorage
                        // start
                        const flowDataElements = (FlowData.flow?.elements || []).map(el => el.id).sort().join(',');
                        let savedFiles = JSON.parse(localStorage.getItem('savedFiles') || '[]');

                        Object.keys(localStorage).forEach((key) => {
                          const localValue = localStorage.getItem(key);
                          if (!localValue) return;

                          try {
                            const localData = JSON.parse(localValue);
                            const localElements = (localData.flow?.elements || []).map(el => el.id).sort().join(',');

                            if (flowDataElements === localElements) {
                              localStorage.removeItem(key);
                              // console.log(`✅ Removed matching flow.elements for key: ${key}`);
                              savedFiles = savedFiles.filter(fileName => fileName !== key);
                            }
                          } catch (e) {
                            // console.warn(`⚠️ Error parsing localStorage item for key: ${key}`, e);
                          }
                        });

                        // Update savedFiles even if it was removed
                        localStorage.setItem('savedFiles', JSON.stringify(savedFiles));
                        // end
                        // By Abhishek on 7-Jan-24: for hom btn exit -> check home btn flag and navigate
                        const homeBtnClkFlag = getHomeBtnClkFlag();
                        if (homeBtnClkFlag) {
                          setHomeBtnClkFlag(false);
                          navigate('/recent-files-list');
                          setChecked(false);
                        }
                      }
                      else {
                        setState_loader({ showResults: false });
                        openModelPopUp('Failed to save feed input.', 'Error', 'error');
                      }
                    }
                  };
                }
                flowPassData = '';
              }).catch(() => {
                setState_loader({ showResults: false });
                openModelPopUp('Failed to save feed input.', 'Error', 'error');
              });
          }
        }
      }, 200);
    }
  };
  // download the flowsheet when user click on download button.
  const onDownload_Button = async (downloadStr = '') => {
    // added by chandrashekhar because remove the warning in console. START
    if (downloadStr === 'disabled' && isConvasEmpty) {
      return false;
    }
    // added by chandrashekhar because remove the warning in console. END
    openProjectInfo = true;
    const flowNodes = rfInstance.toObject().nodes;
    const flowEdges = rfInstance.toObject().edges;
    const flow = { elements: [...flowNodes, ...flowEdges] };
    for (let i = 0; i < flow.elements.length; i++) {
      if (flow.elements[i].source) {
        if (Object.keys(flow.elements[i].data.streamNum_dict).length > 0) {
          if (flow.elements[i].data.streamNum_dict[flow.elements[i].data.text])
            flow.elements[i].data.text = flow.elements[i].data.streamNum_dict[flow.elements[i].data.text];
        }
      }
    }
    if (rfInstance) {
      const convasNodes = $('.react-flow__nodes').children().length;
      if (convasNodes > 0 && isFileSaved == false) { // checking whether file is already saved or not.
        onSave_saveButton('downloadAs'); // call onSave_saveButton function before downloading
      } else {
        /**
         * comment by chandrashekhar because create a global function START
         */

        jsLogger.info('Download Button clicked');

        // save the log
        const logs = getLogs();
        // console.log('logs :', logs);

        // comm
        const changeJSON = {
          'fileName': `${text}.json`,
          'userEmail': getUserEmail,
          'userType': getEmailUserType(getUserEmail),
          'changeLog': { [getCurrentDate()]: logs },
          'env': process.env.REACT_APP_ENV
          // 'changeLog' : {[getCurrentDate()] : logFileDataChange(FlowData)}  //old one
        };

        // console.log('changeJSON : ', JSON.stringify(changeJSON));
        // axios({
        //   method: 'post',
        //   url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/logWinFileChange',
        //   headers: {},
        //   data: JSON.stringify(changeJSON)
        // })
        logWinFileChange(changeJSON)
          .then((res) => {
            // console.log(res);
          })
          .catch((err) => {
            // console.log(err);
          });

        downloadFlowSheetJSON(fileDownload, text);
        // const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
        //   JSON.stringify(fileDownload)
        // )}`; // converting file into string data
        // const link = document.createElement('a'); // creating ancher tag
        // link.href = jsonString;
        // // link.download = `${fileDownloadName}.win`; // creating file name
        // // eslint-disable-next-line
        // link.download = `${fileDownloadName ? fileDownloadName : text}.win`; // creating file name
        // link.target = '_blank';
        // document.body.appendChild(link);
        // link.click(); // dynamicaly performaing clicking action through ancher tag
        // document.body.removeChild(link); // removing already created ancher tag
        /**
         * comment by chandrashekhar because create a global function END
         */
        setState_loader({
          showResults: false
        }); // disabling loading icons
      };
    };
  };
  // ######## function to use while clearing the canvas and related dependency #######
  const resetVariable = () => {
    removeItemFromLocalStorage();
    c_edi = []; c_feed = []; c_chemical_dosing = []; c_wex = []; c_mixsplit = []; c_product = []; c_pump = []; c_boosterPump = []; c_rectangle = []; c_box_RO_HP = [];
    c_pump_hp = []; c_ro = []; c_wasteout = []; c_roPump = []; cartridge_feed = []; c_stripper = []; c_pelton_wheel = []; c_Turbo_Charger = []; edge_id_details = []; edge_details_SaveFiles = [];
    connectionInfo = {};
    connectionInfo_source_target = {};
    default_pump_ro_connection = {};
    ro_connection = {};
    wexpex_connection = {};
    pump_connection = {};
    mixSplit_connection = {};
    peltonwheel_connection = {};
    turbocharger_connection = {};
    mixSplit_source = [];
    mixSplit_target = [];
    streamNum_dict = {};
    unitop_source = [];
    unitop_target = [];
    unitop_edge = [];
    unitopdelete = [];
    wexpex_all_unitop = [];
    clro_all_unitop = [];
    roPump_all_unitops = [];
    groupFeeddAA = [];
    peltonwheel_all_unitop = [];
    turbocharger_all_unitop = [];
    isFileSaved = false;
    isWexPex = false;
    isRoPump = false;
    isNfPump = false;
    isclro = false;
    isPeltonWheel = false;
    isturbocharger = false;
    node1 = [];
    withoutDeletionDublicateTurbo = false;
    withoutDeletionDublicatePeltonWheel = false;
    withoutDeletionDublicateERD = false;
    withoutDuplicateWaterCompWithAA = false;
    sourceYIncrement = 20;
    increment = 5;
  };
  const handleConfirm_reset = (isClose = false) => {
    if (isClose) {
      autoRemoveFiles(); // when it is clear need to remove autoSaved key particular file
      jsLogger.info('Reset - Yes Clicked');
      setChecked(false);
      resetAbValFactCheckedDict();
      setEdgeText(0);
      setClonedEdgeText(0);
      setModalOption(defaultModalOptions);
      setModalIsOpen_reset(true);
      // Added to Reset in version 11 logic implemented @sudarsana
      setElements((els) => els.filter((element) => !elements.includes(element)));
      setEdges((els) => els.filter((edge) => !edges.includes(edge)));
      localStorage.removeItem('form');
      localStorage.removeItem('activecells');
      localStorage.removeItem('storeNodes');
      resetVariable();
      setIsElementModelAccess(false);
      checked_ResetButton = 1;
      disabledStripperAndExplorerTab();
      setTimeout(() => {
        removeLocalStorageValue();
        executeOptionFlag = false;
      }, 100);
      localStorage.setItem('globalExitBtn', 'false');
      convasEmptyFun();
      isFileSaved = false;
      // if (window.location.href.includes('?')) {
      //   window.history.pushState({}, null, window.location.href.split('?')[0]);
      // }
      setTimeout(() => {
        setVisiblePi(true);
        setIsElementModelAccess(false);
      }, 111);

      // setTimeout(() => {
      //   autoRemoveFiles();
      // }, 1000);
    }
  };

  const onReset = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      message: t('Do you want to clear the canvas?'),
      yesOrNo: true,
      onNo: () => setModalOption(defaultModalOptions),
      onYes: () => handleConfirm_reset(true),
      type: 'warning'
    });
  };

  // ######################### End #########################################

  // ######################### New file operation #########################################

  const onNewFile = (event) => {
    jsLogger.info('New Canvas Clicked');
    openPI_onNew_yes = true;
    // GB-680 - Alert on onClick of NEW Button
    event.stopPropagation();
    checked_newButton = 1;
    convasEmptyFun();
    const globalExitBtn = JSON.parse(localStorage.getItem('globalExitBtn'));
    setVisibleDefaultuints(true);
    if (globalExitBtn) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: t('Do you want to save the file?'),
        yesOrNo: true,
        onNo: () => onCanvasClear(),
        onYes: () => saveBeforeCanvasClear(),
        type: 'warning'
      });

    } else {
      onCanvasClear();
    }
  };

  const saveBeforeCanvasClear = () => {
    setChecked(false);
    newFileFlag = true;
    setModalOption(defaultModalOptions);
    onSave_saveButton();
  };
  const onCanvasClear = () => {
    autoRemoveFiles(); // when it is clear need to remove autoSaved key particular file
    setChecked(false);
    localStorage.removeItem('project_info');
    localStorage.removeItem('default_unit_set_dict');
    clearCanvas();
    setModalOption(defaultModalOptions);
    setIsElementModelAccess(false);
    setVisibleDefaultuints(true);
    // if(isConvasEmpty){
    setVisiblePi(true);
    setIsElementModelAccess(false);
    // setTimeout(() => {
    //   autoRemoveFiles();
    // }, 1000);
    // }
  };
  const clearCanvas = () => {
    flagshareclick = false;
    // Added to clearCanvas in version 11 logic implemented @sudarsana
    setElements((els) => els.filter((element) => !elements.includes(element)));
    setEdges((els) => els.filter((edge) => !edges.includes(edge)));
    setText('');
    setEdgeText(0);
    setClonedEdgeText(0);
    resetVariable();
    // if (window.location.href.includes('?')) {
    //   window.history.pushState({}, null, window.location.href.split('?')[0]);
    // }
    disabledStripperAndExplorerTab();
    setTimeout(() => {
      removeLocalStorageValue();
      executeOptionFlag = false;
    }, 100);
    isFileSaved = false;
    newFileFlag = false;
    localStorage.setItem('globalExitBtn', 'false');
    // isClroPresent = false;
    convasEmptyFun();
  };
  const onRestore = () => {
    jsLogger.info('Load File Clicked');
    $('.ReactModal__Content').show();
    $('.ReactModal__Overlay').show();
    setModalIsOpen_filehandle(true);
  };

  const getFlowSheetData = useCallback((response, fname, strEle = '') => {
    const connectionHandle = {};
    const connectionInfoSourceTarget = {};
    if (strEle === 'animelistCalled') {
      flagCalledLocalStorage = strEle;
      // if (window.location.href.includes('?')) {
      //   window.history.pushState({}, null, window.location.href.split('?')[0]);
      // }
    }
    let replaceNameinLocalstorage = [];
    const restoreFlow = async () => {
      const { flow } = response;
      const data = flow.elements;
      const filteritems_hppump = data.filter((values) => values.id.startsWith('hppump') || values.id.startsWith('roPump') || values.id.startsWith('pump'));
      replaceNameinLocalstorage = filteritems_hppump.map((values) => values.id);
      if (flow) {
        executeOptionFlag = true;
        streamNum_dict = {};
        for (let i = 0; i < flow.elements.length; i++) {
          if (flow.elements[i].id) {
            if (['', 'null', null].indexOf(flow.elements[i].name) < 0) {
              localStorage.setItem(flow.elements[i].id, flow.elements[i].name);
            }
            node1.push(flow.elements[i]);
          }
          // ######### Temporarly added -> change source and target edi value from cf to edi #######
          if (flow.elements[i].source) {
            if (flow.elements[i].source.replace(/[\d_]+/g, '') === 'cf') {
              const val = flow.elements[i].source.split('_');
              val[0] = 'edi_';
              flow.elements[i].source = val[0].concat(val[1]);
            }
            // @sudarsana here condition written for 'mixsplit', because after open the file that mixsplit connection are not happening
            if (flow.elements[i].source.replace(/[\d_]+/g, '') !== 'mixsplit') {
              connectionHandle[`${flow.elements[i].source}${flow.elements[i].sourceHandle}`] = flow.elements[i].sourceHandle;
            }
          }
          if (flow.elements[i].target) {
            if (flow.elements[i].target.replace(/[\d_]+/g, '') === 'cf') {
              const val = flow.elements[i].target.split('_');
              val[0] = 'edi_';
              flow.elements[i].target = val[0].concat(val[1]);
            }
            // @sudarsana here condition written for 'mixsplit', because after open the file that mixsplit connection are not happening
            if (flow.elements[i].target.replace(/[\d_]+/g, '') !== 'mixsplit') {
              connectionHandle[`${flow.elements[i].target}${flow.elements[i].targetHandle}`] = flow.elements[i].targetHandle;
            }
            connectionInfoSourceTarget[`${flow.elements[i].source}`] = flow.elements[i].target;
          }
          // ######### Temporarly added -> change source and target RO value from cls to ro #######
          if (flow.elements[i].source) {
            if (flow.elements[i].source.replace(/[\d_]+/g, '') === 'cls') {
              const val = flow.elements[i].source.split('_');
              val[0] = 'ro_';
              flow.elements[i].source = val[0].concat(val[1]);
            }
          }

          if (flow.elements[i].target) {
            if (flow.elements[i].target.replace(/[\d_]+/g, '') === 'cls') {
              const val = flow.elements[i].target.split('_');
              val[0] = 'ro_';
              flow.elements[i].target = val[0].concat(val[1]);
            }
          }
          // ######################################################################
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'stripper') {
            c_stripper.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'feed') {
            c_feed.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'cf') {
            const val = flow.elements[i].id.split('_');
            val[0] = 'edi_';
            flow.elements[i].id = val[0].concat(val[1]);
            c_edi.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          else if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'edi') {
            c_edi.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'cls') {
            const val = flow.elements[i].id.split('_');
            val[0] = 'ro_';
            flow.elements[i].id = val[0].concat(val[1]);
            c_ro.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          else if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'ro') {
            c_ro.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          else if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'nf') {
            c_ro.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'roPump') {
            c_roPump.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'nfPump') {
            c_roPump.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'hppump') {
            c_pump_hp.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'groupROHP') {
            c_box_RO_HP.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'rectangle') {
            c_rectangle.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'boosterpump') {
            c_boosterPump.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'pump') {
            c_pump.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'product') {
            c_product.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'wasteout') {
            c_wasteout.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'mixsplit') {
            c_mixsplit.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));

          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'chemicaldosing') {
            c_chemical_dosing.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'wex') {
            c_wex.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'peltonwheel') {
            c_pelton_wheel.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'TC') {
            c_Turbo_Charger.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].id.replace(/[\d_]+/g, '') === 'cartridge') {
            cartridge_feed.push(Number(flow.elements[i].id.substring(flow.elements[i].id.indexOf('_') + 1)));
          }
          if (flow.elements[i].source) {
            localStorage.setItem('loadCheck', flow.elements[i].data);
            // @sudarsana here we commented this line because of sometimes- streamNum_dict  getting undefined
            // @sudarsana Due to this sloved issue we called one function at bottom updateVaue() --> for this is update streamNum_dict correctly
            // streamNum_dict[flow.elements[i].data.text] = flow.elements[i].data.streamNum_dict[flow.elements[i].data.text];
            mixSplit_source.push(flow.elements[i].source);
            mixSplit_target.push(flow.elements[i].target);
          }
        }
        wexpex_all_unitop = [];
        if (response.wexpex_all_unitop) {
          wexpex_all_unitop = response.wexpex_all_unitop;
          // @sudarsana add the bellow logic to fix the bug when deleting ERD in saved files
          const wexpex_all_unitop_all_ids = wexpex_all_unitop.map(values => values.id);
          node1 = node1.filter(node => !wexpex_all_unitop_all_ids.includes(node.id));
        }
        peltonwheel_all_unitop = [];
        if (response.peltonwheel_all_unitop) {
          peltonwheel_all_unitop = response.peltonwheel_all_unitop;
          // @sudarsana add the bellow logic to fix the bug when deleting ERD in saved files
          const peltonwheel_all_unitop_all_ids = peltonwheel_all_unitop.map(values => values.id);
          node1 = node1.filter(node => !peltonwheel_all_unitop_all_ids.includes(node.id));
        }
        turbocharger_all_unitop = [];
        if (response.turbocharger_all_unitop) {
          turbocharger_all_unitop = response.turbocharger_all_unitop;
          // @sudarsana add the bellow logic to fix the bug when deleting ERD in saved files
          const turbocharger_all_unitop_all_ids = turbocharger_all_unitop.map(values => values.id);
          node1 = node1.filter(node => !turbocharger_all_unitop_all_ids.includes(node.id));
        }
        clro_all_unitop = [];
        if (response.clro_all_unitop) {
          clro_all_unitop = response.clro_all_unitop;
        }
        // for hiding delete icon in WEX related mixer-splitter
        // @sudarsana added here setTimeout to fixed the bug about hide the delete icon in mixspilt in wex/pex
        setTimeout(() => {
          wexpex_all_unitop.forEach((item) => {
            removeCrossIcon(item);
          });
        });
        // end

        setCountInstance(flow.elements.length);
        const onlyElements = [];
        const onlyEdges = [];
        for (let i = 0; i < flow.elements.length; i++) {
          const item = flow.elements[i];
          if (item.position) {
            onlyElements.push(item);
          } else {
            item.data.connection_number = false;
            // @sudarsana this for condtion for without update the edge in subnetwork
            if ((item.source).replace(/[\d_]+/g, '') === 'hppump' && (item.target).replace(/[\d_]+/g, '') === 'roPump') {
              item.data.subnetwork = false;
            }
            if ((item.source).replace(/[\d_]+/g, '') === 'hppump' && (item.target).replace(/[\d_]+/g, '') === 'nfPump') {
              item.data.subnetwork = false;
            }
            // Check if sourceYIncrement is missing and add it if necessary
            if ((!item.data.hasOwnProperty('sourceYIncrement'))) {
              sourceYIncrement += 10;
              item.data.sourceYIncrement = sourceYIncrement;
            } else if (item.data.hasOwnProperty('sourceYIncrement')) {
              sourceYIncrement += 10;
              item.data.sourceYIncrement = sourceYIncrement;
            }
            edge_id_details.push(item);
            edge_details_SaveFiles.push(item);
            onlyEdges.push(item);
          }
        }
        setElements(onlyElements || []);
        setEdges(onlyEdges || []);
        // @sudarsana here we are calling updateValue() function reason for update Streamdict data properly when we taking any file from design canvas
        updateValue();
        disabledStripperAndExplorerTab();
      }
    };
    setText(decodeURIComponent(fname));
    restoreFlow();
    setModalIsOpen_filehandle(false);
    localStorage.removeItem('loadCheck');
    if (response.unitop_source) {
      unitop_source = response.unitop_source;
      unitop_target = response.unitop_target;
      connectionInfo = connectionHandle; // response.connectionInfo;
      connectionInfo_source_target = connectionInfoSourceTarget; // response.connectionInfo_source_target;
    }
    const unitop_source_new = [];
    const unitop_target_new = [];
    for (let i = 0; i < response.flow.elements.length; i++) {
      if (response.element_color && response.flow.elements[i].id.length < 23) {
        if (response.element_color[response.flow.elements[i].id] == 'rgba(0, 0, 0, 0)') {
          getBorderColor(response.flow.elements[i].id, 'add');
        } else {
          if (unSavedgetProjectInfoOpenFlag()) {
            setTimeout(() => {
              getBorderColor(response.flow.elements[i].id);
            }, 500);
          } else {
            getBorderColor(response.flow.elements[i].id);
          }
        }
      }
      if (response.flow.elements[i].source) {
        // @sudarsana bug fixing after saving if connecting get issue starting code
        // @sudarsana here modified changes for bug fixing GB-2008
        unitop_source_new.push(response.flow.elements[i].source + response.flow.elements[i].sourceHandle);
        unitop_target_new.push(response.flow.elements[i].target + response.flow.elements[i].targetHandle);
        // @sudarsana ending code bug fixing
      }
    }
    unitop_source = [...unitop_source_new];
    unitop_target = [...unitop_target_new];
    // we are clicking fitview button after loading the flowsheet ----->kranthi
    setTimeout(() => {
      if (!(response.flow.elements.length <= 12))
        $('.react-flow__controls-fitview').click();
    }, 1);
    // sudarsana fixed the bug for updating existing localstorage values
    replaceNameinLocalstorage.forEach(key => {
      const value = localStorage.getItem(key);
      let newValue = '';
      if (value.startsWith('HP_Pump')) {
        newValue = value.replace('HP_Pump', 'HPP');
        localStorage.setItem(key, newValue);
      }
      if (value.startsWith('pump')) {
        newValue = value.replace('pump', 'Pump');
        localStorage.setItem(key, newValue);
      }
      if (value.startsWith('RO_ERD')) {
        newValue = value.replace('RO_ERD', 'ROERD');
        localStorage.setItem(key, newValue);
      } else if (value.startsWith('RO-HP')) {
        newValue = value.replace('RO-HP', 'ROHP');
        localStorage.setItem(key, newValue);
      } else if (value.startsWith('RO_PW')) {
        newValue = value.replace('RO_PW', 'ROPW');
        localStorage.setItem(key, newValue);
      } else if (value.startsWith('RO_TC')) {
        newValue = value.replace('RO_TC', 'ROTC');
        localStorage.setItem(key, newValue);
      }
    });
  }, [setElements]);

  function splitPathAndFileName(fullPath) {
    // Check if the input is a string
    if (typeof fullPath !== 'string') {
      throw new Error('Input must be a string');
    }

    // Handle empty string
    if (fullPath.trim() === '') {
      return { folderPath: '', fileName: '' };
    }

    // Find the last occurrence of '/' to separate folder path and file name
    const lastSlashIndex = fullPath.lastIndexOf('/');

    // If no slash found, there's no folder path
    if (lastSlashIndex === -1) {
      return { folderPath: '', fileName: fullPath };
    }

    // Extract folder path and file name
    const folderPath = fullPath.substring(0, lastSlashIndex + 1); // Include the trailing slash
    const fileName = fullPath.substring(lastSlashIndex + 1);

    return { folderPath, fileName };
  }

  /* This function gets called �when user comes to canvas from Recent files or Preconfig Files module */
  const fetchData = async (fileName, isupload, data) => {
    const decodedString = decodeURIComponent(fileName);
    JustclearLog();
    set_curr_file_name(decodedString);
    setFetchLoading(true);
    setIsElementModelAccess(false); // by Abhi @ 29-5 to reset the yellow triangle warning issue
    itemToBePassIn_ro_elem_shared_access = ''; // reset this variable also which is used to pass as a prop to check for yellow triangle
    // if(data === undefined){
    //   return;
    // }
    function responseData(response) {
      let response_final = '';
      let val = fileName.split('.json')[0];
      if (val.includes('preconfig')) {
        // val = val.split('/')[1];
        val = val.split('/')[2];
        setVisibleDefaultuints(false);
      }
      if (val.includes('temp_files')) {
        val = val.split('/')[1];
        setVisibleDefaultuints(false);
      }
      if (val.includes('romachine')) {
        val = val.split('/')[1];
        setVisibleDefaultuints(false);
      }
      if (val.includes('winflows_4_files')) {
        val = val.split('/')[1];
        setVisibleDefaultuints(false);
      }
      if (val.indexOf('-sharedFile') >= 0) {
        val = val.split('-sharedFile')[0];
        setVisibleDefaultuints(false);
      }
      if (!isupload) {
        if (response.data[0] !== '{' && response.data[0] !== undefined) {
          // adding condition to make old files work - 20/07/2023
          const res_data = response.data.split('"')[1];
          if (res_data) {
            response_final = decrypt_data(res_data);
          } else {
            response_final = decrypt_data(response.data);
          }
        } else {
          const final_data = JSON.parse(response.data);
          response_final = final_data;
        }
      } else {
        response_final = response;
      }
      // Ensure response_final is parsed as JSON object if it's a string edit by Kranthi
      response_final = typeof response_final === 'string' ? JSON.parse(response_final) : response_final;
      // to-do : By Abhishek for file change log task
      // console.log('while opening : ', response_final);
      if (Object.prototype.toString.call(response_final) === '[object String]') {
        response_final = JSON.parse(response_final);
      }
      fileDataWhenOpen = response_final;

      // ############# function to create flowsheet #############
      getFlowSheetData(response_final, val);
      // ############## remove dict from local storage ###########
      removeItemFromLocalStorage();
      // ############# Chemical Dosing data ##############
      if (response_final.formData_dosing && Object.keys(response_final.formData_dosing).length) {
        const dosing_data = {
          Chemical_Dosing: response_final.formData_dosing
        };
        localStorage.setItem('dosing-dict', JSON.stringify(dosing_data));
      }
      // ############# EDI data ##############
      if (response_final.formData_edi && Object.keys(response_final.formData_edi).length) {
        // ############## Temporarly converting cf id to edi id in edi-dict ############
        const tempVar = Object.keys(response_final.formData_edi);
        tempVar.forEach((item, index) => {
          if (item.replace(/[\d_]+/g, '') === 'cf') {
            const val = item.split('_');
            val[0] = 'edi_';
            tempVar[index] = val[0].concat(val[1]);
            // ############ Dictionary to add new key value and delete prevoius keys ##################
            Object.assign(response_final.formData_edi, { [tempVar[index]]: response_final.formData_edi[item] })[item];
            delete response_final.formData_edi[item];
          }
        });
        const edi_data = {
          EDI: response_final.formData_edi
        };
        localStorage.setItem('edi-dict', JSON.stringify(edi_data));
      }
      // ############# feed payload data ##############
      if (response_final.payloadData_feed && Object.keys(response_final.payloadData_feed).length) {
        const feed_payload = {
          feed: response_final.payloadData_feed
        };
        localStorage.setItem('feed-dict', JSON.stringify(feed_payload));
      }
      // ############### Stripper Data ###################
      if (response_final.formData_stripper && Object.keys(response_final.formData_stripper).length) {
        const formdatastripper = {
          st: response_final.formData_stripper
        };
        localStorage.setItem('stripper-dict', JSON.stringify(formdatastripper));
      }
      if (response_final.wex_dict && Object.keys(response_final.wex_dict).length) {
        const workExcDict = {
          work_exc: response_final.wex_dict
        };
        localStorage.setItem('work_exc-dict', JSON.stringify(workExcDict));
        defaultSetUnitsetdict('current-unit-work', response_final.unitSet_dict);
      }
      if (response_final.pex_dict && Object.keys(response_final.pex_dict).length) {
        const pressExcDict = {
          press_exc: response_final.pex_dict
        };
        localStorage.setItem('press_exc-dict', JSON.stringify(pressExcDict));
        defaultSetUnitsetdict('current-unit-work', response_final.unitSet_dict);
      }
      if (response_final.pelton_dict && Object.keys(response_final.pelton_dict).length) {
        const peltonDict = {
          pelton_exc: response_final.pelton_dict
        };
        localStorage.setItem('pelton_wheel-dict', JSON.stringify(peltonDict));
        defaultSetUnitsetdict('pelton-unit-work', response_final.unitSet_dict);
      }
      if (response_final.turbo_dict && Object.keys(response_final.turbo_dict).length) {
        const turboDict = {
          TRD_data: response_final.turbo_dict
        };
        localStorage.setItem('turbo_charger-dict', JSON.stringify(turboDict));
        defaultSetUnitsetdict('turbo-unit-work', response_final.unitSet_dict);
      }
      // ############# feed form data ##############
      if (response_final.formData_feed && Object.keys(response_final.formData_feed).length) {
        const feed_data = {
          feed: response_final.formData_feed
        };
        // folling code has been added to check the ion balance of feed form in case feed is not charge balanced for a saved file
        // borader color will be red for that feed form
        // Extract cation and anion sums directly using array destructuring and find
        // Get all feed IDs from formData_feed
        const feedIds = Object.keys(response_final.formData_feed || {});
        // Process each feed ID
        feedIds.forEach(feedId => {
          const gridData = response_final.formData_feed?.[feedId]?.["grid-data"];

          // Check if gridData exists before processing
          if (gridData) {
            const meqValues = gridData.map(item => item.Meq);

            // Use direct array indexing instead of forEach loop
            const sum_cation = meqValues[9];   // sum of Cation (in meq/l)
            const sum_anion = meqValues[22];   // sum of anion (in meq/l)

            // Compare with tolerance to handle floating point precision issues
            const tolerance = 0.0001;
            const isBalanced = Math.abs(sum_cation - sum_anion) < tolerance;
            if (!isBalanced) {
              // Handle unbalanced case
              getBorderColor(feedId, 'add');
            };
          }
        });
        localStorage.setItem('form', JSON.stringify(feed_data));
      }
      // ############# ro payload data ##############
      if (response_final.payloadData_ro && Object.keys(response_final.payloadData_ro).length) {
        // ############## Temporarly converting cls id to ro id in ro-dict ############
        const tempVar = Object.keys(response_final.payloadData_ro);
        tempVar.forEach((item, index) => {
          if (item.replace(/[\d_]+/g, '') === 'cls') {
            const val = item.split('_');
            val[0] = 'ro_';
            tempVar[index] = val[0].concat(val[1]);
            // ############ Dictionary to add new key value and delete prevoius keys ##################
            Object.assign(response_final.payloadData_ro, { [tempVar[index]]: response_final.payloadData_ro[item] })[item];
            delete response_final.payloadData_ro[item];
          }
        });

        const payloadData_ro = {
          ro: response_final.payloadData_ro
        };
        localStorage.setItem('ro_payload', JSON.stringify(payloadData_ro));
      }
      // ######################### ro form data #############
      if (response_final.formData_ro && Object.keys(response_final.formData_ro).length) {
        // ############## Temporarly converting cls id to ro id in ro-dict ############
        const tempVar = Object.keys(response_final.formData_ro);
        tempVar.forEach((item, index) => {
          if (item.replace(/[\d_]+/g, '') === 'cls') {
            const val = item.split('_');
            val[0] = 'ro_';
            tempVar[index] = val[0].concat(val[1]);
            // ############ Dictionary to add new key value and delete prevoius keys ##################
            Object.assign(response_final.formData_ro, { [tempVar[index]]: response_final.formData_ro[item] })[item];
            delete response_final.formData_ro[item];
          }
        });
        const ro_data = {
          ro: response_final.formData_ro
        };
        localStorage.setItem('ro-dict', JSON.stringify(ro_data));
        // set all ro id in ab value dict.
        const ROarr = Object.keys(response_final.formData_ro);
        for (let i = 0; i < ROarr.length; i++) {
          addInABFobj(ROarr[i], false);
        }
        itemToBePassIn_ro_elem_shared_access = response_final.formData_ro || '';
      }
      // ######################### clro form data #############
      if (response_final.formData_clro && Object.keys(response_final.formData_clro).length) {
        // ############## Temporarly converting cls id to ro id in clro-dict ############
        const tempVar = Object.keys(response_final.formData_clro);
        tempVar.forEach((item, index) => {
          if (item.replace(/[\d_]+/g, '') === 'cls') {
            const val = item.split('_');
            val[0] = 'clro_';
            tempVar[index] = val[0].concat(val[1]);
            // ############ Dictionary to add new key value and delete prevoius keys ##################
            Object.assign(response_final.formData_clro, { [tempVar[index]]: response_final.formData_clro[item] })[item];
            delete response_final.formData_clro[item];
          }
        });
        const clro_data = {
          ro: response_final.formData_clro
        };
        localStorage.setItem('clro-dict', JSON.stringify(clro_data));
        // localStorage.setItem('clro_payload', JSON.stringify(clro_data));
        // set all clro id in ab value dict.
        const CLROarr = Object.keys(response_final.formData_clro);
        for (let i = 0; i < CLROarr.length; i++) {
          addInABFobj(CLROarr[i], false);
        }

        if (isObjectEmpty(response_final.formData_ro)) {
          itemToBePassIn_ro_elem_shared_access = response_final.formData_ro || '';
        }
        if (isObjectEmpty(response_final.formData_clro)) {
          itemToBePassIn_ro_elem_shared_access = response_final.formData_clro || '';
        }
      }
      // ############# clro payload data ##############
      if (response_final.payloadData_clro) {
        // ############## Temporarly converting cls id to ro id in clro-dict ############
        const tempVar = Object.keys(response_final.payloadData_clro);
        tempVar.forEach((item, index) => {
          if (item.replace(/[\d_]+/g, '') === 'cls') {
            const val = item.split('_');
            val[0] = 'clro_';
            tempVar[index] = val[0].concat(val[1]);
            // ############ Dictionary to add new key value and delete prevoius keys ##################
            Object.assign(response_final.payloadData_clro, { [tempVar[index]]: response_final.payloadData_clro[item] })[item];
            delete response_final.payloadData_clro[item];
          }
        });
        const payloadData_clro = {
          ro: response_final.payloadData_clro
        };
        localStorage.setItem('clro_payload', JSON.stringify(payloadData_clro));
      }
      // ############ mixer-splitter form data #########
      if (response_final.formData_mixSplit && Object.keys(response_final.formData_mixSplit).length) {
        const mixSplit_data = {
          mixSplit: response_final.formData_mixSplit
        };
        localStorage.setItem('mixSplit-dict', JSON.stringify(mixSplit_data));
      }
      // ############# cf form data ##############
      if (response_final.formData_cf && Object.keys(response_final.formData_cf).length) {
        const cf_data = {
          cf: response_final.formData_cf
        };
        localStorage.setItem('cf-dict', JSON.stringify(cf_data.cf));
      }
      // ############# pump form data ##############
      if (response_final.formData_pump && Object.keys(response_final.formData_pump).length) {
        const pump_data = {
          pump: response_final.formData_pump
        };
        localStorage.setItem('pump-dict', JSON.stringify(pump_data.pump));
      }
      // ############# hppump form data ##############
      if (response_final.formData_hppump && Object.keys(response_final.formData_hppump).length) {
        const hppump_data = {
          hppump: response_final.formData_hppump
        };
        localStorage.setItem('hp-pump-dict', JSON.stringify(hppump_data.hppump));
      }
      // ################ unit set data #########
      if (response_final.unitSet_dict.pressure === 'Mpa') {
        response_final.unitSet_dict.pressure = 'MPa';
      }
      localStorage.setItem('system-units', JSON.stringify(response_final.unitSet_dict));
      localStorage.setItem('previous_ro_pressure_unit', response_final.unitSet_dict.pressure);
      // ############# A&B options #################
      if (response_final.ABoptions) {
        localStorage.setItem('options', JSON.stringify(response_final.ABoptions));
      }
      // ############# Project Info #################
      if (response_final.projectInfo_dict) {
        localStorage.setItem('project_info', JSON.stringify(response_final.projectInfo_dict));
      }

      // CLRO Access check
      let isClroPresent = false;
      if (isObjectEmpty(response_final.formData_clro)) { // if clro form have value
        isClroPresent = true;
      }
      const isClroAccess = check_CLRO_access(getUserDictData(), 'CLRO User');
      setClroAccess(isClroAccess);
      if (isClroPresent && isClroAccess == false) {
        // todo : Show warning
        localStorage.setItem('CLROinfo', 'empty');
        openModelPopUp('You don\'t have DSSRO access', 'Error', 'error');
      }
      // nf module check
      let isNfModulePresent = false;
      if (isObjectEmpty(response_final.formData_ro)) { // if clro form have value
        const nfFind = Object.keys(response_final.formData_ro).filter((key) => key.startsWith('nf'));
        if (nfFind.length > 0) {
          isNfModulePresent = true;
        }
      }
      const isNFAccess = check_CLRO_access(getUserDictData(), 'NF Module');
      if (isNfModulePresent && isNFAccess == false) {
        // todo : Show warning
        localStorage.setItem('CLROinfo', 'empty');
        openModelPopUp('You don\'t have NF Module access', 'Error', 'error');
      }
       // argo module check
      let isArgoModulePresent = false;
      if (isObjectEmpty(response_final.payloadData_ro)) { // if argo form have value
        const nfFind = Object.keys(response_final.payloadData_ro).filter((key) => key.startsWith('Argo'));
        if (nfFind.length > 0) {
          isArgoModulePresent = true;
        }
      }
      const isArgoAccess = check_CLRO_access(getUserDictData(), '');
      if (isArgoModulePresent && isArgoAccess == false) {
        // todo : Show warning
        // localStorage.setItem('CLROinfo', 'empty');
        openModelPopUp('You don\'t have Argo Analyzer Module access', 'Error', 'error');
      }
      setTimeout(() => {
        // if (document.querySelectorAll('.react-flow__edge.react-flow__edge-custom').length) {
        //   const obj = {};
        //   document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele) => {
        //     obj[ele.value] = +ele.value;
        //   });
        //   localStorage.setItem('streamNum_dict', JSON.stringify(obj));
        // }
        // Added by Akhil on 10th Dec24 to remove NaN string and add new values in stream textfield"
        const obj_new = {};
        if (document.querySelectorAll('.react-flow__edge.react-flow__edge-custom').length) {
          const obj = {};
          document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele, ind) => {
            obj[ele.value] = +ele.value;
            if (ele.value === "" || ele.value === undefined || ele.value === "NaN") {
              obj_new[ind] = ind;
            }
          });
          localStorage.setItem('streamNum_dict', JSON.stringify(obj));
        }
        if (Object.keys(obj_new).length > 0) {
          const stream_dict = { ...JSON.parse(localStorage.getItem('streamNum_dict')) }; // Create a copy using the spread operator
          // Remove the empty string key if it exists
          if (stream_dict[""] !== undefined) {
            delete stream_dict[""];
          }
          if (Object.keys(stream_dict).indexOf('NaN') >= 0) {
            delete stream_dict.NaN;
          }
          // for (const key in JSON.parse(localStorage.getItem('streamNum_dict_new'))) {
          //   if (!stream_dict.hasOwnProperty(key)) {
          //     stream_dict[key] = JSON.parse(localStorage.getItem('streamNum_dict_new'))[key];
          //   }
          // }
          const storedData = JSON.parse(localStorage.getItem('streamNum_dict_new') || '{}');
          Object.entries(storedData).forEach(([key, value]) => {
            if (!Object.hasOwn(stream_dict, key)) {
              stream_dict[key] = value;
            }
          });
          localStorage.setItem('streamNum_dict', JSON.stringify(stream_dict));
          document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele, index) => {
            if (stream_dict[ele.value]) {
              ele.value = stream_dict[ele.value];
            } else {
              ele.value = Number(Math.max(...Object.keys(stream_dict))) + (index + 1);
            }
          });
          // // @sudarsana after saving the file we are getting Stream number not properly assined to fix we are using to connect onStreamAlign() function
          // if (fileSavedSuccess) {
          //   onStreamAlign();
          //   fileSavedSuccess = false;
          // }
        }

        // ################# Specify Flow Data ###################
        if (response_final.specifyFlow_data) {
          localStorage.setItem('flow_dict', JSON.stringify(response_final.specifyFlow_data));
        }
        if (response_final.feed_flow_dict_val) {
          localStorage.setItem('feed_flow_dict', JSON.stringify(response_final.feed_flow_dict_val));
        }
        if (response_final.product_flow_dict_val) {
          localStorage.setItem('product_flow_dict', JSON.stringify(response_final.product_flow_dict_val));
        }
        convasEmptyFun();
      }, 100);
      setSelectedFileName(fileName);
      flagshareclick = false;

      // setTimeout(() => {
      //   const flowNodes = document.querySelector('.react-flow__node');
      //   if(!flowNodes){
      //     setVisiblePi(true);
      //   }else{
      //     setVisiblePi(false);
      //   }
      // }, 4001);

      if (getProjectInfoOpenFlag()) {
        setVisiblePi(true);
        setIsElementModelAccess(false);
      }
      else {
        setVisiblePi(false);
      }
      setProjectInfoOpenFlag(false);
    }

    if (!isupload) {
      if (fileName.includes('temp_files')) {
        // request_url = `https://4wyldoizc5.execute-api.us-east-1.amazonaws.com/dev/winflows_fileopen?param1=${fileName}`;

        // request_url = `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_get_winfile_content?param1=${fileName}`;
        // fileName = fileName.replace('flowsheetwizard/', '');
        fileName = fileName.replace(/[+]/g, '%2B');
        getWinflowsFileContent_FlowsheetWizard(fileName)
          // axios.get(request_url)
          .then((res) => responseData(res))
          .catch(() => {
            openModelPopUp(t('Failed to load win files'), 'Error', 'error');
          });
      } else if (fileName.includes('preconfig')) {
        // request_url = `https://4wyldoizc5.execute-api.us-east-1.amazonaws.com/dev/winflows_fileopen?param1=${fileName}`;

        // request_url = `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_get_winfile_content?param1=${fileName}`;
        fileName = fileName.replace(/[+]/g, '%2B');
        getWinflowsFileContent_preconfigFile(fileName)
          // axios.get(request_url)
          .then((res) => responseData(res))
          .catch(() => {
            openModelPopUp(t('Failed to load win files'), 'Error', 'error');
          });
      } else if (fileName.includes('winflows_4_files')) {
        setTimeout(() => {
          getWinflowsFileContent_preconfigFile(fileName)
            .then((res) => responseData(res))
            .catch(() => {
              openModelPopUp('Failed to load win-4 files', 'Error', 'error');
            });
        }, 2000);
      } else {
        if (fileName.includes('romachine')) {
          getWinflowsFileContent_preconfigFile(fileName)
            .then((res) => responseData(res))
            .catch(() => {
              openModelPopUp(t('RO Machine not available'), 'Error', 'error');
            });
        }
        else {
          const getUserType = getUserEmail.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
          // request_url = `https://4wyldoizc5.execute-api.us-east-1.amazonaws.com/dev/fileopen?param1=${getUserEmail}_${fileName}`;
          // request_url = `https://4wyldoizc5.execute-api.us-east-1.amazonaws.com/dev/winflows_fileopen?param1=${getUserEmail}_${fileName}`; // old
          //  request_url = `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_get_winfile_content?param1=${getUserEmail}_${fileName}&param2=${getUserEmail}&param3=${getUserType}`;
          // request_url = `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_get_winfile_content?param1=${getUserEmail}_${fileName}`;

          // open custom folder on save start
          getWinflowsFileContent(getUserEmail, fileName, getUserType)
            // let folderPAth = localStorage.getItem('folderPath');
            // folderPAth = folderPAth ? `${folderPAth}/` : '';
            // fileName = fileName.replace(/[+]/g, '%2B');

            // if (folderPAth === '') {
            //   const fillPObj = splitPathAndFileName(fileName);
            //   folderPAth = fillPObj.folderPath;
            //   fileName = fillPObj.fileName;
            //   localStorage.setItem('folderPath', folderPAth.endsWith('/') ? folderPAth.slice(0, -1) : folderPAth);
            // }

            // if (fileName.split('/').length > 0) {
            //   fileName = fileName.split('/')[fileName.split('/').length - 1];
            // }

            // getWinflowsFileContent_folder(folderPAth, getUserEmail, fileName, getUserType)
            // open custom folder on save ends

            // getWinflowsFileContent_folder
            // axios.get(request_url)
            .then(
              (res) => {
                // localStorage.removeItem('folderPath');
                responseData(res);
              }
            )
            .catch(() => {
              openModelPopUp(t('Failed to load saved win file'), 'Error', 'error');
            });
        }
      }
    } else {
      responseData(data);
    };
    // axios.get(request_url)
    // getWinflowsFileContent(param1, param2)
    //   .then((res)=>responseData(res))
    //   .catch((error) => {
    //     openModelPopUp('Failed to save feed input', 'Error', 'error');
    //   });
  };

  useEffect(() => {
    let fileName = window.location.search;
    if (fileName) {
      fileName = fileName.split('?')[1];
      // console.log(unSavedgetProjectInfoOpenFlag());
      if (unSavedgetProjectInfoOpenFlag() && fileName.includes('autoSave')) {
        const unSavedFileName = decodeURIComponent(fileName);
        // console.log('get fileName', unSavedFileName);
        const unsavedData = localStorage.getItem(unSavedFileName);
        if (unsavedData) {
          const response_final = JSON.parse(unsavedData);
          // console.log('Matched localStorage data:', JSON.parse(unsavedData));
          getFlowSheetData(response_final, fileName);

          // get fileName Single%20Pass%20NF%20(Seawater%20feed)_autoSave_1761887238151.json
          removeItemFromLocalStorage();
          if (response_final.payloadData_feed && Object.keys(response_final.payloadData_feed).length) {

            localStorage.setItem('feed-dict', JSON.stringify(response_final.payloadData_feed));
          }

          if (response_final.formData_feed && Object.keys(response_final.formData_feed).length) {

            localStorage.setItem('form', JSON.stringify(response_final.formData_feed));
          }
          if (response_final.payloadData_ro && Object.keys(response_final.payloadData_ro).length) {
            // ############## Temporarly converting cls id to ro id in ro-dict ############
            const tempVar = Object.keys(response_final.payloadData_ro);
            tempVar.forEach((item, index) => {
              if (item.replace(/[\d_]+/g, '') === 'cls') {
                const val = item.split('_');
                val[0] = 'ro_';
                tempVar[index] = val[0].concat(val[1]);
                // ############ Dictionary to add new key value and delete prevoius keys ##################
                Object.assign(response_final.payloadData_ro, { [tempVar[index]]: response_final.payloadData_ro[item] })[item];
                delete response_final.payloadData_ro[item];
              }
            });

            const payloadData_ro = {
              ro: response_final.payloadData_ro
            };
            localStorage.setItem('ro_payload', JSON.stringify(payloadData_ro));
          }
          // ######################### ro form data #############
          if (response_final.formData_ro && Object.keys(response_final.formData_ro).length) {
            // ############## Temporarly converting cls id to ro id in ro-dict ############
            const tempVar = Object.keys(response_final.formData_ro);
            tempVar.forEach((item, index) => {
              if (item.replace(/[\d_]+/g, '') === 'cls') {
                const val = item.split('_');
                val[0] = 'ro_';
                tempVar[index] = val[0].concat(val[1]);
                // ############ Dictionary to add new key value and delete prevoius keys ##################
                Object.assign(response_final.formData_ro, { [tempVar[index]]: response_final.formData_ro[item] })[item];
                delete response_final.formData_ro[item];
              }
            });
            const ro_data = {
              ro: response_final.formData_ro
            };
            localStorage.setItem('ro-dict', JSON.stringify(ro_data));
            // set all ro id in ab value dict.
            const ROarr = Object.keys(response_final.formData_ro);
            for (let i = 0; i < ROarr.length; i++) {
              addInABFobj(ROarr[i], false);
            }
            itemToBePassIn_ro_elem_shared_access = response_final.formData_ro || '';
          }
          // ######################### clro form data #############
          if (response_final.formData_clro && Object.keys(response_final.formData_clro).length) {
            // ############## Temporarly converting cls id to ro id in clro-dict ############
            const tempVar = Object.keys(response_final.formData_clro);
            tempVar.forEach((item, index) => {
              if (item.replace(/[\d_]+/g, '') === 'cls') {
                const val = item.split('_');
                val[0] = 'clro_';
                tempVar[index] = val[0].concat(val[1]);
                // ############ Dictionary to add new key value and delete prevoius keys ##################
                Object.assign(response_final.formData_clro, { [tempVar[index]]: response_final.formData_clro[item] })[item];
                delete response_final.formData_clro[item];
              }
            });
            const clro_data = {
              ro: response_final.formData_clro
            };
            localStorage.setItem('clro-dict', JSON.stringify(clro_data));
            // localStorage.setItem('clro_payload', JSON.stringify(clro_data));
            // set all clro id in ab value dict.
            const CLROarr = Object.keys(response_final.formData_clro);
            for (let i = 0; i < CLROarr.length; i++) {
              addInABFobj(CLROarr[i], false);
            }

            if (isObjectEmpty(response_final.formData_ro)) {
              itemToBePassIn_ro_elem_shared_access = response_final.formData_ro || '';
            }
            if (isObjectEmpty(response_final.formData_clro)) {
              itemToBePassIn_ro_elem_shared_access = response_final.formData_clro || '';
            }
          }
          // ############# clro payload data ##############
          if (response_final.payloadData_clro) {
            // ############## Temporarly converting cls id to ro id in clro-dict ############
            const tempVar = Object.keys(response_final.payloadData_clro);
            tempVar.forEach((item, index) => {
              if (item.replace(/[\d_]+/g, '') === 'cls') {
                const val = item.split('_');
                val[0] = 'clro_';
                tempVar[index] = val[0].concat(val[1]);
                // ############ Dictionary to add new key value and delete prevoius keys ##################
                Object.assign(response_final.payloadData_clro, { [tempVar[index]]: response_final.payloadData_clro[item] })[item];
                delete response_final.payloadData_clro[item];
              }
            });
            const payloadData_clro = {
              ro: response_final.payloadData_clro
            };
            localStorage.setItem('clro_payload', JSON.stringify(payloadData_clro));
          }
          // ############# Chemical Dosing data ##############
          if (response_final.formData_dosing && Object.keys(response_final.formData_dosing).length) {
            const dosing_data = {
              Chemical_Dosing: response_final.formData_dosing
            };
            localStorage.setItem('dosing-dict', JSON.stringify(dosing_data));
          }
          // ############# EDI data ##############
          if (response_final.formData_edi && Object.keys(response_final.formData_edi).length) {
            // ############## Temporarly converting cf id to edi id in edi-dict ############
            const tempVar = Object.keys(response_final.formData_edi);
            tempVar.forEach((item, index) => {
              if (item.replace(/[\d_]+/g, '') === 'cf') {
                const val = item.split('_');
                val[0] = 'edi_';
                tempVar[index] = val[0].concat(val[1]);
                // ############ Dictionary to add new key value and delete prevoius keys ##################
                Object.assign(response_final.formData_edi, { [tempVar[index]]: response_final.formData_edi[item] })[item];
                delete response_final.formData_edi[item];
              }
            });
            const edi_data = {
              EDI: response_final.formData_edi
            };
            localStorage.setItem('edi-dict', JSON.stringify(edi_data));
          }
          if (response_final.formData_cf && Object.keys(response_final.formData_cf).length) {
            const cf_data = {
              cf: response_final.formData_cf
            };
            localStorage.setItem('cf-dict', JSON.stringify(cf_data.cf));
          }
          if (response_final.formData_pump && Object.keys(response_final.formData_pump).length) {
            const pump_data = {
              pump: response_final.formData_pump
            };
            localStorage.setItem('pump-dict', JSON.stringify(pump_data.pump));
          }
          // ############# hppump form data ##############
          if (response_final.formData_hppump && Object.keys(response_final.formData_hppump).length) {
            const hppump_data = {
              hppump: response_final.formData_hppump
            };
            localStorage.setItem('hp-pump-dict', JSON.stringify(hppump_data.hppump));
          }
          if (response_final.formData_mixSplit && Object.keys(response_final.formData_mixSplit).length) {
            const mixSplit_data = {
              mixSplit: response_final.formData_mixSplit
            };
            localStorage.setItem('mixSplit-dict', JSON.stringify(mixSplit_data));
          }
          if (response_final.unitSet_dict.pressure === 'Mpa') {
            response_final.unitSet_dict.pressure = 'MPa';
          }
          localStorage.setItem('system-units', JSON.stringify(response_final.unitSet_dict));
          localStorage.setItem('previous_ro_pressure_unit', response_final.unitSet_dict.pressure);
          // ############# A&B options #################
          if (response_final.ABoptions) {
            localStorage.setItem('options', JSON.stringify(response_final.ABoptions));
          }
          // ############### Stripper Data ###################
          if (response_final.formData_stripper && Object.keys(response_final.formData_stripper).length) {
            const formdatastripper = {
              st: response_final.formData_stripper
            };
            localStorage.setItem('stripper-dict', JSON.stringify(formdatastripper));
          }
          if (response_final.pex_dict && Object.keys(response_final.pex_dict).length) {
            const pressExcDict = {
              press_exc: response_final.pex_dict
            };
            localStorage.setItem('press_exc-dict', JSON.stringify(pressExcDict));
            defaultSetUnitsetdict('current-unit-work', response_final.unitSet_dict);
          }
          if (response_final.pelton_dict && Object.keys(response_final.pelton_dict).length) {
            const peltonDict = {
              pelton_exc: response_final.pelton_dict
            };
            localStorage.setItem('pelton_wheel-dict', JSON.stringify(peltonDict));
            defaultSetUnitsetdict('pelton-unit-work', response_final.unitSet_dict);
          }
          if (response_final.turbo_dict && Object.keys(response_final.turbo_dict).length) {
            const turboDict = {
              TRD_data: response_final.turbo_dict
            };
            localStorage.setItem('turbo_charger-dict', JSON.stringify(turboDict));
            defaultSetUnitsetdict('turbo-unit-work', response_final.unitSet_dict);
          }

          if (response_final.projectInfo_dict) {
            localStorage.setItem('project_info', JSON.stringify(response_final.projectInfo_dict));
          }
          // ################# Specify Flow Data ###################
          if (response_final.specifyFlow_data) {
            localStorage.setItem('flow_dict', JSON.stringify(response_final.specifyFlow_data));
          }
          if (response_final.feed_flow_dict_val) {
            localStorage.setItem('feed_flow_dict', JSON.stringify(response_final.feed_flow_dict_val));
          }

          if (response_final.product_flow_dict_val) {
            localStorage.setItem('product_flow_dict', JSON.stringify(response_final.product_flow_dict_val));
          }
          //  getFlowSheetData(response_final, fileName);
          unSavedsetProjectInfoOpenFlag(false);
          flagCalledLocalStorage = 'unSaved';
          convasEmptyFun();
          setTimeout(() => {
            localStorage.setItem('globalExitBtn', 'true');
          }, 1000);
          //  getBorderColor('feed_1');
        }
      }
      else if (saveTrigger) {
        fetchData(fileName);
        flagCalledLocalStorage = '';
      }
    }
    setEdgeText(0);
    window.history.pushState({}, null, `${window.location.origin}${window.location.pathname}`);
    setClonedEdgeText(0);
    setTimeout(() => {
      flagCalledLocalStorage = '';
      setSaveTrigger(true);
    }, 100);
    if (flagCalledLocalStorage === '') {
      localStorage.removeItem('form');
      localStorage.removeItem('activecells');
      resetVariable();
      sourceYIncrement = 20;
      increment = 5;
    }
  }, [window.location.search, trigger]);

  // By Abhishek : 26-6-25 : to disable the calculation when yellow triangle warning appear
  useEffect(() => {
    if (isElementModelAccess) {
      setExecuteObj([
        { ...getCommonData('specifyflow', false) },
        { ...getCommonData('calculate', true) },
        { ...getCommonData('stream', true) },
        { ...getCommonData('explorer', true) },
        { ...getCommonData('pdf-report', true) },
        { ...getCommonData('error', true) },
      ]);
    }
  }, [isElementModelAccess]);

  // const onLoad = (_reactFlowInstance) => setRfInstance(_reactFlowInstance);

  // Added useCallback hook in version 11 @sudarsana
  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    setChecked(false);
    convasEmptyFun();
  }, []);

  // Added useCallback hook in version 11 @sudarsana
  const onDrop = useCallback((event) => {
    // @sudarsana (08/28/2024) when user deleting edge or unitops this logic is used to re-filling the entire connectionInfo dictionary
    if (Object.keys(connectionInfo).length === 0) {
      const edges = rfInstance?.toObject()?.edges ?? [];
      edges.forEach(edge => {
        if (!edge.source.includes('mixsplit')) {
          const sourceKey = edge.source + edge.sourceHandle;
          connectionInfo[sourceKey] = edge.sourceHandle;
        }
        if (!edge.target.includes('mixsplit')) {
          const targetKey = edge.target + edge.targetHandle;
          connectionInfo[targetKey] = edge.targetHandle;
        }
      });
    }
    setChecked(false);
    dragdrop.current = true;
    convasEmptyFun();
    localStorage.setItem('globalExitBtn', 'true');
    event.preventDefault();
    checked_newButton = 0;
    checked_ResetButton = 0;
    isRoPump = false;
    isNfPump = false;
    isclro = false;
    isWexPex = false;
    isPeltonWheel = false;
    isturbocharger = false;
    wex_call_count = 0;
    const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    const type = event.dataTransfer.getData('application/reactflow');

    const position = rfInstance.project({
      // @Sudarsana Fix the origin of nodes so that it will stay at the place where it is left while dropping on canvas
      x: event.clientX - reactFlowBounds.left - 30,
      y: event.clientY - reactFlowBounds.top - 20,
    });
    if (type == 'customnode_feed') {
      if (c_feed.length > 0) {
        c_feed.sort((a, b) => { return a - b; });
        id_feed = 1;
        for (let i = 0; i < c_feed.length; i += 1) {
          if (id_feed === c_feed[i])
            id_feed += 1;
          else
            break;
        }
      }
      if (c_feed.length === 0) { id_feed = 1; }
      if (localStorage.getItem(`feed_${id_feed}`)) { localStorage.removeItem(`feed_${id_feed}`); }
      c_feed.push(id_feed);
      jsLogger.info(`feed_${id_feed} is added`);
      const newNode0 = {
        id: `feed_${id_feed++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5 },
        data: { label: 'node 2' },
      };
      node1.push(newNode0);
      setElements((es) => es.concat(newNode0));
    } else if (type == 'customnode_productOut') {
      if (c_ro.length > 0) {
        c_ro.sort((a, b) => { return a - b; });
        id_ro = 1;
        for (let i = 0; i < c_ro.length; i += 1) {
          if (id_ro === c_ro[i])
            id_ro += 1;
          else
            break;
        }
      }
      if (c_ro.length === 0) { id_ro = 1; }
      if (localStorage.getItem(`ro_${id_ro}`)) { localStorage.removeItem(`ro_${id_ro}`); }
      c_ro.push(id_ro);
      jsLogger.info(`ro_${id_ro} is added`);
      const newNode1 = {
        id: `ro_${id_ro++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5, id: 'd' },
      };
      node1.push(newNode1);
      setElements((es) => es.concat(newNode1));
    } else if (type == 'customnode_productOut_NF') {
      if (c_ro.length > 0) {
        c_ro.sort((a, b) => { return a - b; });
        id_ro = 1;
        for (let i = 0; i < c_ro.length; i += 1) {
          if (id_ro === c_ro[i])
            id_ro += 1;
          else
            break;
        }
      }
      if (c_ro.length === 0) { id_ro = 1; }
      if (localStorage.getItem(`ro_${id_ro}`)) { localStorage.removeItem(`ro_${id_ro}`); }
      c_ro.push(id_ro);
      jsLogger.info(`nf_${id_ro} is added`);
      const newNode1 = {
        id: `nf_${id_ro++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5, id: 'd' },
      };
      node1.push(newNode1);
      setElements((es) => es.concat(newNode1));
    } else if (type == 'customnode_ROpump') {
      isRoPump = true;
      if (c_roPump.length > 0) {
        c_roPump.sort();
        id_roPump = c_roPump[c_roPump.length - 1] + 1;
      }
      if (c_roPump.length === 0)
        id_roPump = 1;
      if (c_pump_hp.length > 0) {
        c_pump_hp.sort((a, b) => { return a - b; });
        id_pump_hp = c_pump_hp[c_pump_hp.length - 1] + 1;
      }
      if (c_box_RO_HP.length > 0) {
        c_box_RO_HP.sort((a, b) => { return a - b; });
        id_box_RO_HP = c_box_RO_HP[c_box_RO_HP.length - 1] + 1;
      }
      if (c_pump_hp.length === 0)
        id_pump_hp = 1;
      if (c_box_RO_HP.length === 0)
        id_box_RO_HP = 1;
      if (localStorage.getItem(`roPump_${id_roPump}`)) {
        localStorage.removeItem(`roPump_${id_roPump}`);
      }
      if (localStorage.getItem(`hppump_${id_pump_hp}`)) {
        localStorage.removeItem(`hppump_${id_pump_hp}`);
      }
      if (c_roPump.length > 0) {
        if (c_roPump.indexOf(id_roPump) == -1) {
          c_roPump.push(id_roPump);
        } else {
          c_roPump.push(Math.max(...c_roPump) + 1);
          id_roPump = Math.max(...c_roPump) + 1;
        }
      } else {
        c_roPump.push(id_roPump);
      }
      if (c_pump_hp.length > 0) {
        if (c_pump_hp.indexOf(id_pump_hp) == -1) {
          c_pump_hp.push(id_pump_hp);
        } else {
          c_pump_hp.push(Math.max(...c_pump_hp) + 1);
          id_pump_hp = Math.max(...c_pump_hp) + 1;
        }
      } else {
        c_pump_hp.push(id_pump_hp);
      }
      if (c_box_RO_HP.length > 0) {
        if (c_box_RO_HP.indexOf(id_box_RO_HP) == -1) {
          c_box_RO_HP.push(id_box_RO_HP);
        } else {
          c_box_RO_HP.push(Math.max(...c_box_RO_HP) + 1);
          id_box_RO_HP = Math.max(...c_box_RO_HP) + 1;
        }
      } else {
        c_box_RO_HP.push(id_box_RO_HP);
      }
      const ParentNode = {
        id: `groupROHP_${id_box_RO_HP}`,
        type: 'customnode_RO_HP_group',
        data: { label: null },
        position,
        style: { width: '193px', height: '52px' },
      };
      jsLogger.info(`groupROHP_${id_box_RO_HP} is added`);
      node1.push(ParentNode);
      const newNode1 = {
        id: `roPump_${id_roPump}`, // getId(),
        type,
        position: { x: 140, y: 0 },
        style: { width: 'auto', height: 'auto', id: 'd' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`roPump_${id_roPump} is added`);
      node1.push(newNode1);
      const newNode2 = {
        id: `hppump_${id_pump_hp}`, // getId(),
        type: 'customnode_pump_hp',
        position: { x: 0, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`hppump_${id_pump_hp} is added`);
      node1.push(newNode2);
      const nodes = [newNode1, newNode2, ParentNode];
      roPump_all_unitops.push(...nodes);
      setElements((es) => es.concat(newNode1));
      setElements((es) => es.concat(newNode2));
      setElements((es) => es.concat(ParentNode));
    } else if (type == 'customnode_NFpump') {
      isNfPump = true;
      if (c_roPump.length > 0) {
        c_roPump.sort();
        id_roPump = c_roPump[c_roPump.length - 1] + 1;
      }
      if (c_roPump.length === 0)
        id_roPump = 1;
      if (c_pump_hp.length > 0) {
        c_pump_hp.sort((a, b) => { return a - b; });
        id_pump_hp = c_pump_hp[c_pump_hp.length - 1] + 1;
      }
      if (c_box_RO_HP.length > 0) {
        c_box_RO_HP.sort((a, b) => { return a - b; });
        id_box_RO_HP = c_box_RO_HP[c_box_RO_HP.length - 1] + 1;
      }
      if (c_pump_hp.length === 0)
        id_pump_hp = 1;
      if (c_box_RO_HP.length === 0)
        id_box_RO_HP = 1;
      if (localStorage.getItem(`nfPump_${id_roPump}`)) {
        localStorage.removeItem(`nfPump_${id_roPump}`);
      }
      if (localStorage.getItem(`hppump_${id_pump_hp}`)) {
        localStorage.removeItem(`hppump_${id_pump_hp}`);
      }
      if (c_roPump.length > 0) {
        if (c_roPump.indexOf(id_roPump) == -1) {
          c_roPump.push(id_roPump);
        } else {
          c_roPump.push(Math.max(...c_roPump) + 1);
          id_roPump = Math.max(...c_roPump) + 1;
        }
      } else {
        c_roPump.push(id_roPump);
      }
      if (c_pump_hp.length > 0) {
        if (c_pump_hp.indexOf(id_pump_hp) == -1) {
          c_pump_hp.push(id_pump_hp);
        } else {
          c_pump_hp.push(Math.max(...c_pump_hp) + 1);
          id_pump_hp = Math.max(...c_pump_hp) + 1;
        }
      } else {
        c_pump_hp.push(id_pump_hp);
      }
      if (c_box_RO_HP.length > 0) {
        if (c_box_RO_HP.indexOf(id_box_RO_HP) == -1) {
          c_box_RO_HP.push(id_box_RO_HP);
        } else {
          c_box_RO_HP.push(Math.max(...c_box_RO_HP) + 1);
          id_box_RO_HP = Math.max(...c_box_RO_HP) + 1;
        }
      } else {
        c_box_RO_HP.push(id_box_RO_HP);
      }
      const ParentNode = {
        id: `groupROHP_${id_box_RO_HP}`,
        type: 'customnode_NF_HP_group',
        data: { label: null },
        position,
        style: { width: '193px', height: '52px' },
      };
      jsLogger.info(`groupROHP_${id_box_RO_HP} is added`);
      node1.push(ParentNode);
      const newNode1 = {
        id: `nfPump_${id_roPump}`, // getId(),
        type,
        position: { x: 140, y: 0 },
        style: { width: 'auto', height: 'auto', id: 'd' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`nfPump_${id_roPump} is added`);
      node1.push(newNode1);
      const newNode2 = {
        id: `hppump_${id_pump_hp}`, // getId(),
        type: 'customnode_pump_hp',
        position: { x: 0, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`hppump_${id_pump_hp} is added`);
      node1.push(newNode2);
      const nodes = [newNode1, newNode2, ParentNode];
      roPump_all_unitops.push(...nodes);
      setElements((es) => es.concat(newNode1));
      setElements((es) => es.concat(newNode2));
      setElements((es) => es.concat(ParentNode));
    }
    else if (type == 'customnode_Feed_AO') {
      if (withoutDuplicateWaterCompWithAA) {
        document.querySelector('#toatster-msg span').innerHTML = 'Only one Argo Analyzer module is allowed';
        document.querySelector('#toatster-msg').style.display = 'block';
        setTimeout(() => {
          document.querySelector('#toatster-msg').style.display = 'none';
          document.querySelector('#toatster-msg span').innerHTML = '';
        }, 3000);
        return false;
      }
      if (c_feedAA.length > 0) {
        c_feedAA.sort();
        id_feedAA = c_feedAA[c_feedAA.length - 1] + 1;
      }
      if (c_feedAA.length === 0)
        id_feedAA = 1;
      if (c_feed_AA.length > 0) {
        c_feed_AA.sort((a, b) => { return a - b; });
        id_AA = c_feed_AA[c_feed_AA.length - 1] + 1;
      }
      if (c_box_Feed_AA.length > 0) {
        c_box_Feed_AA.sort((a, b) => { return a - b; });
        id_box_Feed_AA = c_box_Feed_AA[c_box_Feed_AA.length - 1] + 1;
      }
      if (c_feed_AA.length === 0)
        id_AA = 1;
      if (c_box_Feed_AA.length === 0)
        id_box_Feed_AA = 1;
      if (localStorage.getItem(`Wateranalysis${id_feedAA}`)) {
        localStorage.removeItem(`Wateranalysis${id_feedAA}`);
      }
      if (localStorage.getItem(`Argo${id_AA}`)) {
        localStorage.removeItem(`Argo${id_AA}`);
      }
      if (c_feedAA.length > 0) {
        if (c_feedAA.indexOf(id_feedAA) == -1) {
          c_feedAA.push(id_feedAA);
        } else {
          c_feedAA.push(Math.max(...c_feedAA) + 1);
          id_feedAA = Math.max(...c_feedAA) + 1;
        }
      } else {
        c_feedAA.push(id_feedAA);
      }
      if (c_feed_AA.length > 0) {
        if (c_feed_AA.indexOf(id_AA) == -1) {
          c_feed_AA.push(id_AA);
        } else {
          c_feed_AA.push(Math.max(...c_feed_AA) + 1);
          id_AA = Math.max(...c_feed_AA) + 1;
        }
      } else {
        c_feed_AA.push(id_AA);
      }
      if (c_box_Feed_AA.length > 0) {
        if (c_box_Feed_AA.indexOf(id_box_Feed_AA) == -1) {
          c_box_Feed_AA.push(id_box_Feed_AA);
        } else {
          c_box_Feed_AA.push(Math.max(...c_box_Feed_AA) + 1);
          id_box_Feed_AA = Math.max(...c_box_Feed_AA) + 1;
        }
      } else {
        c_box_Feed_AA.push(id_box_Feed_AA);
      }
      const ParentNode = {
        id: `groupRAAFeed_${id_box_Feed_AA}`,
        type: 'customnode_Feed_AO_group',
        data: { label: null },
        position,
        style: { width: '193px', height: '50px' },
      };
      jsLogger.info(`groupRAAFeed_${id_box_Feed_AA} is added`);
      node1.push(ParentNode);
      const newNode1 = {
        id: `Wateranalysis`, // getId(),
        type: 'customnode_Wateranalysis',
        position: { x: 0, y: 0 },
        style: { width: 'auto', height: 'auto', id: 'd' },
        parentNode: `groupRAAFeed_${id_box_Feed_AA}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`Wateranalysis${id_feedAA} is added`);
      node1.push(newNode1);
      const newNode2 = {
        id: `Argo`, // getId(),
        type: 'customnode_Argo',
        position: { x: 140, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupRAAFeed_${id_box_Feed_AA}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`Argo${id_AA} is added`);
      node1.push(newNode2);
      const newNode3 = {
        id: `Horizental_Stripper`, // getId(),
        type: 'customnode_horizental',
        position: { x: 60, y: 17 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupRAAFeed_${id_box_Feed_AA}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`Argo${id_AA} is added`);
      node1.push(newNode3);
      const nodes = [newNode1, newNode2, newNode3, ParentNode];
      groupFeeddAA.push(...nodes);
      setElements((es) => es.concat(newNode1));
      setElements((es) => es.concat(newNode2));
      setElements((es) => es.concat(newNode3));
      setElements((es) => es.concat(ParentNode));
    }
    else if (type == 'customnode_CLROpump') {  // abhishek
      isclro = true;
      if (c_roPump.length > 0) {
        c_roPump.sort();
        id_clro = c_roPump[c_roPump.length - 1] + 1;
      }
      if (c_roPump.length === 0) { id_clro = 1; }
      if (c_pump_hp.length > 0) {
        c_pump_hp.sort((a, b) => { return a - b; });
        id_pump_hp = c_pump_hp[c_pump_hp.length - 1] + 1;
      }
      if (c_box_RO_HP.length > 0) {
        c_box_RO_HP.sort((a, b) => { return a - b; });
        id_box_RO_HP = c_box_RO_HP[c_box_RO_HP.length - 1] + 1;
      }
      if (c_pump_hp.length === 0) { id_pump_hp = 1; }
      if (c_box_RO_HP.length === 0) { id_box_RO_HP = 1; }
      if (localStorage.getItem(`roPump_${id_clro}`)) { localStorage.removeItem(`roPump_${id_clro}`); }
      if (localStorage.getItem(`hppump_${id_pump_hp}`)) { localStorage.removeItem(`hppump_${id_pump_hp}`); }
      if (c_roPump.length > 0) {
        if (c_roPump.indexOf(id_clro) == -1) {
          c_roPump.push(id_clro);
        } else {
          c_roPump.push(Math.max(...c_roPump) + 1);
          id_clro = Math.max(...c_roPump) + 1;
        }
      } else {
        c_roPump.push(id_clro);
      }

      if (c_pump_hp.length > 0) {
        if (c_pump_hp.indexOf(id_pump_hp) == -1) {
          c_pump_hp.push(id_pump_hp);
        } else {
          c_pump_hp.push(Math.max(...c_pump_hp) + 1);
          id_pump_hp = Math.max(...c_pump_hp) + 1;
        }
      } else {
        c_pump_hp.push(id_pump_hp);
      }
      if (c_box_RO_HP.length > 0) {
        if (c_box_RO_HP.indexOf(id_box_RO_HP) == -1) {
          c_box_RO_HP.push(id_box_RO_HP);
        } else {
          c_box_RO_HP.push(Math.max(...c_box_RO_HP) + 1);
          id_box_RO_HP = Math.max(...c_box_RO_HP) + 1;
        }
      } else {
        c_box_RO_HP.push(id_box_RO_HP);
      }
      const ParentNode = {
        id: `groupROHP_${id_box_RO_HP}`,
        type: 'customnode_RO_HP_group',
        data: { label: null },
        position,
        style: { width: '193px', height: '52px' },
      };
      jsLogger.info(`groupROHP_${id_box_RO_HP} is added`);
      node1.push(ParentNode);
      const newNode1 = {
        id: `roPump_${id_clro}`, // getId(),
        type,
        position: { x: 140, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`roPump_${id_clro} is added`);
      node1.push(newNode1);
      const newNode2 = {
        id: `hppump_${id_pump_hp}`, // getId(),
        type: 'customnode_pump_hp',
        position: { x: 0, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false,
      };
      jsLogger.info(`hppump_${id_pump_hp} is added`);
      node1.push(newNode2);
      const nodes = [newNode1, newNode2, ParentNode];
      clro_all_unitop.push(...nodes);

      setElements((es) => es.concat(newNode1));
      setElements((es) => es.concat(newNode2));
      setElements((es) => es.concat(ParentNode));
    } // by abhishek
    else if (type == 'customnode_edi') {
      if (c_edi.length > 0) {
        c_edi.sort((a, b) => { return a - b; });
        id_edi = c_edi[c_edi.length - 1] + 1;
      }
      if (c_edi.length === 0)
        id_edi = 1;
      if (localStorage.getItem(`edi_${id_edi}`)) {
        localStorage.removeItem(`edi_${id_edi}`);
      }
      if (c_edi.length > 0) {
        if (c_edi.indexOf(id_edi) == -1) {
          c_edi.push(id_edi);
        } else {
          c_edi.push(Math.max(...c_edi) + 1);
          id_edi = Math.max(...c_edi) + 1;
        }
      } else {
        c_edi.push(id_edi);
      }

      const newNode2 = {
        id: `edi_${id_edi}`, // getId(),
        type,
        position,
        data: {
          id: 'e',
          label: (
            <div>
              <input className="nodrag3" type="image" src={EDI} width="48" height="40" disabled />
            </div>
          ),
        },
        style: { width: 'auto', height: 'auto', zIndex: 5, id: 'e' },
      };
      jsLogger.info(`edi_${id_edi} is added`);
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    } else if (type == 'customnode_pump') {
      if (c_pump.length > 0) {
        c_pump.sort((a, b) => { return a - b; });
        id_pump = c_pump[c_pump.length - 1] + 1;
      }
      if (c_pump.length === 0)
        id_pump = 1;
      if (localStorage.getItem(`pump_${id_pump}`)) {
        localStorage.removeItem(`pump_${id_pump}`);
      }
      if (c_pump.length > 0) {
        if (c_pump.indexOf(id_pump) == -1) {
          c_pump.push(id_pump);
        } else {
          c_pump.push(Math.max(...c_pump) + 1);
          id_pump = Math.max(...c_pump) + 1;
        }
      } else {
        c_pump.push(id_pump);
      }
      const newNode2 = {
        id: `pump_${id_pump}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5 },
      };
      jsLogger.info(`pump_${id_pump} is added`);
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    } else if (type == 'customnode_product') {
      if (c_product.length > 0) {
        c_product.sort((a, b) => { return a - b; });
        id_productOut = c_product[c_product.length - 1] + 1;
      }
      if (c_product.length === 0)
        id_productOut = 1;
      if (localStorage.getItem(`product_${id_productOut}`)) {
        localStorage.removeItem(`product_${id_productOut}`);
      }
      if (c_product.length > 0) {
        if (c_product.indexOf(id_productOut) == -1) {
          c_product.push(id_productOut);
        } else {
          c_product.push(Math.max(...c_product) + 1);
          id_productOut = Math.max(...c_product) + 1;
        }
      } else {
        c_product.push(id_productOut);
      }
      const newNode2 = {
        id: `product_${id_productOut}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5 },
      };
      jsLogger.info(`product_${id_productOut} is added`);
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    }
    else if (type == 'customnode_wasteout') {
      if (c_wasteout.length > 0) {
        c_wasteout.sort((a, b) => { return a - b; });
        id_wasteOut = c_wasteout[c_wasteout.length - 1] + 1;
      }
      if (c_wasteout.length === 0)
        id_wasteOut = 1;
      if (localStorage.getItem(`wasteout_${id_wasteOut}`)) {
        localStorage.removeItem(`wasteout_${id_wasteOut}`);
      }
      if (c_wasteout.length > 0) {
        if (c_wasteout.indexOf(id_wasteOut) == -1) {
          c_wasteout.push(id_wasteOut);
        } else {
          c_wasteout.push(Math.max(...c_wasteout) + 1);
          id_wasteOut = Math.max(...c_wasteout) + 1;
        }
      } else {
        c_wasteout.push(id_wasteOut);
      }

      const newNode2 = {
        id: `wasteout_${id_wasteOut}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5 },
      };
      jsLogger.info(`wasteout_${id_wasteOut} is added`);
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    }
    else if (type == 'customnode_mixsplit') {
      const wex_mixsplit = c_wex.length > 0 ? 2 : 1;
      if (c_mixsplit.length > 0) {
        c_mixsplit.sort((a, b) => { return a - b; });
        id_mixSplit = c_mixsplit[c_mixsplit.length - 1] + wex_mixsplit;
      }
      if (c_mixsplit.length === 0)
        id_mixSplit = 1;
      if (localStorage.getItem(`mixsplit_${id_mixSplit}`)) {
        localStorage.removeItem(`mixsplit_${id_mixSplit}`);
      }
      if (c_mixsplit.length > 0) {
        if (c_mixsplit.indexOf(id_mixSplit) == -1) {
          c_mixsplit.push(id_mixSplit);
        } else {
          c_mixsplit.push(Math.max(...c_mixsplit) + 1);
          id_mixSplit = Math.max(...c_mixsplit) + 1;
        }
      } else {
        c_mixsplit.push(id_mixSplit);
      }

      const newNode2 = {
        id: `mixsplit_${id_mixSplit++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto' },
      };
      jsLogger.info(`wasteout_${id_wasteOut} is added`);
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    } else if (type == 'customnode_chemical_dosing') {
      if (c_chemical_dosing.length > 0) {
        c_chemical_dosing.sort((a, b) => { return a - b; });
        id_chemical_dosing = 1;
        for (let i = 0; i < c_chemical_dosing.length; i += 1) {
          if (id_chemical_dosing === c_chemical_dosing[i])
            id_chemical_dosing += 1;
          else
            break;
        }
      }
      if (c_chemical_dosing.length === 0)
        id_chemical_dosing = 1;
      if (localStorage.getItem(`chemicaldosing_${id_chemical_dosing}`)) {
        localStorage.removeItem(`chemicaldosing_${id_chemical_dosing}`);
      }
      c_chemical_dosing.push(id_chemical_dosing);
      const newNode2 = {
        id: `chemicaldosing_${id_chemical_dosing++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5 },
      };
      jsLogger.info(`chemicaldosing_${id_chemical_dosing++} is added`);
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    }
    else if (type == 'customnode_WEX_PEX') {
      isWexPex = true;
      if (withoutDeletionDublicateERD) {
        document.querySelector('#toatster-msg span').innerHTML = "Multiple ERDs are not allowed on same flow sheet";
        document.querySelector('#toatster-msg').style.display = 'block';
        setTimeout(() => {
          document.querySelector('#toatster-msg').style.display = 'none';
          document.querySelector('#toatster-msg span').innerHTML = '';
        }, 3000);
        return false;
      }
      if (c_wex.length > 0) {
        c_wex.sort((a, b) => { return a - b; });
        id_wex_pex = 1;
        for (let i = 0; i < c_wex.length; i += 1) {
          if (id_wex_pex === c_wex[i])
            id_wex_pex += 1;
          else
            break;
        }
      }
      if (c_mixsplit.length > 0) {
        c_mixsplit.sort((a, b) => { return a - b; });
        id_mixSplit = c_mixsplit[c_mixsplit.length - 1] + 1;
      }
      if (c_pump_hp.length > 0) {
        c_pump_hp.sort((a, b) => { return a - b; });
        id_pump_hp = c_pump_hp[c_pump_hp.length - 1] + 1;
      }
      if (c_roPump.length > 0) {
        c_roPump.sort((a, b) => { return a - b; });
        id_roPump = c_roPump[c_roPump.length - 1] + 1;
      }
      if (c_box_RO_HP.length > 0) {
        c_box_RO_HP.sort((a, b) => { return a - b; });
        id_box_RO_HP = c_box_RO_HP[c_box_RO_HP.length - 1] + 1;
      }
      if (c_boosterPump.length > 0) {
        c_boosterPump.sort((a, b) => { return a - b; });
        id_boosterPump = c_boosterPump[c_boosterPump.length - 1] + 1;
      }
      if (c_roPump.length === 0)
        id_roPump = 1;
      if (c_pump_hp.length === 0)
        id_pump_hp = 1;
      if (c_wex.length === 0)
        id_wex_pex = 1;
      if (c_mixsplit.length === 0)
        id_mixSplit = 1;
      if (c_box_RO_HP.length === 0)
        id_box_RO_HP = 1;
      if (c_boosterPump.length === 0)
        id_boosterPump = 1;
      if (localStorage.getItem(`wex_${id_wex_pex}`)) {
        localStorage.removeItem(`wex_${id_wex_pex}`);
      }
      if (localStorage.getItem(`boosterpump_${id_boosterPump}`)) {
        localStorage.removeItem(`boosterpump_${id_boosterPump}`);
      }
      c_wex.push(id_wex_pex);

      if (c_mixsplit.length > 0) {
        if (c_mixsplit.indexOf(id_mixSplit) == -1) {
          c_mixsplit.push(id_mixSplit);
        }
        else {
          c_mixsplit.push(Math.max(...c_mixsplit) + 1);
          id_mixSplit = Math.max(...c_mixsplit) + 1;
        }
      }
      else {
        c_mixsplit.push(id_mixSplit);
      }
      if (c_pump_hp.length > 0) {
        if (c_pump_hp.indexOf(id_pump_hp) == -1) {
          c_pump_hp.push(id_pump_hp);
        }
        else {
          c_pump_hp.push(Math.max(...c_pump_hp) + 1);
          id_pump_hp = Math.max(...c_pump_hp) + 1;
        }
      }
      else {
        c_pump_hp.push(id_pump_hp);
      }
      if (c_roPump.length > 0) {
        if (c_roPump.indexOf(id_roPump) == -1) {
          c_roPump.push(id_roPump);
        }
        else {
          c_roPump.push(Math.max(...c_roPump) + 1);
          id_roPump = Math.max(...c_roPump) + 1;
        }
      }
      else {
        c_roPump.push(id_roPump);
      }
      if (c_box_RO_HP.length > 0) {
        if (c_box_RO_HP.indexOf(id_box_RO_HP) == -1) {
          c_box_RO_HP.push(id_box_RO_HP);
        }
        else {
          c_box_RO_HP.push(Math.max(...c_box_RO_HP) + 1);
          id_box_RO_HP = Math.max(...c_box_RO_HP) + 1;
        }
      }
      else {
        c_box_RO_HP.push(id_box_RO_HP);
      }
      if (c_boosterPump.length > 0) {
        if (c_boosterPump.indexOf(id_boosterPump) == -1) {
          c_boosterPump.push(id_boosterPump);
        }
        else {
          c_boosterPump.push(Math.max(...c_boosterPump) + 1);
          id_boosterPump = Math.max(...c_boosterPump) + 1;
        }
      }
      else {
        c_boosterPump.push(id_boosterPump);
      }
      const ParentNode = {
        id: `groupROHP_${id_box_RO_HP}`,
        type: 'customnode_RO_HP_group',
        data: { label: null },
        position,
        style: { width: '681px', height: '254px' },
      };
      const newNode2 = {
        id: `mixsplit_${id_mixSplit++}`, // getId(),
        type: 'customnode_mixsplit',
        position: { x: 0, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode4 = {
        id: `mixsplit_${id_mixSplit++}`, // getId(),
        type: 'customnode_mixsplit',
        position: { x: 440, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode3 = {
        id: `hppump_${id_pump_hp++}`, // getId(),
        type: 'customnode_pump_hp',
        position: { x: 238, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode5 = {
        id: `roPump_${id_roPump++}`, // getId(),
        type: 'customnode_ROpump',
        position: { x: 628, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode6 = {
        id: `boosterpump_${id_boosterPump++}`, // getId(),
        type: 'customnode_boosterPump',
        position: { x: 340, y: 128 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode1 = {
        id: `wex_${id_wex_pex++}`, // getId(),
        type,
        position: { x: 334, y: 200 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const nodes = [newNode2, newNode4, newNode1, newNode3, newNode5, newNode6, ParentNode];
      wexpex_all_unitop.push(...nodes);
      setElements((es) => es.concat(...nodes));
    }
    else if (type == 'customnode_cartridge') {
      if (cartridge_feed.length > 0) {
        cartridge_feed.sort((a, b) => { return a - b; });
        id_cartridge = 1;
        for (let i = 0; i < cartridge_feed.length; i += 1) {
          if (id_cartridge === cartridge_feed[i])
            id_cartridge += 1;
          else
            break;
        }
      }
      if (cartridge_feed.length === 0)
        id_cartridge = 1;

      if (localStorage.getItem(`cartridge_${id_cartridge}`)) {
        localStorage.removeItem(`cartridge_${id_cartridge}`);
      }
      cartridge_feed.push(id_cartridge);
      jsLogger.info(`cartridge_${id_cartridge} is added`);
      const newNode0 = {
        id: `cartridge_${id_cartridge++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5 },
        data: { label: 'node 2' },
      };
      node1.push(newNode0);
      setElements((es) => es.concat(newNode0));
      const cfkey = newNode0.id;

      // Abhishek : 2-Apr-24 On Cf table default selection based on user Access

      cf_dict.sort((a, b) => a.CF_ID - b.CF_ID);  // sort the cf element dict. in ascending order
      let cfDetails = [...cf_dict];

      if (!isCfAdmin) {  // filter the data based on passcord
        cfDetails = cfDetails.filter(item => item.PassCode === 0);
      }

      let defObjIndex = 0;
      cfDetails.forEach((item, index) => {
        if (item.Filter === 'RO.Zs 05-40') {
          defObjIndex = index;
        }
      });

      const defObj = cfDetails.find(item => item.Filter === 'RO.Zs 05-40');

      const cfob = {
        cf: {
          [cfkey]: { ...defObj, 'rowIndex': defObjIndex }
        }
      };

      // const cfob = {
      //   cf: {
      //     [cfkey]: {
      //       'CF_ID': 11,
      //       'Filter': 'RO.Zs 05-40',
      //       'P_N': 1236269,
      //       'TIE': 4,
      //       'Micron': 5,
      //       'Coefficient': 0.01809524,
      //       'DesignFlowPerTIE': 5,
      //       'ViscosityConst': 0.001,
      //       'FactSheetName': '#specfiles\\ROSave.pdf#',
      //       'PassCode': 0,
      //       'flowsheet_link': 'https://estore.watertechnologies.com/document/document/contentdownload/?document_name=FS1097EN.pdf&language=English&security=Public',
      //       'rowIndex': 7
      //   }
      //   }
      // };

      if (localStorage.getItem('cf-dict')) {
        const cfls = JSON.parse(localStorage.getItem('cf-dict'));
        cfls.cf[cfkey] = cfob.cf[cfkey];
        localStorage.setItem('cf-dict', JSON.stringify(cfls));
      } else {
        localStorage.setItem('cf-dict', JSON.stringify(cfob));
      }
      getBorderColor(newNode0.id);
    } else if (type == 'customnode_pump_hp') {
      if (c_pump_hp.length > 0) {
        c_pump_hp.sort((a, b) => { return a - b; });
        id_pump_hp = 1;
        for (let i = 0; i < c_pump_hp.length; i += 1) {
          if (id_pump_hp === c_pump_hp[i])
            id_pump_hp += 1;
          else
            break;
        }
      }
      if (c_pump_hp.length === 0)
        id_pump_hp = 1;

      if (localStorage.getItem(`hppump_${id_pump_hp}`)) {
        localStorage.removeItem(`hppump_${id_pump_hp}`);
      }
      c_pump_hp.push(id_pump_hp);
      jsLogger.info(`hppump_${id_pump_hp} is added`);
      const newNode0 = {
        id: `hppump_${id_pump_hp++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto' },
        data: { label: 'node 2' },
      };
      node1.push(newNode0);
      setElements((es) => es.concat(newNode0));
    } else if (type === 'customnode_stripper') {
      if (c_stripper.length > 0) {
        c_stripper.sort((a, b) => { return a - b; });
        id_stripper = 1;
        for (let i = 0; i < c_stripper.length; i += 1) {
          if (id_stripper === c_stripper[i])
            id_stripper += 1;
          else
            break;
        }
      }
      if (c_stripper.length === 0)
        id_stripper = 1;
      if (localStorage.getItem(`stripper_${id_stripper}`)) {
        localStorage.removeItem(`stripper_${id_stripper}`);
      }
      c_stripper.push(id_stripper);
      jsLogger.info(`stripper_${id_stripper} is added`);
      const newNode0 = {
        id: `stripper_${id_stripper++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto', zIndex: 5 },
        data: { label: 'node 2' },
      };
      node1.push(newNode0);
      setElements((es) => es.concat(newNode0));
    } else if (type === 'customnode_RO_HP_group') {
      if (c_box_RO_HP.length > 0) {
        c_box_RO_HP.sort((a, b) => { return a - b; });
        id_box_RO_HP = 1;
        for (let i = 0; i < c_box_RO_HP.length; i += 1) {
          if (id_box_RO_HP === c_box_RO_HP[i])
            id_box_RO_HP += 1;
          else
            break;
        }
      }
      if (c_box_RO_HP.length === 0)
        id_box_RO_HP = 1;

      if (localStorage.getItem(`groupROHP_${id_box_RO_HP}`)) {
        localStorage.removeItem(`groupROHP_${id_box_RO_HP}`);
      }
      c_box_RO_HP.push(id_box_RO_HP);
      jsLogger.info(`groupROHP_${id_box_RO_HP} is added`);
      const newNode2 = {
        id: `groupROHP_${id_box_RO_HP++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto' },
      };
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    } else if (type === 'customnode_NF_HP_group') {
      if (c_box_RO_HP.length > 0) {
        c_box_RO_HP.sort((a, b) => { return a - b; });
        id_box_RO_HP = 1;
        for (let i = 0; i < c_box_RO_HP.length; i += 1) {
          if (id_box_RO_HP === c_box_RO_HP[i])
            id_box_RO_HP += 1;
          else
            break;
        }
      }
      if (c_box_RO_HP.length === 0)
        id_box_RO_HP = 1;

      if (localStorage.getItem(`groupROHP_${id_box_RO_HP}`)) {
        localStorage.removeItem(`groupROHP_${id_box_RO_HP}`);
      }
      c_box_RO_HP.push(id_box_RO_HP);
      jsLogger.info(`groupROHP_${id_box_RO_HP} is added`);
      const newNode2 = {
        id: `groupROHP_${id_box_RO_HP++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto' },
      };
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    }
    else if (type === 'customnode_Feed_AO_group') {
      if (c_box_Feed_AA.length > 0) {
        c_box_Feed_AA.sort((a, b) => { return a - b; });
        id_box_Feed_AA = 1;
        for (let i = 0; i < c_box_Feed_AA.length; i += 1) {
          if (id_box_Feed_AA === c_box_Feed_AA[i])
            id_box_Feed_AA += 1;
          else
            break;
        }
      }
      if (c_box_Feed_AA.length === 0)
        id_box_Feed_AA = 1;

      if (localStorage.getItem(`groupRAAFeed_${id_box_Feed_AA}`)) {
        localStorage.removeItem(`groupRAAFeed_${id_box_Feed_AA}`);
      }
      c_box_Feed_AA.push(id_box_Feed_AA);
      jsLogger.info(`groupRAAFeed_${id_box_Feed_AA} is added`);
      const newNode2 = {
        id: `groupRAAFeed_${id_box_Feed_AA++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto' },
      };
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    }
    else if (type === 'customnode_rectangle') {
      if (c_rectangle.length > 0) {
        c_rectangle.sort((a, b) => { return a - b; });
        id_rectangle = c_rectangle[c_rectangle.length - 1];
      }
      if (c_rectangle.length === 0)
        id_rectangle = 1;
      if (localStorage.getItem(`box_${id_rectangle}`)) {
        localStorage.removeItem(`box_${id_rectangle}`);
      }
      if (c_rectangle.length > 0) {
        if (c_rectangle.indexOf(id_rectangle) === -1) {
          c_rectangle.push(id_rectangle);
        } else {
          c_rectangle.push(Math.max(...c_rectangle) + 1);
          id_rectangle = Math.max(...c_rectangle) + 1;
        }
      } else {
        c_rectangle.push(id_rectangle);
      }
      jsLogger.info(`rectangle_${id_rectangle} is added`);
      const newNode2 = {
        id: `rectangle_${id_rectangle++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto' },
      };
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    }
    else if (type === 'customnode_horizental') {
      if (c_rectangle.length > 0) {
        c_rectangle.sort((a, b) => { return a - b; });
        id_rectangle = c_rectangle[c_rectangle.length - 1];
      }
      if (c_rectangle.length === 0)
        id_rectangle = 1;
      if (localStorage.getItem(`box_${id_rectangle}`)) {
        localStorage.removeItem(`box_${id_rectangle}`);
      }
      if (c_rectangle.length > 0) {
        if (c_rectangle.indexOf(id_rectangle) === -1) {
          c_rectangle.push(id_rectangle);
        } else {
          c_rectangle.push(Math.max(...c_rectangle) + 1);
          id_rectangle = Math.max(...c_rectangle) + 1;
        }
      } else {
        c_rectangle.push(id_rectangle);
      }
      jsLogger.info(`rectangle_${id_rectangle} is added`);
      const newNode2 = {
        id: `Horizental_Stripper_${id_rectangle++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto' },
      };
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    }
    else if (type === 'customnode_boosterPump') {
      if (c_boosterPump.length > 0) {
        c_boosterPump.sort((a, b) => { return a - b; });
        id_boosterPump = c_boosterPump[c_boosterPump.length - 1];
      }
      if (c_boosterPump.length === 0)
        id_boosterPump = 1;
      if (localStorage.getItem(`boosterpump_${id_boosterPump}`)) {
        localStorage.removeItem(`boosterpump_${id_boosterPump}`);
      }
      if (c_boosterPump.length > 0) {
        if (c_boosterPump.indexOf(id_boosterPump) === -1) {
          c_boosterPump.push(id_boosterPump);
        }
        else {
          c_boosterPump.push(Math.max(...c_boosterPump) + 1);
          id_boosterPump = Math.max(...c_boosterPump) + 1;
        }
      }
      else {
        c_boosterPump.push(id_boosterPump);
      }
      jsLogger.info(`boosterpump_${id_boosterPump} is added`);
      const newNode2 = {
        id: `boosterpump_${id_boosterPump++}`, // getId(),
        type,
        position,
        style: { width: 'auto', height: 'auto' },
      };
      node1.push(newNode2);
      setElements((es) => es.concat(newNode2));
    } else if (type === 'customnode_Pelton_Wheel') {
      isPeltonWheel = true;
      if (withoutDeletionDublicatePeltonWheel) {
        document.querySelector('#toatster-msg span').innerHTML = 'Two Pelton Wheel are not allowed on same flow sheet';
        document.querySelector('#toatster-msg').style.display = 'block';
        setTimeout(() => {
          document.querySelector('#toatster-msg').style.display = 'none';
          document.querySelector('#toatster-msg span').innerHTML = '';
        }, 3000);
        return false;
      }
      if (c_pelton_wheel.length > 0) {
        c_pelton_wheel.sort((a, b) => { return a - b; });
        id_pelton_wheel = 1;
        for (let i = 0; i < c_pelton_wheel.length; i += 1) {
          if (id_pelton_wheel === c_pelton_wheel[i])
            id_pelton_wheel += 1;
          else
            break;
        }
      }
      if (c_pump_hp.length > 0) {
        c_pump_hp.sort((a, b) => { return a - b; });
        id_pump_hp = c_pump_hp[c_pump_hp.length - 1] + 1;
      }
      if (c_roPump.length > 0) {
        c_roPump.sort((a, b) => { return a - b; });
        id_roPump = c_roPump[c_roPump.length - 1] + 1;
      }
      if (c_box_RO_HP.length > 0) {
        c_box_RO_HP.sort((a, b) => { return a - b; });
        id_box_RO_HP = c_box_RO_HP[c_box_RO_HP.length - 1] + 1;
      }
      if (c_rectangle.length > 0) {
        c_rectangle.sort((a, b) => { return a - b; });
        id_rectangle = c_rectangle[c_rectangle.length - 1] + 1;
      }
      if (c_roPump.length === 0)
        id_roPump = 1;
      if (c_pump_hp.length === 0)
        id_pump_hp = 1;
      if (c_pelton_wheel.length === 0)
        id_pelton_wheel = 1;
      if (c_box_RO_HP.length === 0)
        id_box_RO_HP = 1;
      if (c_rectangle.length === 0)
        id_rectangle = 1;
      if (localStorage.getItem(`peltonwheel_${id_pelton_wheel}`)) {
        localStorage.removeItem(`peltonwheel_${id_pelton_wheel}`);
      }
      if (localStorage.getItem(`hppump_${id_pump_hp}`)) {
        localStorage.removeItem(`hppump_${id_pump_hp}`);
      }
      if (localStorage.getItem(`roPump_${id_roPump}`)) {
        localStorage.removeItem(`roPump_${id_roPump}`);
      }
      c_pelton_wheel.push(id_pelton_wheel);
      if (c_pump_hp.length > 0) {
        if (c_pump_hp.indexOf(id_pump_hp) === -1) {
          c_pump_hp.push(id_pump_hp);
        } else {
          c_pump_hp.push(Math.max(...c_pump_hp) + 1);
          id_pump_hp = Math.max(...c_pump_hp) + 1;
        }
      } else {
        c_pump_hp.push(id_pump_hp);
      }
      if (c_roPump.length > 0) {
        if (c_roPump.indexOf(id_roPump) === -1) {
          c_roPump.push(id_roPump);
        } else {
          c_roPump.push(Math.max(...c_roPump) + 1);
          id_roPump = Math.max(...c_roPump) + 1;
        }
      } else {
        c_roPump.push(id_roPump);
      }
      if (c_box_RO_HP.length > 0) {
        if (c_box_RO_HP.indexOf(id_box_RO_HP) === -1) {
          c_box_RO_HP.push(id_box_RO_HP);
        } else {
          c_box_RO_HP.push(Math.max(...c_box_RO_HP) + 1);
          id_box_RO_HP = Math.max(...c_box_RO_HP) + 1;
        }
      } else {
        c_box_RO_HP.push(id_box_RO_HP);
      }
      if (c_rectangle.length > 0) {
        if (c_rectangle.indexOf(id_rectangle) === -1) {
          c_rectangle.push(id_rectangle);
        } else {
          c_rectangle.push(Math.max(...c_rectangle) + 1);
          id_rectangle = Math.max(...c_rectangle) + 1;
        }
      } else {
        c_rectangle.push(id_rectangle);
      }
      const ParentNode = {
        id: `groupROHP_${id_box_RO_HP}`,
        type: 'customnode_RO_HP_group',
        data: { label: null },
        position,
        style: { width: '187px', height: '206px' },
      };
      const newNode3 = {
        id: `hppump_${id_pump_hp++}`, // getId(),
        type: 'customnode_pump_hp',
        position: { x: 0, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode5 = {
        id: `roPump_${id_roPump++}`, // getId(),
        type: 'customnode_ROpump',
        position: { x: 134, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode1 = {
        id: `peltonwheel_${id_pelton_wheel++}`, // getId(),
        type,
        position: { x: 0, y: 150 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode6 = {
        id: `rectangle_${id_rectangle++}`, // getId(),
        type: 'customnode_rectangle',
        position: { x: 23, y: 51 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };

      const nodes = [newNode3, newNode1, newNode5, newNode6, ParentNode];
      peltonwheel_all_unitop.push(...nodes);
      setElements((es) => es.concat(...nodes));
    }
    // ################# Drop on Canvax Turbo Charger ###################
    else if (type === 'customnode_Turbo_Charger') {
      isturbocharger = true;
      if (withoutDeletionDublicateTurbo) {
        document.querySelector('#toatster-msg span').innerHTML = 'Two Turbo Chargers are not allowed on same flow sheet';
        document.querySelector('#toatster-msg').style.display = 'block';
        setTimeout(() => {
          document.querySelector('#toatster-msg').style.display = 'none';
          document.querySelector('#toatster-msg span').innerHTML = '';
        }, 3000);
        return false;
      }
      if (c_Turbo_Charger.length > 0) {
        c_Turbo_Charger.sort((a, b) => { return a - b; });
        id_Turbo_Charger = 1;
        for (let i = 0; i < c_Turbo_Charger.length; i += 1) {
          if (id_Turbo_Charger === c_Turbo_Charger[i])
            id_Turbo_Charger += 1;
          else
            break;
        }
      }
      if (c_pump_hp.length > 0) {
        c_pump_hp.sort((a, b) => { return a - b; });
        id_pump_hp = c_pump_hp[c_pump_hp.length - 1] + 1;
      }
      if (c_roPump.length > 0) {
        c_roPump.sort((a, b) => { return a - b; });
        id_roPump = c_roPump[c_roPump.length - 1] + 1;
      }
      if (c_box_RO_HP.length > 0) {
        c_box_RO_HP.sort((a, b) => { return a - b; });
        id_box_RO_HP = c_box_RO_HP[c_box_RO_HP.length - 1] + 1;
      }
      if (c_roPump.length === 0)
        id_roPump = 1;
      if (c_pump_hp.length === 0)
        id_pump_hp = 1;
      if (c_Turbo_Charger.length === 0)
        id_Turbo_Charger = 1;
      if (c_box_RO_HP.length === 0)
        id_box_RO_HP = 1;
      if (localStorage.getItem(`TC_${id_Turbo_Charger}`)) {
        localStorage.removeItem(`TC_${id_Turbo_Charger}`);
      }
      if (localStorage.getItem(`hppump_${id_pump_hp}`)) {
        localStorage.removeItem(`hppump_${id_pump_hp}`);
      }
      if (localStorage.getItem(`roPump_${id_roPump}`)) {
        localStorage.removeItem(`roPump_${id_roPump}`);
      }
      c_Turbo_Charger.push(id_Turbo_Charger);
      if (c_pump_hp.length > 0) {
        if (c_pump_hp.indexOf(id_pump_hp) === -1) {
          c_pump_hp.push(id_pump_hp);
        } else {
          c_pump_hp.push(Math.max(...c_pump_hp) + 1);
          id_pump_hp = Math.max(...c_pump_hp) + 1;
        }
      } else {
        c_pump_hp.push(id_pump_hp);
      }
      if (c_roPump.length > 0) {
        if (c_roPump.indexOf(id_roPump) === -1) {
          c_roPump.push(id_roPump);
        } else {
          c_roPump.push(Math.max(...c_roPump) + 1);
          id_roPump = Math.max(...c_roPump) + 1;
        }
      } else {
        c_roPump.push(id_roPump);
      }
      if (c_box_RO_HP.length > 0) {
        if (c_box_RO_HP.indexOf(id_box_RO_HP) === -1) {
          c_box_RO_HP.push(id_box_RO_HP);
        } else {
          c_box_RO_HP.push(Math.max(...c_box_RO_HP) + 1);
          id_box_RO_HP = Math.max(...c_box_RO_HP) + 1;
        }
      } else {
        c_box_RO_HP.push(id_box_RO_HP);
      }
      const ParentNode = {
        id: `groupROHP_${id_box_RO_HP}`,
        type: 'customnode_RO_HP_group',
        data: { label: null },
        position,
        style: { width: '317px', height: '206px' },
      };
      const newNode3 = {
        id: `hppump_${id_pump_hp++}`, // getId(),
        type: 'customnode_pump_hp',
        position: { x: 0, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode5 = {
        id: `roPump_${id_roPump++}`, // getId(),
        type: 'customnode_ROpump',
        position: { x: 264, y: 0 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const newNode1 = {
        id: `TC_${id_Turbo_Charger++}`, // getId(),
        type,
        position: { x: 130, y: 150 },
        style: { width: 'auto', height: 'auto' },
        parentNode: `groupROHP_${id_box_RO_HP}`,
        extent: 'parent',
        draggable: false
      };
      const nodes = [newNode3, newNode1, newNode5, ParentNode];
      turbocharger_all_unitop.push(...nodes);
      setElements((es) => es.concat(...nodes));
    }
    disabledStripperAndExplorerTab();
  }, [rfInstance]);

  const onOk = () => {
    setIsEdit(false);
    setText(decodeURIComponent(text.trim()));
    jsLogger.info(`File Name renamed : ${text.trim()} `);
    // open custom folder on save start save_tick icon
    onSave(text.trim());  // by abhishek for custom folder
    // if (text.trim() === '' || text.trim().length <= 3) {
    //   openModelPopUp('Please enter valid filename', 'Warning', 'warning');
    // }
    // else
    //   setVisibleSaveFiles(true);
    // open custom folder on save end
  };
  const openEditMenu = () => {
    oldText.current = text;
    setClonedText(text);
    const ele = (focusElement && focusElement.current) ? focusElement.current : focusElement;
    ele.focus();
    setIsEdit(true);
  };
  const PreviousName = () => {
    setText(decodeURIComponent(clonedText));
    setIsEdit(false);
  };
  const onCancel = () => {
    setIsEdit(false);
  };
  const viewCloseOption = () => {
    setViewOption(false);
  };
  const explorerCloseOption = () => {
    setExplorerOption(false);
  };
  const handleCloseOption = () => {
    setVisiableAAWithFeed(false);
    setOpenOption(false);
    setVisiableError(false);
    setVisibleRo(false);
    setVisibleNF(false);
    setVisibleStripper(false);
    setVisibleCF(false);
    setVisibleUnits(false);
    setVisibleFeed(false);
    // setAutoSavedFeedForm(false);
    setVisibleSplit(false);
    setVisiblePump(false);
    setVisibleDosing(false);
    setVisibleEDI(false);
    setVisibleHpPump(false);
    setVisibleWorkExchanger(false);
    setVisiblePeltonWheel(false);
    setVisibleWexPex(false);
    setVisibleTurbo(false);
    setVisibleSaveFiles(false);
    setAdminBtnTxt('Admin');
    // dragdrop.current = true;
  };
  const handleClosePi = () => {
    setVisiblePi(false);
  };
  const handleCloseSpecifyFlow = () => {
    setVisibleSpecifyFlow(false);
    dragdrop.current = true;
  };
  const onFileShare = (fileShareStr = '') => {
    // added by chandrashekhar because remove the warning in console. START
    if (fileShareStr === 'disabled' && isConvasEmpty) {
      return false;
    }
    // added by chandrashekhar because remove the warning in console. END
    let flagShareData = false;
    flagshareclick = true;
    if (rfInstance) {
      if (rfInstance.getNodes().length <= 0 && rfInstance.getEdges().length <= 0) {
        flagShareData = true;
      }
    } else {
      flagShareData = true;
    }
    handleClickStr = 'blank';
    if (flagShareData) {
      openModelPopUp('You cannot share empty flowsheet !', 'Warning', 'warning');
    } else if (!text || text === 'filename') {
      openModelPopUp(t('Kindly save the file before sharing!'), 'Warning', 'warning');
    } else {
      handleClickStr = '';
      onSave_saveButton();
    }
  };
  const CustomControls = () => {
    // code was commented for customized are not allowed
    // const inputFields = document.querySelectorAll('.react-flow__edgelabel-renderer input');

    // if (inputFields) {
    //   inputFields.forEach((inputField) => {
    //     if (isInteractive) {
    //       inputField.style.pointerEvents = 'all';
    //     } else {
    //       inputField.style.pointerEvents = 'none';
    //     }
    //   });
    // }
    return (
      <Controls>
        {/* <button
          type="button"
          className="react-flow__controls-button-customized react-flow__controls-interactive-customized"
          title="Toggle Interactivity"
          aria-label="toggle interactivity"
          // data-testid="element"
          data-title="Toggle Interactivity"
          onClick={toggleInteractivity}
        >
          {isInteractive ? (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 32">
            <path d="M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z"></path>
          </svg>) : (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 32"><path d="M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z"></path></svg>)}

        </button> */}
        <ControlButton className="react-flow__controls-button react-flow__controls-height" onClick={() => setHeight_canvas(height_canvas + 75)}>
          <HeightRoundedIcon className='react-flow-control react-flow-width' />
        </ControlButton>
        <ControlButton className="react-flow__controls-button react-flow__controls-width" onClick={() => setWidth_canvas(width_canvas + 150)}>
          <HeightRoundedIcon className='react-flow-control react-flow-height' />
        </ControlButton>
      </Controls>
    );
  };

  const getReportExecute = (event, ele) => {
    if (!event.target.closest('.menu-item').classList.contains('disabled')) {
      if (ele.str === 'calculate') {
        if (localStorage.getItem('globalExitBtn') === 'true' && !text) {
          openModelPopUp('Please save the file before executing!', 'Warning', 'warning');
          return false;
        } else {
          setFindAllConnection(false);
          setCallExecuteFun(true);
          const reactFlowEdges = document.querySelectorAll('.react-flow__edges path.react-flow__edge-interaction');
          if (reactFlowEdges.length > 0) {
            reactFlowEdges.forEach((ele) => {
              ele.classList.remove('click-active');
            });
          }
          setTimeout(() => {
            addMouseHoverEvent();
          }, 100);
        }
      } else if (ele.str === 'stream') {
        openPopup('View');
      } else if (ele.str === 'explorer') {
        openPopup('Explorer');
      } else if (ele.str === 'specifyflow') {
        setVisibleSpecifyFlow(true);
      } else if (ele.str === 'error') {
        setVisiableError(true);
      } else if (ele.str === 'pdf-report') {
        setPdfAnchorEl(event.currentTarget);
        setExecuteDisabled(true);
      }
    } else {
      event.preventDefault();
    }
  };
  const getMassBalance = (event) => {
    // if (!event.target.closest('.menu-item').classList.contains('disabled')) {
    setMassBalanceAnchorEl(event.currentTarget);
    setOpenMassBalanceOverlay(true);
    // }
  };
  const fetchLoadingData = (data) => {
    setFindAllConnection(false);
    setExecutefetchLoadings(data);
    flowPassData = data.data;
    if (data.img && data.msg) {
      setFetchLoading(data.loader);
      if (data.warningArr && data.warningArr.str === 'errorwarning') {
        openModelPopUp('Flowsheet solved with errors.', 'Warning', 'warning');
        setExecutefetchLoadings('');
      } else {
        openModelPopUp(t('Flowsheet is solved successfully.'), 'Solver Message', 'success');
        setExecutefetchLoadings('');
      }
    } else if (data.msg) {
    } else { setFetchLoading(data.loader); }
  };

  const executeObjData = (data) => {
    setExecuteObj(data);
    setOpenStremOverlay(true);
  };
  const reportErrorListDataData = (data) => {
    setReportErrorListData(data);
    error_details_info = data;
  };

  const jsonFileUpload = async (event) => { // upload files function
    if (event.target.files && event.target.files[0]) { // checking file event is existing?
      const files = event.target.files[0];
      const data = await uploadWinFiles(event);
      // win-4 file upload
      const content = await data.target.result;
      const filename = files.name;
      if (content.indexOf('<?xml') !== -1) {
        uploadWin_4_File(filename, content, 'flow', fetchData, setFetchLoading, setVisibleDefaultuints);
      } else {
        let winData = data.target.result;
        if (winData[0] !== '{') {
          if (winData[0] === '"' && filename.split('.win').length < 2) {
            winData = decrypt_data(JSON.parse(data.target.result));
          } else {
            winData = decrypt_data(data.target.result);
          }
        }
        fetchData(files.name.split('.win')[0], true, winData); // updataing canvas with selected files data
        setFetchLoading(false); // disableing loading symbol
        setVisibleDefaultuints(false);
      }
    }
  };
  const eleDragStreamInfoPopup = (e) => {
    e = e || window.event;
    e.preventDefault();
    position1 = position3 - e.clientX;
    position2 = position4 - e.clientY;
    position3 = e.clientX;
    position4 = e.clientY;
    stramInfoElement.current.style.top = `${(stramInfoElement.current.offsetTop - position2)}px`;
    stramInfoElement.current.style.left = `${(stramInfoElement.current.offsetLeft - position1)}px`;
  };
  const closeStreamInfoPopup = () => {
    draggableStart = true;
    document.onmouseup = null;
    document.onmousemove = null;
  };
  const dragStreamIfoPopup = (e) => {
    draggableStart = false;
    e = e || window.event;
    e.preventDefault();
    position3 = e.clientX;
    position4 = e.clientY;
    document.onmouseup = closeStreamInfoPopup;
    document.onmousemove = eleDragStreamInfoPopup;
  };

  // This function will not allow user to enter some restricted special character in the file name
  const setFileNameWithoutSpChar = (e) => {
    const str = e.target.value;
    const specialChars = ['{', '}', '[', ']', '/', '\\', '<', '>', '~', '|', '^', '%', '`', '"', '\'', '#', '&'];
    let newStr = '';
    for (let i = 0; i < str.length; i += 1) {
      if (!specialChars.includes(str[i])) {
        newStr += str[i];
      } else {
        openModelPopUp(`'{ }[ ] / \\ < > ~ | \` " ^ ' # % &'  is not allowed in file name.`, 'Warning', 'warning');
      }
    }
    setText(newStr);
  };

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 40,
    height: 20,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 12,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff', // checked circle color
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#002D62' : '#002D62',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 16,
      height: 16,
      borderRadius: 10,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 45 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? '#D5D3E3' : '#D5D3E3', // checked track color
      boxSizing: 'border-box',
    },
  }));

  const handleASChange = (event) => {
    setChecked(event.target.checked);

    if (event.target.checked) {
      onStreamAlign(event);
    }
    disabledStripperAndExplorerTab();
  };
  return (
    <>
      <div ref={stramInfoElement} className='stream-info-wrapper' id='stream-info-wrapper' onMouseOver={() => streamInfoShowHide(true)} onMouseLeave={() => streamInfoShowHide(false)}>
        <div className='handler-drag-1' onMouseDown={(event) => dragStreamIfoPopup(event)} />
        <div className='handler-drag-2' onMouseDown={(event) => dragStreamIfoPopup(event)} />
        <div className='handler-drag-3' onMouseDown={(event) => dragStreamIfoPopup(event)} />
        <div className='handler-drag-4' onMouseDown={(event) => dragStreamIfoPopup(event)} />
        <ul className='stream-info'>
          {streamInfoData.length > 0 && streamInfoData.map((ele, i) => {
            return (
              <li key={i}>
                <span className='bold left'>{ele.str}</span>
                <span className='bold center'>:</span>
                <span className='right'>{ele.value} {ele.unitType && <span>{ele.unitType}</span>} </span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className='toatster-msg' id='toatster-msg'>
        <span />
      </div>
      <Box sx={{ flexGrow: 1 }}>
        <Backdrop
          sx={{ color: '#fff', zIndex: 999999 }}
          style={{
            background: '#d9dbde5c',
          }}
          open={fetchLoading}>
          <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
        </Backdrop>
        <Notification options={modalOption} handleClose={() => closeModelOption()} />
        <div id='loaderImg' style={{ display: state_loader.showResults ? 'block' : 'none' }}>
          <div className="pleaseWaitText"> Please wait...</div></div>
        <div id='overlay' style={{ display: state_loader.showResults ? 'block' : 'none' }} />
        <Grid onClick={onElementClicksData} container item xs={12} style={{ position: 'relative' }}>
          <div className="side-bar">
            <Sidebar handleClick={handleClick} onOk={onOk} onCancel={onCancel} isEdit={isEdit} text={text} setText={setText} clroAccess={Object.keys(dbTransactionDetails).length > 0 ? getNFfeedAndCLROFrom(dbTransactionDetails, 'CLRO User') : false} NFFeedAccess={Object.keys(dbTransactionDetails).length > 0 ? getNFfeedAndCLROFrom(dbTransactionDetails) : false} ArgoAccess={Object.keys(dbTransactionDetails).length > 0 ? getArgoFromAccess(dbTransactionDetails) : false} elements={elements} />
          </div>
          <div className='canvas-wrapper'>
            <div className='canvas-header-menu'>
              <div className="sansW4SeLig edit-file-menu">
                <div className="con">
                  <input
                    ref={focusElement}
                    title={text}
                    value={text}
                    className='Form_Input_design'
                    onChange={(e) => setFileNameWithoutSpChar(e)}
                    name="input"
                    id="input"
                    onBlur={onCancel}
                    placeholder={t('Give File Name')}
                    onClick={openEditMenu}
                    autoComplete="off"
                  />
                  <Tooltip title="Edit File" placement="bottom" arrow>
                    <Button className='edit_file' data-testid='file name' style={{ background: 'transparent' }} aria-label="file name" onClick={openEditMenu} size="large">
                      <div className="card" style={{ marginRight: '8px' }}>
                        <img src={editIcon} alt='edit_file' className="menu-item-block" />
                        <img src={editIconColor} className="img-top" alt='edit_file' />
                      </div>
                    </Button>
                  </Tooltip>
                  {isEdit ? (
                    <div className="icon">
                      <div className="card" id='saveAS'>
                        <img src={navigateIcon} alt='check' onMouseDown={onOk} />
                        <img src={navigateIcon} className="img-top" alt='edit_file_color' onMouseDown={onOk} />
                      </div>
                      <div className="card" style={{ position: 'absolute' }}>
                        <img src={closeIcon} alt='close' onMouseDown={PreviousName} />
                        <img src={closeIcon} className="img-top" alt='edit_file_color' onMouseDown={PreviousName} />
                      </div>
                    </div>
                  ) : ('')}
                </div>
                <Tooltip title={t('Share File')} placement="bottom" arrow>
                  {/* <Button className='share-file' style={{ background: 'transparent' }} data-testid='share' aria-label="share" onClick={onFileShare} size="large" disabled={isConvasEmpty}> */}
                  <Button className='share-file' style={{ background: 'transparent' }} data-testid='share' aria-label="share" onClick={() => onFileShare('disabled')} size="large">
                    <div className="card">
                      {
                        isConvasEmpty ?
                          <img src={isHoveredShare ? share_Icon_hover_disabled : share_Icon_disabled} alt='share' className="menu-image"
                            onMouseEnter={() => setIsHoveredShare(true)}
                            onMouseLeave={() => setIsHoveredShare(false)} />
                          :
                          <img src={isHoveredShare ? share_Icon_hover : shareIcon} alt='share' className="menu-image"
                            onMouseEnter={() => setIsHoveredShare(true)}
                            onMouseLeave={() => setIsHoveredShare(false)} />
                      }
                    </div>
                  </Button>
                </Tooltip>
                <Tooltip title="Save" placement="bottom" arrow>
                  <Button className='save-file' style={{ background: 'transparent' }} data-testid='save' aria-label="save"
                    // open custom folder on save start save_btn
                    // onClick={() => { setVisibleSaveFiles(true); }} size="large" disabled={isConvasEmpty}>
                    onClick={() => onSave_saveButton('', '', 'disabled')} size="large">
                    {/* open custom folder on save end */}
                    <div className="card">
                      {
                        isConvasEmpty ?
                          <img src={isHoveredSave ? save_hover_disabled : save_Icon_disabled} alt='save_file' className="menu-image"
                            onMouseEnter={() => setIsHoveredSave(true)}
                            onMouseLeave={() => setIsHoveredSave(false)} />
                          :
                          <img src={isHoveredSave ? save_hover : save_Icon} alt='save_file' className="menu-image"
                            onMouseEnter={() => setIsHoveredSave(true)}
                            onMouseLeave={() => setIsHoveredSave(false)} />
                      }
                    </div>
                  </Button>
                </Tooltip>
                <Tooltip title="Download File" placement="bottom" arrow>
                  {/* <Button className='save-file' data-testid='download' style={{ background: 'transparent' }} aria-label="download" onClick={onDownload_Button} size="large"  disabled={isConvasEmpty}> */}
                  <Button className='save-file' data-testid='download' style={{ background: 'transparent' }} aria-label="download" onClick={() => onDownload_Button('disabled')} size="large">
                    <div className="card">
                      {
                        isConvasEmpty ?
                          <img src={isHoveredDownload ? download_hover_disabled : download_Icon_disabled} alt='download_file' className="menu-image"
                            onMouseEnter={() => setIsHoveredDownload(true)}
                            onMouseLeave={() => setIsHoveredDownload(false)} />
                          :
                          <img src={isHoveredDownload ? download_hover : download_Icon} alt='download_file' className="menu-image"
                            onMouseEnter={() => setIsHoveredDownload(true)}
                            onMouseLeave={() => setIsHoveredDownload(false)} />
                      }
                    </div>
                  </Button>
                </Tooltip>
                {isElementModelAccess && <Tooltip title="This file has RO elements for which access is restricted" placement="bottom" arrow>
                  <Button className='save-file' data-testid='warning' aria-label="save" size="large">
                    <div className="card">
                      <img src={reportWarningImage} alt='ro_file_error' className="menu-item-block" />
                      <img src={reportWarningImage} className="img-top" alt='ro_file_err_color' />
                    </div>
                  </Button>
                </Tooltip>}
              </div>
              <div className="menu-block specify-flow">
                {executeObj.length > 0 && executeObj.map((ele, ind) => {
                  return (
                    <Tooltip title={ele.title} placement="bottom" arrow key={ind}>
                      <Button aria-controls={pdfOpen ? 'demo-positioned-menu' : undefined}
                        aria-haspopup="true"
                        style={{ background: 'transparent' }}
                        aria-expanded={pdfOpen ? 'true' : undefined}
                        ref={el => { buttonElement.current[ind] = el; }} id={`${ele.str}_data`} className={`menu-item ${ele.class} ${ele.disabled ? 'disabled' : ''}`} data-testid={ele.title} aria-label={ele.title} onClick={(event) => getReportExecute(event, ele)} size="large">
                        <div className="card">
                          <img src={ele.oriImg} alt={ele.title} className="menu-item-block" />
                          <img src={ele.hovImg} className="img-top" alt={ele.title} />
                        </div>
                      </Button>
                    </Tooltip>
                  );
                })}
                {executeDisabled && (
                  <PdfOptions
                    flowSheetImage={flowSheetImage}
                    setState_loader={setState_loader}
                    text={text}
                    pdfOpen={pdfOpen}
                    setPdfAnchorEl={setPdfAnchorEl}
                    pdfAnchorEl={pdfAnchorEl}
                    translateObject={t}
                    report_invoice={executeEDIInfoData.reportData}
                    flowSheetSolvdData={executeEDIInfoData.flowSheetSolvdData}
                  />
                )}
              </div>
            </div>
            {/* FlowSheet Recovery :  only visible after calculate openStremOverlay executeDisabled */}
            {openStremOverlay && !(localStorage.getItem('StandAloneARGO') == 'true') && (
              <div className='system-info'>
                {getMassBalanceAccess(dbTransactionDetails) && <div className='massbalance'>
                  <Tooltip title="Mass Balance" placement="left" data-testid="flowtool-tip" arrow>
                    <IconButton className='massBal' style={{ background: 'transparent' }} data-testid='save' aria-label="save" aria-controls={MassBalanceOpen ? 'demo-positioned-menu' : undefined} aria-expanded={MassBalanceOpen ? 'true' : undefined} aria-haspopup="true"
                      onClick={(event) => { getMassBalance(event); }}
                      // size="large" disabled={isConvasEmpty}>
                      size="large">
                      <div className="card">
                        {(executeEDIInfoData?.reportData?.report_dict?.massbal_dict?.Overall_Flag === true) && <img src={Checked_Icon} className="img-top1" alt='mb_true_icon' />}
                        {(executeEDIInfoData?.reportData?.report_dict?.massbal_dict?.Overall_Flag === false) && <img src={UnChecked_Icon} className="img-top1" alt='mb_false_icon' />}
                        <img src={Balance_Icon} alt='Design Canvas' className="menu-item-block" />
                      </div>
                    </IconButton >
                  </Tooltip>
                  {/* <div className='sysRvyNum'>{systemRecoveryValue}</div> */}
                </div>}
                <div className='flowRecovery'>
                  <div className='sysRvyText'>{t('System Recovery')}</div>
                  <div className='sysRvyNum'>{systemRecoveryValue}</div>
                </div>
              </div>
            )}
            {
              openMassBalanceOverlay && (
                <MassBalance
                  openMassBalanceOverlay={openMassBalanceOverlay}
                  massBalanceAnchorEl={massBalanceAnchorEl}
                  setMassBalanceAnchorEl={setMassBalanceAnchorEl}
                  MassBalanceOpen={MassBalanceOpen}
                  translateObject={t}
                  report_invoice={executeEDIInfoData.reportData}
                />
              )
            }
            {/* {openStremOverlay && (
              <div className='flowRecovery'>
                <div className='sysRvyText'>{t('System Recovery')}</div>
                <div className='sysRvyNum'>{systemRecoveryValue}</div>
              </div>
            )} */}
            {/* FlowSheet Recovery */}
            <div onClick={onElementClicksData} className="dndflow">
              <ReactFlowProvider>
                <div className="reactflow-wrapper" ref={reactFlowWrapper} style={{ minHeight: height_canvas, minWidth: width_canvas }}>
                  <div style={{ height: height_canvas, minHeight: height_canvas, minWidth: width_canvas }}>
                    <ReactFlow
                      nodes={elements} // changes to elements to nodes in version 11 @sudarsana
                      edges={edges}   // Added new property version 11 @sudarsana
                      connectionRadius={100} // Added new Property version 11 @sudarsana
                      onNodesChange={onNodesChange}  // Added new property version 11 @sudarsana
                      onEdgesChange={onEdgesChange}  // Added new property version 11 @sudarsana
                      onConnect={onConnect}
                      // nodesDraggable={isInteractive}
                      onConnect_new_PW={onConnect_new_PW}
                      onConnect_new_TC={onConnect_new_TC}
                      deleteKeyCode={null} // @sudarsana backkey removed for deleting
                      selectNodesOnDrag={false}
                      onInit={setRfInstance}  // Added new property version 11 @sudarsana
                      onEdgeContextMenu={onEdgeContextMenu}
                      onEdgeMouseEnter={onEdgeMouseEnter}
                      className="validationflow"
                      nodeTypes={nodeTypes}
                      edgeTypes={edgeTypes}
                      onConnectStart={onConnectStart}
                      onConnectStop={onConnectStop}
                      onConnectEnd={onConnectEnd}
                      onNodeClick={onClickElements && onElementClick}  // Added onNodeClick updated name as onElementClick @sudarsana
                      connectionLineType="step"
                      onNodeDrag={onNodeDrag}  // @sudarsana add for proximity connection
                      onDrop={onDrop}
                      onDragOver={onDragOver}
                      onEdgeUpdate={onEdgeUpdate} // Added new property in version 11 @sudarsana
                      snapToGrid               // Added SnapTOGrid rin version @sudarsana
                      snapGrid={[54, 54]}  // @sudarsana changed values 54 and 54
                      style={{ 'position': 'absolute' }}
                    >
                      <Background color="#aaa" gap={16} />
                      <DownloadFlowsheet flowsheetImage={getFlowSheetDataUrlImages} />
                      {/* @sudarsana add for proximity connection */}
                      <Proximity />
                      {/* Edge intersection highlights */}
                      <EdgeIntersections edges={edges} />
                    </ReactFlow>
                  </div>
                  {/* automate_stream */}
                  <div id='automateStream' className={`automate_stream ${checked ? 'checkedAs' : 'defaultAs'}`} data-testid='automate_stream' >
                    <div className='asTxt'>{t('Automate Stream ID')}</div>
                    <div className="automateStream_switch">
                      <AntSwitch
                        checked={checked}
                        label="Automate Stream"
                        onChange={handleASChange} />
                    </div>
                  </div>
                </div>
                <CustomControls />
                <input type="file" id="file" ref={inputFile} style={{ display: 'none' }} data-testid="element" />
              </ReactFlowProvider>
            </div>
          </div>
          <div className="save__controls">
            <Tooltip title="Load File" placement="left" arrow>
              <Button
                aria-label="My Files"
                onClick={onRestore}
                size="large"
                style={{ background: 'transparent' }}
                data-testid="openfile">
                <div className="card">
                  <img src={openFileIcon} alt='My Files' className="menu-item-block" />
                  <img src={openIconColor} className="img-top" alt='My Files' />
                </div>
              </Button>
            </Tooltip>{' '}
            <Tooltip title="New Canvas" placement="left" data-testid="flowtool-tip" arrow>
              <Button
                aria-label="Design Canvas"
                onClick={onNewFile}
                size="large"
                style={{ background: 'transparent' }}
              >
                <div className="card">
                  <img src={new_Icon} alt='Design Canvas' className="menu-item-block" />
                  <img src={newIconColor} className="img-top" alt='Design Canvas' />
                </div>
              </Button>
            </Tooltip>
            <Tooltip title="Select system of units" placement="left" arrow>
              <Button
                aria-label="units"
                onClick={() => { jsLogger.info('Select system of units Clicked'); setVisibleUnits(true); }}
                size="large"
                style={{ background: 'transparent' }}
              >
                <div className="card">
                  <img src={settings} alt='units' className="menu-item-block" />
                  <img src={systemUnitsIconColor} className="img-top" alt='units_color' />
                </div>
              </Button>
            </Tooltip>
            {/* options tab is disabled from prod & avail. only in dev n qa by Abhishek 8-Dec-23  */}
            {/* @ sudarsana for access of options button only specific user */}
            {((process.env.REACT_APP_ENV === 'dev') ||
              (process.env.REACT_APP_ENV === 'qa' && userMail_ID_Access_Env.includes(mail_ID)) ||
              (process.env.REACT_APP_ENV === 'prod' && userMail_ID_Access_Env.includes(mail_ID))) &&
              <Tooltip title="Options" placement="left" arrow>
                <Button
                  aria-label="options"
                  onClick={() => { jsLogger.info('Options Clicked'); setOpenOption(true); }}
                  size="large"
                  style={{ background: 'transparent' }}
                >
                  <div className="card">
                    <img src={optionsIcon} alt='options' className="menu-item-block" />
                    <img src={optionsIconColor} className="img-top" alt='options_color' />
                  </div>
                </Button>
              </Tooltip>}
            <Tooltip title="Reset" placement="left" arrow>
              <Button
                aria-label="reset"
                onClick={onReset}
                size="large"
                style={{ background: 'transparent' }}
              >
                <div className="card">
                  <img src={resetIcon} alt='reset_file' className="menu-item-block" />
                  <img src={resetIconColor} className="img-top" alt='reset_file_color' />
                </div>
              </Button>
            </Tooltip>
            <Tooltip title="Project Info" placement="left" arrow>
              <Button ref={el => { projectInfo.current[0] = el; }}
                aria-label="units"
                onClick={() => { jsLogger.info('Project Info Clicked'); setVisiblePi(true); }}
                size="large"
                id='pInfoId'
                style={{ background: 'transparent' }}
              >
                <div className="card">
                  <img src={project_info} alt='units' className="menu-item-block" />
                  <img src={icon_color_project_info} className="img-top" alt='units_color' />
                </div>
              </Button>
            </Tooltip>
          </div>
        </Grid>
      </Box>
      <Modal id="openDialog" className="open-dialog" isOpen={modalIsOpen_filehandle} ariaHideApp={false}>
        <Box sx={{ width: '100%' }}>
          <AnimeList
            setModalIsOpen_filehandle={setModalIsOpen_filehandle}
            getFlowSheetData={getFlowSheetData}
            setSelectedFileName={setSelectedFileName}
            modalIsOpen_filehandle={modalIsOpen_filehandle}
            elements={elements}
            setElements={setElements}
            jsonFileUpload={jsonFileUpload}
            openModelPopUp={openModelPopUp}
            setIsElementModelAccess={setIsElementModelAccess}
            resetVariable={resetVariable}
            clroAccess={clroAccess}
            translateObject={t}
            forceUpdate={forceUpdate}
          />
        </Box>
      </Modal>
      <Modal id="saveDialog" isOpen={modalIsOpen_saveDialog}>
        <Box>
          <SaveDialog
            setModalIsOpen_saveDialog={setModalIsOpen_saveDialog}
            modalIsOpen_saveDialog={modalIsOpen_saveDialog}
            onSave={onSave}
          />
        </Box>
      </Modal>
      <Modal isOpen={modalIsOpen_alert}>
        <Box sx={{ width: '100%' }}>
          <AlertDialog
            setModalIsOpen_alert={setModalIsOpen_alert}
            modalIsOpen_alert={modalIsOpen_alert}
          />
        </Box>
      </Modal>
      {openStremOverlay && !(localStorage.getItem('StandAloneARGO') == 'true') && (
        <StreamOverlayDrawerHeader
          fileName={selectedFileName}
        />
      )}
      <ExecuteContext.Provider value={executeEDIInfoData}>
        {visible_fileSharing && (
          <div className="file-share-draggable">
            <File_Share
              visible_fileSharing={visible_fileSharing}
              setVisible_fileSharing={setVisiblefileSharing}
              onSave_saveButton={onSave_saveButton}
              text={`${text}-sharedFile`}
            />
          </div>
        )}
        {visibleRo && (
          <RoInput
            visibleRo={visibleRo}
            handleCloseRo={handleCloseOption}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            roDetails={roDetails}
            dbTransactionDetails={dbTransactionDetails}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            setIsElementModelAccess={setIsElementModelAccess}
            onElementClick={onElementClick}
            inputOutputFlag={inputOutputFlag}
            setInputOutputFlag={setInputOutputFlag}
            getReportExecute={getReportExecute}
            translateObject={t}
          />
        )}
        {visiableAAWithFeed && (<ArgoAnalyzer
          handleCloseRoModal={handleCloseOption}
          dbTransactionDetails={dbTransactionDetails}
          setokbuttonFormAutoSave={setokbuttonFormAutoSave}
          handleCloseRo={handleCloseOption}
          argoDetails={argoDetails}
          translateObject={t}
          visiableAAWithFeed={visiableAAWithFeed}
          disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
          setIsElementModelAccess={setIsElementModelAccess}
          onElementClick={onElementClick}
          inputOutputFlag={inputOutputFlag}
          setInputOutputFlag={setInputOutputFlag}
          getReportExecute={getReportExecute}
        />)}
        {visibleNF && (
          <NFInput
            visibleNF={visibleNF}
            handleCloseNF={handleCloseOption}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            roDetails={roDetails}
            dbTransactionDetails={dbTransactionDetails}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            setIsElementModelAccess={setIsElementModelAccess}
            onElementClick={onElementClick}
            inputOutputFlag={inputOutputFlag}
            setInputOutputFlag={setInputOutputFlag}
            getReportExecute={getReportExecute}
            translateObject={t}
          />
        )}
        {visibleFeed && (
          <FeedInput
            setVisibleFeed={handleCloseOption}
            visibleFeed={visibleFeed}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            dbTransactionDetails={dbTransactionDetails}
            feedItem={feedItem}
            selectedFileName={selectedFileName}
            handleFeedItem={() => setFeedItem({})}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            text={text}
            translateObject={t}
          />
        )}
        {visibleUnits && (
          <ExecuteContext.Provider value={executeEDIInfoData}>
            <SystemUnits
              feedItem={feedItem}
              visibleUnits={visibleUnits}
              visibleDefaultUnits={visibleDefaultUnits}
              translateObject={t}
              handleCloseUnits={handleCloseOption}
            />
          </ExecuteContext.Provider>
        )}

        {visibleCF && (
          <CartridgeFilter
            visibleCF={visibleCF}
            handleCloseCF={handleCloseOption}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            dbTransactionDetails={dbTransactionDetails}
            unitopDetails={unitopDetails}
            translateObject={t}
          />
        )}
        {visibleStripper && (
          <StripperInput
            visibleStripper={visibleStripper}
            handleCloseStripper={handleCloseOption}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            stripperDetails={stripperDetails}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
          />
        )}
        {visibleSaveFiles && (
          <SaveFiles
            visibleSaveFiles={visibleSaveFiles}
            handleCloseSaveFiles={handleCloseOption}
            text={text}
            setText={setText}
            onSave={onSave}
            onSave_saveButton={onSave_saveButton}
            setSourcePath={setSourcePath}
            sourcePath={sourcePath}
            openModelPopUp={openModelPopUp}
            // splitDetails={splitDetails}
            // localData_mixSplit={localData_mixSplit}
            // splitObjData={splitObjData}
            // streamNum_dict={streamNum_dict}
            // splitterColor={splitterColor}
            // setSplitterColor={setSplitterColor}
            // setCallExecuteFun={setCallExecuteFun}
            // inputOutputFlag={inputOutputFlag}
            // setInputOutputFlag={setInputOutputFlag}
            // disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
          />
        )}
        {visibleSplit && (
          <SplitInput
            visibleSplit={visibleSplit}
            handleCloseSplit={handleCloseOption}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            splitDetails={splitDetails}
            localData_mixSplit={localData_mixSplit}
            splitObjData={splitObjData}
            streamNum_dict={streamNum_dict}
            splitterColor={splitterColor}
            setSplitterColor={setSplitterColor}
            setCallExecuteFun={setCallExecuteFun}
            inputOutputFlag={inputOutputFlag}
            setInputOutputFlag={setInputOutputFlag}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
            openStremOverlay={openStremOverlay}
          />
        )}
        {visibleSpecifyFlow && (
          <SpecifyFlow
            visibleSpecifyFlow={visibleSpecifyFlow}
            setVisibleSpecifyFlow={setVisibleSpecifyFlow}
            handleCloseSpecifyFlow={handleCloseSpecifyFlow}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            elements={elements}
            openModelPopUp={openModelPopUp}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
          />
        )}
        {visiblePump && (
          <PumpInput
            visiblePump={visiblePump}
            handleClosePump={handleCloseOption}
            pumpDetails={pumpDetails}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            dbTransactionDetails={dbTransactionDetails}
            splitObjData={splitObjData}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
          />
        )}
        {visibleDosing && (
          <DosingInput
            visibleDosing={visibleDosing}
            handleCloseDosing={handleCloseOption}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            dosingDetails={dosingDetails}
            inputOutputFlag={inputOutputFlag}
            setInputOutputFlag={setInputOutputFlag}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
          />
        )}
        {visibleEDI && (
          <EDIInput
            visibleEDI={visibleEDI}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            handleCloseEDI={handleCloseOption}
            ediDetails={ediDetails}
            buttonElement={buttonElement}
            dbTransactionDetails={dbTransactionDetails}
            inputOutputFlag={inputOutputFlag}
            setInputOutputFlag={setInputOutputFlag}
            translateObject={t}
          />
        )}
        {visibleHpPump && (
          <HPumpInput
            visibleHpPump={visibleHpPump}
            handleCloseHpPump={handleCloseOption}
            pumpDetails={pumpDetails}
            dbTransactionDetails={dbTransactionDetails}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            splitObjData={splitObjData}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            clro_all_unitop={clro_all_unitop}
            translateObject={t}
          />
        )}
        {openOption && (
          <Options
            openOption={openOption}
            handleCloseOption={handleCloseOption}
            dbTransactionDetails={dbTransactionDetails}
            adminBtnTxt={adminBtnTxt}
            setAdminBtnTxt={setAdminBtnTxt}
            setOpenOption={setOpenOption}
            mail_ID={mail_ID}
            userMail_ID_Access_Env={userMail_ID_Access_Env}
          />
        )}
        {viewOption && (
          <Views
            viewOption={viewOption}
            handleCloseOption={viewCloseOption}
            ediOutputData={ediOutputData}
          />
        )}
        {explorerOption && (
          <Explorer
            explorerOption={explorerOption}
            handleCloseOption={explorerCloseOption}
            report_invoice={executeEDIInfoData.reportData}
          />
        )}
        {visiableError && (
          <ReportWinflow
            visiableError={visiableError}
            reportErrorListData={reportErrorListData}
            handleCloseOption={handleCloseOption}
            activeIndexVal={activeIndexVal}
            translateObject={t}
          />
        )}
        {callExecuteFun && (
          <ExecutePopup
            duplicateNodeFlag={duplicateNodeFlag}
            openModelPopUp={openModelPopUp}
            element={elements}
            edges={edges}
            findAllConnection={findAllConnection}
            executeOptionFlag={executeOptionFlag}
            connectionInfo_source_target={connectionInfo_source_target}
            fetchLoadings={fetchLoadingData}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            executeObjs={executeObjData}
            reportErrorListDatas={reportErrorListDataData}
            wexpex_all_unitop={wexpex_all_unitop}
            peltonwheel_all_unitop={peltonwheel_all_unitop}
            turbocharger_all_unitop={turbocharger_all_unitop}
            filename={text}
            clro_all_unitop={clro_all_unitop}
            setInputOutputFlag={setInputOutputFlag}
            ediOutputDataset={ediOutputDataset}
            translateObject={t}
          />
        )}
        {visiblePi && (<ProjectInfo
          visiblePi={visiblePi}
          handleClosePi={handleClosePi}
          translateObject={t}
        />
        )}
        {visibleWorkExchanger && (
          <WorkExchangerForm
            visibleWorkExchanger={visibleWorkExchanger}
            workExchanger={workExchanger}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            handleCloseWorkExchanger={handleCloseOption}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
          />
        )}
        {visiblePeltonWheel && (
          <PeltonWheelForm
            visiblePeltonWheel={visiblePeltonWheel}
            pletonWheel={pletonWheel}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            handleClosePeltonWheel={handleCloseOption}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
          />
        )}
        {visibleTurbo && (
          <TurboChargerForm
            visibleTurbo={visibleTurbo}
            turboChargeDetails={turboChargeDetails}
            setokbuttonFormAutoSave={setokbuttonFormAutoSave}
            turbocharger_all_unitop={turbocharger_all_unitop}
            handleCloseTurboCharger={handleCloseOption}
            disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
            translateObject={t}
          />
        )}
      </ExecuteContext.Provider>
    </>
  );
}
export default () => (
  // @sudarsana added ReactFlowProvider tag for proximity connection
  <ReactFlowProvider>
    <Flow />
  </ReactFlowProvider>
);
export { onSave_saveButton, autoRemoveFiles };
